/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 69);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var keys = __webpack_require__(24);
var hasSymbols = typeof Symbol === 'function' && _typeof(Symbol('foo')) === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function isFunction(fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function arePropertyDescriptorsSupported() {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) {
			// jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) {
		/* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function defineProperty(object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function defineProperties(object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(37);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sections":"nrk-sections","section":"nrk-section","sectionAfterStandup":"nrk-sectionAfterStandup","sectionBeforeStandup":"nrk-sectionBeforeStandup","standup":"nrk-standup","introBlock":"nrk-introBlock","headingBlock":"nrk-headingBlock","block":"nrk-block","block__right":"nrk-block__right","block__left":"nrk-block__left","block__spaceAfter":"nrk-block__spaceAfter","block__lessPadding":"nrk-block__lessPadding","block__map":"nrk-block__map","block__mapHeadingBlock":"nrk-block__mapHeadingBlock","block__mapNoMarginBottom":"nrk-block__mapNoMarginBottom","block__noMarginBottom":"nrk-block__noMarginBottom","block__lastBlock":"nrk-block__lastBlock","super":"nrk-super","super__content":"nrk-super__content","blurred":"nrk-blurred","overlay":"nrk-overlay","darkedout":"nrk-darkedout","NRKlogo":"nrk-NRKlogo","shareButtonGroup":"nrk-shareButtonGroup","visible":"nrk-visible","shareButton":"nrk-shareButton","to-top":"nrk-to-top","introBlockArrow":"nrk-introBlockArrow","fadeIn":"nrk-fadeIn","arrowBlink":"nrk-arrowBlink"};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(7);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"video":"nrk-video","darkedout":"nrk-darkedout","fullscreen--video":"nrk-fullscreen--video","fullscreen--video--container":"nrk-fullscreen--video--container","video-mute-button":"nrk-video-mute-button","video-mute-svg-muted-hover":"nrk-video-mute-svg-muted-hover","video-mute-svg-unmuted-hover":"nrk-video-mute-svg-unmuted-hover","visible":"nrk-visible","subtitlescontainer":"nrk-subtitlescontainer","subtitles":"nrk-subtitles"};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (global, factory) {
  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.nrkSerumImagecropUtils = {});
})(undefined, function (exports) {
  'use strict';

  var isPolopolyIdRegex = /^[1-9]{1,2}\.\d+$/;

  function isPolopolyId(id) {
    if (!id) {
      return false;
    }
    return isPolopolyIdRegex.test(id);
  }

  // prettier-ignore
  var widths = [100, 120, 150, 174, 200, 206, 225, 244, 250, 252, 300, 320, 350, 400, 450, 452, 460, 462, 500, 600, 650, 665, 682, 700, 734, 768, 900, 974, 1200, 1280, 1360, 1450, 1550, 1600, 1700, 1800, 1920, 2000, 2100, 2200, 2300, 2400];

  // prettier-ignore
  var ratios = ['1:1', '11', '16:9', '169', '16:3', '163', '3:4', '34'];

  // prettier-ignore
  var qualities = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0];

  var _baseUrl = 'https://nrk.no/serum/api/imagecrop/';

  function createUrl(_ref) {
    var id = _ref.id,
        ratio = _ref.ratio,
        width = _ref.width,
        quality = _ref.quality;

    var url = '' + _baseUrl + id;
    var queryString = createQueryString({ ratio: ratio, width: width, quality: quality });
    if (queryString) {
      url += '?' + queryString;
    }
    return url;
  }

  function createQueryString(_ref2) {
    var ratio = _ref2.ratio,
        width = _ref2.width,
        quality = _ref2.quality;

    if (!ratio && !width) {
      return quality ? 'quality=' + quality : '';
    }
    var ratioPart = ratio ? 'f' + ratio.replace(':', '') : '';
    var widthPart = width ? 'w' + width : '';
    var qualityPart = quality ? '&quality=' + quality : '';
    return 'cropid=' + ratioPart + widthPart + qualityPart;
  }

  function getClosestNumber(goal, targets) {
    if (!isValidGoal(goal)) {
      throw new Error('\n      getClosestNumber(goal, targets): passing a goal of ' + goal + '\n      is not supported. Pass a number');
    }
    if (!isValidTargets(targets)) {
      throw new Error('\n      getClosestNumber(goal, targets): targets ' + targets.toString() + ' is invald.\n      Pass an array of numbers');
    }
    if (!targets.length) {
      // eslint-disable-next-line no-undefined
      return undefined;
    }
    return targets.reduce(function (prev, curr) {
      return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev;
    });
  }

  function isValidGoal(goal) {
    return typeof goal === 'number';
  }

  function isValidTargets(targets) {
    if (!targets) {
      return false;
    }
    var isValid = true;
    for (var i = 0; i < targets.length; i++) {
      if (typeof targets[i] !== 'number') {
        isValid = false;
        break;
      }
    }
    // return targets.some((target) => {
    //   return (typeof target !== 'number')
    // })
    return isValid;
  }

  function isValidRatio(ratio, supportedRatios) {
    if (!Array.isArray(supportedRatios)) {
      // eslint-disable-next-line no-useless-escape
      throw new Error("isValidRatio(ratio, supportedRatios): supportedRatios '" + supportedRatios + "' is not supported. Pass an array of supported ratios");
    }
    if (!ratio) {
      return false;
    }
    return supportedRatios.includes(ratio);
  }

  function isValidQuality(quality, supportedQualities) {
    if (!Array.isArray(supportedQualities)) {
      // eslint-disable-next-line no-useless-escape
      throw new Error("isValidQuality(quality, supportedQualities): supportedQualities '" + supportedQualities + "' is not supported. Pass an array of supported qualities");
    }
    if (!quality) {
      return false;
    }
    return supportedQualities.includes(quality);
  }

  function createImageUrl(options) {
    var polopolyId = options.id,
        width = options.width,
        ratio = options.ratio,
        quality = options.quality;

    if (!isPolopolyId(polopolyId)) {
      throw new Error('createSerumImageUrl(): invalid polopolyId. Got ' + polopolyId);
    }

    var args = {
      id: polopolyId,
      ratio: null,
      quality: 0.8,
      width: 0

      // If a ratio is provided, ensure that it is valid
    };if (hasOption(ratio)) {
      if (!isValidRatio(ratio, ratios)) {
        throw new Error('\n      createSerumImageUrl(): ratio ' + ratio + ' is not supported.\n      Supported ratios are ' + ratios.toString());
      }
      args.ratio = ratio;
    }

    // If a quality is provided, ensure that it is valid
    if (hasOption(quality)) {
      if (!isValidQuality(quality, qualities)) {
        throw new Error('\n      createSerumImageUrl(): quality ' + quality + ' is not supported.\n      Supported qualities are ' + qualities.toString());
      }
      args.quality = quality;
    }

    // If a width is provided, ensure that is is a positive integer
    if (hasOption(width)) {
      if (!isNumber(width) || width <= 0) {
        var errorMessage = 'createSerumImageUrl(): width must be a positive integer, got ' + width;
        throw new Error(errorMessage);
      }
      var isSupportedWidth = widths.includes(width);
      var closestWidth = getClosestNumber(width, widths);
      if (typeof closestWidth !== 'undefined' && closestWidth) {
        args.width = isSupportedWidth ? width : closestWidth;
      }
    }

    return createUrl(args);
  }

  function hasOption(option) {
    return typeof option !== 'undefined' && option;
  }

  function isNumber(number) {
    return Number.isInteger(number);
  }

  exports.createImageUrl = createImageUrl;
  exports.ratios = ratios;
  exports.widths = widths;
  exports.qualities = qualities;
  exports.isPolopolyId = isPolopolyId;

  Object.defineProperty(exports, '__esModule', { value: true });
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals
	Set,
	Map,
	WeakSet,
	WeakMap,

	Promise,

	Symbol,
	Proxy,

	Atomics,
	SharedArrayBuffer,

	ArrayBuffer,
	DataView,
	Uint8Array,
	Float32Array,
	Float64Array,
	Int8Array,
	Int16Array,
	Int32Array,
	Uint8ClampedArray,
	Uint16Array,
	Uint32Array,
*/

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var undefined; // eslint-disable-line no-shadow-restricted-names

var ThrowTypeError = Object.getOwnPropertyDescriptor ? function () {
	return Object.getOwnPropertyDescriptor(arguments, 'callee').get;
}() : function () {
	throw new TypeError();
};

var hasSymbols = typeof Symbol === 'function' && _typeof(Symbol.iterator) === 'symbol';

var getProto = Object.getPrototypeOf || function (x) {
	return x.__proto__;
}; // eslint-disable-line no-proto

var generator; // = function * () {};
var generatorFunction = generator ? getProto(generator) : undefined;
var asyncFn; // async function() {};
var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
var asyncGen; // async function * () {};
var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
var asyncGenIterator = asyncGen ? asyncGen() : undefined;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'$ %Array%': Array,
	'$ %ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'$ %ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
	'$ %ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'$ %ArrayPrototype%': Array.prototype,
	'$ %ArrayProto_entries%': Array.prototype.entries,
	'$ %ArrayProto_forEach%': Array.prototype.forEach,
	'$ %ArrayProto_keys%': Array.prototype.keys,
	'$ %ArrayProto_values%': Array.prototype.values,
	'$ %AsyncFromSyncIteratorPrototype%': undefined,
	'$ %AsyncFunction%': asyncFunction,
	'$ %AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
	'$ %AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
	'$ %AsyncGeneratorFunction%': asyncGenFunction,
	'$ %AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
	'$ %AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
	'$ %Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'$ %Boolean%': Boolean,
	'$ %BooleanPrototype%': Boolean.prototype,
	'$ %DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'$ %DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
	'$ %Date%': Date,
	'$ %DatePrototype%': Date.prototype,
	'$ %decodeURI%': decodeURI,
	'$ %decodeURIComponent%': decodeURIComponent,
	'$ %encodeURI%': encodeURI,
	'$ %encodeURIComponent%': encodeURIComponent,
	'$ %Error%': Error,
	'$ %ErrorPrototype%': Error.prototype,
	'$ %eval%': eval, // eslint-disable-line no-eval
	'$ %EvalError%': EvalError,
	'$ %EvalErrorPrototype%': EvalError.prototype,
	'$ %Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'$ %Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
	'$ %Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'$ %Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
	'$ %Function%': Function,
	'$ %FunctionPrototype%': Function.prototype,
	'$ %Generator%': generator ? getProto(generator()) : undefined,
	'$ %GeneratorFunction%': generatorFunction,
	'$ %GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
	'$ %Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'$ %Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
	'$ %Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'$ %Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
	'$ %Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'$ %Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
	'$ %isFinite%': isFinite,
	'$ %isNaN%': isNaN,
	'$ %IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'$ %JSON%': JSON,
	'$ %JSONParse%': JSON.parse,
	'$ %Map%': typeof Map === 'undefined' ? undefined : Map,
	'$ %MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'$ %MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
	'$ %Math%': Math,
	'$ %Number%': Number,
	'$ %NumberPrototype%': Number.prototype,
	'$ %Object%': Object,
	'$ %ObjectPrototype%': Object.prototype,
	'$ %ObjProto_toString%': Object.prototype.toString,
	'$ %ObjProto_valueOf%': Object.prototype.valueOf,
	'$ %parseFloat%': parseFloat,
	'$ %parseInt%': parseInt,
	'$ %Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'$ %PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
	'$ %PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
	'$ %Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
	'$ %Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
	'$ %Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
	'$ %Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'$ %RangeError%': RangeError,
	'$ %RangeErrorPrototype%': RangeError.prototype,
	'$ %ReferenceError%': ReferenceError,
	'$ %ReferenceErrorPrototype%': ReferenceError.prototype,
	'$ %Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'$ %RegExp%': RegExp,
	'$ %RegExpPrototype%': RegExp.prototype,
	'$ %Set%': typeof Set === 'undefined' ? undefined : Set,
	'$ %SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'$ %SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
	'$ %SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'$ %SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
	'$ %String%': String,
	'$ %StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'$ %StringPrototype%': String.prototype,
	'$ %Symbol%': hasSymbols ? Symbol : undefined,
	'$ %SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
	'$ %SyntaxError%': SyntaxError,
	'$ %SyntaxErrorPrototype%': SyntaxError.prototype,
	'$ %ThrowTypeError%': ThrowTypeError,
	'$ %TypedArray%': TypedArray,
	'$ %TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
	'$ %TypeError%': TypeError,
	'$ %TypeErrorPrototype%': TypeError.prototype,
	'$ %Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'$ %Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
	'$ %Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'$ %Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
	'$ %Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'$ %Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
	'$ %Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'$ %Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
	'$ %URIError%': URIError,
	'$ %URIErrorPrototype%': URIError.prototype,
	'$ %WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'$ %WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
	'$ %WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	'$ %WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var key = '$ ' + name;
	if (!(key in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[key] === 'undefined' && !allowMissing) {
		throw new TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}
	return INTRINSICS[key];
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(45);

module.exports = Function.prototype.bind || implementation;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) {
			return false;
		}
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && _typeof(Symbol.toStringTag) === 'symbol';

module.exports = function isCallable(value) {
	if (!value) {
		return false;
	}
	if (typeof value !== 'function' && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
		return false;
	}
	if (typeof value === 'function' && !value.prototype) {
		return true;
	}
	if (hasToStringTag) {
		return tryFunctionObject(value);
	}
	if (isES6ClassFn(value)) {
		return false;
	}
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.polopolyIdHandler = undefined;
exports.createSrcSet = createSrcSet;

var _serumImagecropUtils = __webpack_require__(5);

var _alignmentClasses = __webpack_require__(26);

function createSrcSet(imageId, ratio, supportedWidths) {
  return supportedWidths.map(function (width) {
    var imageUrl = (0, _serumImagecropUtils.createImageUrl)({ id: imageId, width: width, ratio: ratio });
    return imageUrl + ' ' + width + 'w';
  }).join(', ');
}

var polopolyIdHandler = exports.polopolyIdHandler = {
  property: 'data-background-polopoly-id',
  load: function load(card) {
    var polopolyId = card.getAttribute('data-background-polopoly-id');

    var elem = document.createElement('div');
    var defaultUrl = (0, _serumImagecropUtils.createImageUrl)({ id: polopolyId, width: 1600, ratio: '1:1' });
    var desktopSourceSet = createSrcSet(polopolyId, '1:1', _serumImagecropUtils.widths);
    var mobileSourceSet = createSrcSet(polopolyId, '3:4', _serumImagecropUtils.widths);

    var imgStyle = card.getAttribute('data-align-top') ? "min-width: 100%; min-height: 100%; position: relative; left: 50%; transform: translate3d(-50%, 0%, 0); top: 0%;" : "min-width: 100%; min-height: 100%; position: relative; left: 50%; transform: translate3d(-50%, -50%, 0); top: 50%;";

    elem.innerHTML = '\n      <picture style="object-fit: cover;">\n      <source media="(min-aspect-ratio: 3/4)" srcset="' + desktopSourceSet + '">\n      <img src="' + defaultUrl + '" srcset="' + mobileSourceSet + '" style="' + imgStyle + '">\n      </picture>\n    ';
    elem.id = card.getAttribute('data-background-id');

    return elem;
  }
};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"backgrounds":"nrk-backgrounds","background":"nrk-background","visible":"nrk-visible","superoverlay":"nrk-superoverlay","backgroundGradient":"nrk-backgroundGradient"};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var ES = __webpack_require__(1);
var $isNaN = Number.isNaN || function isNaN(a) {
	return a !== a;
};
var $isFinite = Number.isFinite || function isFinite(n) {
	return typeof n === 'number' && global.isFinite(n);
};
var indexOf = Array.prototype.indexOf;

module.exports = function includes(searchElement) {
	var fromIndex = arguments.length > 1 ? ES.ToInteger(arguments[1]) : 0;
	if (indexOf && !$isNaN(searchElement) && $isFinite(fromIndex) && typeof searchElement !== 'undefined') {
		return indexOf.apply(this, arguments) > -1;
	}

	var O = ES.ToObject(this);
	var length = ES.ToLength(O.length);
	if (length === 0) {
		return false;
	}
	var k = fromIndex >= 0 ? fromIndex : Math.max(0, length + fromIndex);
	while (k < length) {
		if (ES.SameValueZero(searchElement, O[k])) {
			return true;
		}
		k += 1;
	}
	return false;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(12);

module.exports = function getPolyfill() {
	return Array.prototype.includes || implementation;
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES = __webpack_require__(1);
var supportsDescriptors = __webpack_require__(0).supportsDescriptors;

/*! https://mths.be/array-from v0.2.0 by @mathias */
module.exports = function from(arrayLike) {
	var defineProperty = supportsDescriptors ? Object.defineProperty : function put(object, key, descriptor) {
		object[key] = descriptor.value;
	};
	var C = this;
	if (arrayLike === null || typeof arrayLike === 'undefined') {
		throw new TypeError('`Array.from` requires an array-like object, not `null` or `undefined`');
	}
	var items = ES.ToObject(arrayLike);

	var mapFn, T;
	if (typeof arguments[1] !== 'undefined') {
		mapFn = arguments[1];
		if (!ES.IsCallable(mapFn)) {
			throw new TypeError('When provided, the second argument to `Array.from` must be a function');
		}
		if (arguments.length > 2) {
			T = arguments[2];
		}
	}

	var len = ES.ToLength(items.length);
	var A = ES.IsCallable(C) ? ES.ToObject(new C(len)) : new Array(len);
	var k = 0;
	var kValue, mappedValue;
	while (k < len) {
		kValue = items[k];
		if (mapFn) {
			mappedValue = typeof T === 'undefined' ? mapFn(kValue, k) : ES.Call(mapFn, T, [kValue, k]);
		} else {
			mappedValue = kValue;
		}
		defineProperty(A, k, {
			'configurable': true,
			'enumerable': true,
			'value': mappedValue,
			'writable': true
		});
		k += 1;
	}
	A.length = len;
	return A;
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES = __webpack_require__(1);
var implementation = __webpack_require__(14);

var tryCall = function tryCall(fn) {
	try {
		fn();
		return true;
	} catch (e) {
		return false;
	}
};

module.exports = function getPolyfill() {
	var implemented = ES.IsCallable(Array.from) && tryCall(function () {
		Array.from({ 'length': -Infinity });
	}) && !tryCall(function () {
		Array.from([], undefined);
	});

	return implemented ? Array.from : implementation;
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES = __webpack_require__(1);

module.exports = function find(predicate) {
	var list = ES.ToObject(this);
	var length = ES.ToInteger(ES.ToLength(list.length));
	if (!ES.IsCallable(predicate)) {
		throw new TypeError('Array#find: predicate must be a function');
	}
	if (length === 0) {
		return undefined;
	}
	var thisArg = arguments[1];
	for (var i = 0, value; i < length; i++) {
		value = list[i];
		if (ES.Call(predicate, thisArg, [value, i, list])) {
			return value;
		}
	}
	return undefined;
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function getPolyfill() {
	// Detect if an implementation exists
	// Detect early implementations which skipped holes in sparse arrays
	// eslint-disable-next-line no-sparse-arrays
	var implemented = Array.prototype.find && [, 1].find(function () {
		return true;
	}) !== 1;

	// eslint-disable-next-line global-require
	return implemented ? Array.prototype.find : __webpack_require__(16);
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(6);

var $TypeError = GetIntrinsic('%TypeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');

var has = __webpack_require__(3);

var predicates = {
  // https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
  'Property Descriptor': function isPropertyDescriptor(ES, Desc) {
    if (ES.Type(Desc) !== 'Object') {
      return false;
    }
    var allowed = {
      '[[Configurable]]': true,
      '[[Enumerable]]': true,
      '[[Get]]': true,
      '[[Set]]': true,
      '[[Value]]': true,
      '[[Writable]]': true
    };

    for (var key in Desc) {
      // eslint-disable-line
      if (has(Desc, key) && !allowed[key]) {
        return false;
      }
    }

    var isData = has(Desc, '[[Value]]');
    var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
    if (isData && IsAccessor) {
      throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
    }
    return true;
  }
};

module.exports = function assertRecord(ES, recordType, argumentName, value) {
  var predicate = predicates[recordType];
  if (typeof predicate !== 'function') {
    throw new $SyntaxError('unknown record type: ' + recordType);
  }
  if (!predicate(ES, value)) {
    throw new $TypeError(argumentName + ' must be a ' + recordType);
  }
  console.log(predicate(ES, value), value);
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = Number.isNaN || function (a) {
  return a !== a;
};

module.exports = Number.isFinite || function (x) {
  return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity;
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function isPrimitive(value) {
	return value === null || typeof value !== 'function' && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object';
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(25);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
	return origKeys(o);
} : __webpack_require__(52);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2);
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) {
				// eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' && value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPositionClasses = undefined;

var _index = __webpack_require__(66);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getClasses = function getClasses(param, prefix) {
  switch (param) {
    case 'top':
      return _index2.default[(prefix ? prefix + '-' : '') + 'align-top'];
    case 'bottom':
      return _index2.default[(prefix ? prefix + '-' : '') + 'align-bottom'];
    case 'middle':
      return _index2.default[(prefix ? prefix + '-' : '') + 'align-middle'];
    case 'left':
      return _index2.default[(prefix ? prefix + '-' : '') + 'align-left'];
    case 'right':
      return _index2.default[(prefix ? prefix + '-' : '') + 'align-right'];
    case 'center':
      return _index2.default[(prefix ? prefix + '-' : '') + 'align-center'];
    default:
      return '';
  }
};

var getPositionClasses = exports.getPositionClasses = function getPositionClasses() {
  var desktopString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'middle center';
  var mobileString = arguments[1];


  var desktopStringArray = desktopString.split(' ');
  var desktopXAxis = getClasses(desktopStringArray[0]);
  var desktopYAxis = getClasses(desktopStringArray[1]);

  var desktopClasses = desktopXAxis + ' ' + desktopYAxis;
  if (!mobileString) {
    return desktopClasses;
  }
  var mobileStringArray = mobileString.split(' ');
  var mobileXAxis = getClasses(mobileStringArray[0], 'mobile');
  var mobileYAxis = getClasses(mobileStringArray[1], 'mobile');
  var mobileClasses = mobileXAxis + ' ' + mobileYAxis;

  return desktopClasses + ' ' + mobileClasses;
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gaInitialize = gaInitialize;
exports.trackAction = trackAction;
var isTrackingEnabled = false;
// let label = null

function gaInitialize(trackingEnabled) {
  isTrackingEnabled = trackingEnabled;
  // label = name
}

function trackAction(action, label) {
  sendToGoogleAnalytics({
    category: 'dh-french-moland-kart',
    action: action,
    label: label
  });
}

function sendToGoogleAnalytics(_ref) {
  var category = _ref.category,
      action = _ref.action,
      label = _ref.label;

  if (window.ga && isTrackingEnabled) {
    window.ga('send', 'event', category, action, label);
  } else {
    if (typeof console !== 'undefined') {
      console.log(category, action, label);
    }
  }
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUnmutedButton = exports.getMutedButton = exports.getInitialMuteButton = undefined;

var _video = __webpack_require__(4);

var _video2 = _interopRequireDefault(_video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getInitialMuteButton = exports.getInitialMuteButton = function getInitialMuteButton() {
  return '\n  <button class="' + _video2.default['video-mute-button'] + '">\n    ' + getMutedButton() + '\n  </button>\n  ';
};

var getMutedButton = exports.getMutedButton = function getMutedButton() {
  return '\n    <svg class="' + _video2.default['video-mute-svg-muted'] + '" width="21" height="19" viewBox="0 0 21 19" xmlns="http://www.w3.org/2000/svg">\n      <g stroke="#FFF" fill="none" fill-rule="evenodd">\n        <path d="M11.1.55l-5.2 5.3h-.2l-4.4.34c-.45.03-.8.43-.8.9v4.8c0 .5.34.88.78.9l4.6.36.14.13 5.06 5.14c.17.14.42 0 .42-.25V.8c0-.24-.25-.37-.4-.25z"/>\n        <path d="M20 7l-5 5M15 7l5 5" stroke-linecap="round"/>\n      </g>\n    </svg>\n    <svg class="' + _video2.default['video-mute-svg-muted-hover'] + '" width="21" height="19" viewBox="0 0 21 19" xmlns="http://www.w3.org/2000/svg">\n      <g fill="none" fill-rule="evenodd">\n        <path d="M10.75.18l-5.1 5.18-4.4.33C.53 5.75 0 6.4 0 7.1v4.8c0 .74.53 1.36 1.25 1.4l4.4.34 5.1 5.18c.5.43 1.25.05 1.25-.63V.77c-.02-.64-.76-1.03-1.25-.6z" fill="#FFF" fill-rule="nonzero"/>\n        <path d="M20 7l-5 5M15 7l5 5" stroke="#FFF" stroke-linecap="round"/>\n      </g>\n    </svg>\n  ';
};

var getUnmutedButton = exports.getUnmutedButton = function getUnmutedButton() {
  return '\n    <svg class="' + _video2.default['video-mute-svg-unmuted'] + '" width="21" height="19" viewBox="0 0 21 19" xmlns="http://www.w3.org/2000/svg">\n      <g fill-rule="nonzero" fill="none">\n        <path d="M21 9.48c0-3.3-1.82-6.22-4.56-7.48l-.37.87c2.4 1.1 4.02 3.7 4.02 6.6 0 2.96-1.65 5.56-4.1 6.65l.36.88C19.14 15.76 21 12.8 21 9.48z" fill="#FFF"/>\n        <path d="M18 9.46C18 7.6 17.06 5.9 15.57 5l-.45.86c1.2.73 1.96 2.1 1.96 3.6 0 1.56-.8 2.96-2.08 3.66l.42.88C17 13.13 18 11.4 18 9.46z" fill="#FFF"/>\n        <path d="M11.1.55l-5.2 5.3h-.2l-4.4.34c-.45.03-.8.43-.8.9v4.8c0 .5.34.88.78.9l4.6.36.14.13 5.06 5.14c.17.14.42 0 .42-.25V.8c0-.24-.25-.37-.4-.25z" stroke="#FFF"/>\n      </g>\n    </svg>\n    <svg class="' + _video2.default['video-mute-svg-unmuted-hover'] + '" width="21" height="19" viewBox="0 0 21 19" xmlns="http://www.w3.org/2000/svg">\n    \n    <g fill-rule="nonzero" fill="#FFF">\n      <path d="M21 9.48c0-3.3-1.82-6.22-4.56-7.48l-.37.87c2.4 1.1 4.02 3.7 4.02 6.6 0 2.96-1.65 5.56-4.1 6.65l.36.88C19.14 15.76 21 12.8 21 9.48z"/>\n      <path d="M18 9.46C18 7.6 17.06 5.9 15.57 5l-.45.86c1.2.73 1.96 2.1 1.96 3.6 0 1.56-.8 2.96-2.08 3.66l.42.88C17 13.13 18 11.4 18 9.46zM10.75.18l-5.1 5.18-4.4.33C.53 5.75 0 6.4 0 7.1v4.8c0 .74.53 1.36 1.25 1.4l4.4.34 5.1 5.18c.5.43 1.25.05 1.25-.63V.77c-.02-.64-.76-1.03-1.25-.6z"/>\n    </g>\n  </svg>\n  ';
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

__webpack_require__(35).shim();
__webpack_require__(33).shim();
__webpack_require__(31).shim();

__webpack_require__(48);

// Object.assign() is commonly used.
// This polyfill use the native implementation if it's present and isn't buggy.
// Object.assign = require('object-assign')

if (typeof Promise === 'undefined') {
  __webpack_require__(44).polyfill();
}

Number.isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global __NAMESPACE__ */
/* eslint-disable max-params */

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _background = __webpack_require__(11);

var _video = __webpack_require__(4);

var _video2 = _interopRequireDefault(_video);

var _index3 = __webpack_require__(58);

var _intersection = __webpack_require__(54);

var _muteButtons = __webpack_require__(28);

var _googleAnalytics = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var App = function () {
  function App(params, container) {
    var _this = this;

    _classCallCheck(this, App);

    this.setSectionId = function (id) {
      _this.sectionId = id;
    };

    this.params = params;
    this.container = container;
    this.error = null;
    this.muted = true;
    this.videoElements = [];

    this.toggleMuteVideo = this.toggleMuteVideo.bind(this);

    this.gaInitialized = false;
    this.sectionId = 0;
  }

  _createClass(App, [{
    key: 'mount',
    value: function mount() {
      try {
        this.initializeGoogleAnalytic();
        this.render();
        this.mountListeners();
      } catch (error) {
        document.body.innerHTML = '' + JSON.stringify(error);
      }

      var videoes = [].concat(_toConsumableArray(document.querySelectorAll('video')));
      this.videoElements = videoes;
      videoes.forEach(function (v) {
        return v.pause();
      });

      var sectionEls = [].concat(_toConsumableArray(document.querySelectorAll('.' + _index2.default.section)));

      var shareButtons = document.querySelector('.' + _index2.default.shareButtonGroup);
      this.shareButtons = shareButtons;

      //initiallyVisible(sectionEls)
      (0, _intersection.observer)(sectionEls, this.videoElements, this.muteButton, this.shareButtons, this.setSectionId);
    }
  }, {
    key: 'initializeGoogleAnalytic',
    value: function initializeGoogleAnalytic() {
      if (!this.gaInitialized) {
        (0, _googleAnalytics.gaInitialize)(this.container.getAttribute('data-tracking'));
      }
      this.gaInitialized = true;
    }
  }, {
    key: 'unmount',
    value: function unmount() {
      this.unmountListeners();
      this.container.innerHTML = '';
    }
  }, {
    key: 'mountListeners',
    value: function mountListeners() {
      // Implement `addEventListener` here
      var muteButton = document.querySelector('.' + _video2.default["video-mute-button"]);
      this.muteButton = muteButton;

      this.muteButton.addEventListener('click', this.toggleMuteVideo, false);
    }
  }, {
    key: 'unmountListeners',
    value: function unmountListeners() {
      // Implement `removeEventListener` here
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.error) {
        this.renderError();
        return;
      }

      var backgroundContainer = document.querySelector('.' + _background.backgrounds);
      var overlayContainer = document.querySelector('.' + _background.superoverlay);
      var sectionElements = Array.prototype.slice.call(document.querySelectorAll('.' + _index2.default.section));

      (0, _index3.loadSections)(sectionElements, backgroundContainer, overlayContainer);
    }
  }, {
    key: 'updateSuperOffest',
    value: function updateSuperOffest() {
      var offset = 0;

      [].concat(_toConsumableArray(document.querySelectorAll('.' + _index2.default.super__content))).reverse().filter(function (content) {
        return content.style.display === 'block';
      }).forEach(function (content) {
        content.style.transform = 'translateY(-' + offset + 'px)';
        offset += content.offsetHeight;
      });
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      this.container.innerHTML = '<pre class="' + 'korrespondentbrev-syria-2017' + '-App--error">' + this.error.stack + '</pre>';
    }
  }, {
    key: 'toggleMuteVideo',
    value: function toggleMuteVideo(e) {
      e.stopPropagation();
      var parentElement = e.target.parentElement;
      var videoElement = parentElement.querySelector('video');

      if (this.muted) {
        this.videoElements.forEach(function (v) {
          return v.muted = false;
        });
        this.muteButton.innerHTML = (0, _muteButtons.getUnmutedButton)();
        this.muted = false;
        (0, _googleAnalytics.trackAction)('UNMUTE/' + this.sectionId);
        return;
      } else {
        this.videoElements.forEach(function (v) {
          return v.muted = true;
        });
        this.muteButton.innerHTML = (0, _muteButtons.getMutedButton)();
        this.muted = true;
        (0, _googleAnalytics.trackAction)('MUTE/' + this.sectionId);
        return;
      }
    }
  }]);

  return App;
}();

exports.default = App;


window.App = App;

//picturefill()

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(0);
var ES = __webpack_require__(1);

var implementation = __webpack_require__(12);
var getPolyfill = __webpack_require__(13);
var polyfill = getPolyfill();
var shim = __webpack_require__(32);

var slice = Array.prototype.slice;

/* eslint-disable no-unused-vars */
var boundIncludesShim = function includes(array, searchElement) {
	/* eslint-enable no-unused-vars */
	ES.RequireObjectCoercible(array);
	return polyfill.apply(array, slice.call(arguments, 1));
};
define(boundIncludesShim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundIncludesShim;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(0);
var getPolyfill = __webpack_require__(13);

module.exports = function shimArrayPrototypeIncludes() {
	var polyfill = getPolyfill();
	define(Array.prototype, { includes: polyfill }, { includes: function includes() {
			return Array.prototype.includes !== polyfill;
		} });
	return polyfill;
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(0);

var implementation = __webpack_require__(14);
var getPolyfill = __webpack_require__(15);
var shim = __webpack_require__(34);

// eslint-disable-next-line no-unused-vars
var boundFromShim = function from(array) {
	// eslint-disable-next-line no-invalid-this
	return implementation.apply(this || Array, arguments);
};

define(boundFromShim, {
	'getPolyfill': getPolyfill,
	'implementation': implementation,
	'shim': shim
});

module.exports = boundFromShim;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(0);
var getPolyfill = __webpack_require__(15);

module.exports = function shimArrayFrom() {
	var polyfill = getPolyfill();

	define(Array, { 'from': polyfill }, {
		'from': function from() {
			return Array.from !== polyfill;
		}
	});

	return polyfill;
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(0);
var ES = __webpack_require__(1);

var implementation = __webpack_require__(16);
var getPolyfill = __webpack_require__(17);
var shim = __webpack_require__(36);

var slice = Array.prototype.slice;

var polyfill = getPolyfill();

var boundFindShim = function find(array, predicate) {
	// eslint-disable-line no-unused-vars
	ES.RequireObjectCoercible(array);
	var args = slice.call(arguments, 1);
	return polyfill.apply(array, args);
};

define(boundFindShim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundFindShim;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(0);
var getPolyfill = __webpack_require__(17);

module.exports = function shimArrayPrototypeFind() {
	var polyfill = getPolyfill();

	define(Array.prototype, { find: polyfill }, {
		find: function find() {
			return Array.prototype.find !== polyfill;
		}
	});

	return polyfill;
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var has = __webpack_require__(3);
var toPrimitive = __webpack_require__(43);
var keys = __webpack_require__(24);

var GetIntrinsic = __webpack_require__(6);

var $TypeError = GetIntrinsic('%TypeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');
var $Array = GetIntrinsic('%Array%');
var $String = GetIntrinsic('%String%');
var $Object = GetIntrinsic('%Object%');
var $Number = GetIntrinsic('%Number%');
var $Symbol = GetIntrinsic('%Symbol%', true);
var $RegExp = GetIntrinsic('%RegExp%');

var hasSymbols = !!$Symbol;

var assertRecord = __webpack_require__(18);
var $isNaN = __webpack_require__(20);
var $isFinite = __webpack_require__(19);
var MAX_SAFE_INTEGER = $Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;

var assign = __webpack_require__(39);
var sign = __webpack_require__(22);
var mod = __webpack_require__(21);
var isPrimitive = __webpack_require__(40);
var parseInteger = parseInt;
var bind = __webpack_require__(7);
var arraySlice = bind.call(Function.call, $Array.prototype.slice);
var strSlice = bind.call(Function.call, $String.prototype.slice);
var isBinary = bind.call(Function.call, $RegExp.prototype.test, /^0b[01]+$/i);
var isOctal = bind.call(Function.call, $RegExp.prototype.test, /^0o[0-7]+$/i);
var regexExec = bind.call(Function.call, $RegExp.prototype.exec);
var nonWS = ['\x85', '\u200B', '\uFFFE'].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = bind.call(Function.call, $RegExp.prototype.test, nonWSregex);
var invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i;
var isInvalidHexLiteral = bind.call(Function.call, $RegExp.prototype.test, invalidHexLiteral);
var $charCodeAt = bind.call(Function.call, $String.prototype.charCodeAt);

var toStr = bind.call(Function.call, Object.prototype.toString);

var $NumberValueOf = bind.call(Function.call, GetIntrinsic('%NumberPrototype%').valueOf);
var $BooleanValueOf = bind.call(Function.call, GetIntrinsic('%BooleanPrototype%').valueOf);
var $StringValueOf = bind.call(Function.call, GetIntrinsic('%StringPrototype%').valueOf);
var $DateValueOf = bind.call(Function.call, GetIntrinsic('%DatePrototype%').valueOf);

var $floor = Math.floor;
var $abs = Math.abs;

var $ObjectCreate = Object.create;
var $gOPD = $Object.getOwnPropertyDescriptor;

var $isExtensible = $Object.isExtensible;

var $defineProperty = $Object.defineProperty;

// whitespace from: http://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = ['\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003', '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028', '\u2029\uFEFF'].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var replace = bind.call(Function.call, $String.prototype.replace);
var trim = function trim(value) {
	return replace(value, trimRegex, '');
};

var ES5 = __webpack_require__(38);

var hasRegExpMatcher = __webpack_require__(50);

// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
var ES6 = assign(assign({}, ES5), {

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
	Call: function Call(F, V) {
		var args = arguments.length > 2 ? arguments[2] : [];
		if (!this.IsCallable(F)) {
			throw new $TypeError(F + ' is not a function');
		}
		return F.apply(V, args);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
	ToPrimitive: toPrimitive,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
	// ToBoolean: ES5.ToBoolean,

	// https://ecma-international.org/ecma-262/6.0/#sec-tonumber
	ToNumber: function ToNumber(argument) {
		var value = isPrimitive(argument) ? argument : toPrimitive(argument, $Number);
		if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'symbol') {
			throw new $TypeError('Cannot convert a Symbol value to a number');
		}
		if (typeof value === 'string') {
			if (isBinary(value)) {
				return this.ToNumber(parseInteger(strSlice(value, 2), 2));
			} else if (isOctal(value)) {
				return this.ToNumber(parseInteger(strSlice(value, 2), 8));
			} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
				return NaN;
			} else {
				var trimmed = trim(value);
				if (trimmed !== value) {
					return this.ToNumber(trimmed);
				}
			}
		}
		return $Number(value);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
	// ToInteger: ES5.ToNumber,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
	// ToInt32: ES5.ToInt32,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
	// ToUint32: ES5.ToUint32,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
	ToInt16: function ToInt16(argument) {
		var int16bit = this.ToUint16(argument);
		return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
	// ToUint16: ES5.ToUint16,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
	ToInt8: function ToInt8(argument) {
		var int8bit = this.ToUint8(argument);
		return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
	ToUint8: function ToUint8(argument) {
		var number = this.ToNumber(argument);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) {
			return 0;
		}
		var posInt = sign(number) * $floor($abs(number));
		return mod(posInt, 0x100);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
	ToUint8Clamp: function ToUint8Clamp(argument) {
		var number = this.ToNumber(argument);
		if ($isNaN(number) || number <= 0) {
			return 0;
		}
		if (number >= 0xFF) {
			return 0xFF;
		}
		var f = $floor(argument);
		if (f + 0.5 < number) {
			return f + 1;
		}
		if (number < f + 0.5) {
			return f;
		}
		if (f % 2 !== 0) {
			return f + 1;
		}
		return f;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
	ToString: function ToString(argument) {
		if ((typeof argument === 'undefined' ? 'undefined' : _typeof(argument)) === 'symbol') {
			throw new $TypeError('Cannot convert a Symbol value to a string');
		}
		return $String(argument);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
	ToObject: function ToObject(value) {
		this.RequireObjectCoercible(value);
		return $Object(value);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
	ToPropertyKey: function ToPropertyKey(argument) {
		var key = this.ToPrimitive(argument, $String);
		return (typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'symbol' ? key : this.ToString(key);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	ToLength: function ToLength(argument) {
		var len = this.ToInteger(argument);
		if (len <= 0) {
			return 0;
		} // includes converting -0 to +0
		if (len > MAX_SAFE_INTEGER) {
			return MAX_SAFE_INTEGER;
		}
		return len;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
	CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
		if (toStr(argument) !== '[object String]') {
			throw new $TypeError('must be a string');
		}
		if (argument === '-0') {
			return -0;
		}
		var n = this.ToNumber(argument);
		if (this.SameValue(this.ToString(n), argument)) {
			return n;
		}
		return void 0;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
	RequireObjectCoercible: ES5.CheckObjectCoercible,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
	IsArray: $Array.isArray || function IsArray(argument) {
		return toStr(argument) === '[object Array]';
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
	// IsCallable: ES5.IsCallable,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
	IsConstructor: function IsConstructor(argument) {
		return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
	IsExtensible: Object.preventExtensions ? function IsExtensible(obj) {
		if (isPrimitive(obj)) {
			return false;
		}
		return $isExtensible(obj);
	} : function isExtensible(obj) {
		return true;
	}, // eslint-disable-line no-unused-vars

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
	IsInteger: function IsInteger(argument) {
		if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
			return false;
		}
		var abs = $abs(argument);
		return $floor(abs) === abs;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
	IsPropertyKey: function IsPropertyKey(argument) {
		return typeof argument === 'string' || (typeof argument === 'undefined' ? 'undefined' : _typeof(argument)) === 'symbol';
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-isregexp
	IsRegExp: function IsRegExp(argument) {
		if (!argument || (typeof argument === 'undefined' ? 'undefined' : _typeof(argument)) !== 'object') {
			return false;
		}
		if (hasSymbols) {
			var isRegExp = argument[$Symbol.match];
			if (typeof isRegExp !== 'undefined') {
				return ES5.ToBoolean(isRegExp);
			}
		}
		return hasRegExpMatcher(argument);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
	// SameValue: ES5.SameValue,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
	SameValueZero: function SameValueZero(x, y) {
		return x === y || $isNaN(x) && $isNaN(y);
	},

	/**
  * 7.3.2 GetV (V, P)
  * 1. Assert: IsPropertyKey(P) is true.
  * 2. Let O be ToObject(V).
  * 3. ReturnIfAbrupt(O).
  * 4. Return O.[[Get]](P, V).
  */
	GetV: function GetV(V, P) {
		// 7.3.2.1
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		// 7.3.2.2-3
		var O = this.ToObject(V);

		// 7.3.2.4
		return O[P];
	},

	/**
  * 7.3.9 - https://ecma-international.org/ecma-262/6.0/#sec-getmethod
  * 1. Assert: IsPropertyKey(P) is true.
  * 2. Let func be GetV(O, P).
  * 3. ReturnIfAbrupt(func).
  * 4. If func is either undefined or null, return undefined.
  * 5. If IsCallable(func) is false, throw a TypeError exception.
  * 6. Return func.
  */
	GetMethod: function GetMethod(O, P) {
		// 7.3.9.1
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		// 7.3.9.2
		var func = this.GetV(O, P);

		// 7.3.9.4
		if (func == null) {
			return void 0;
		}

		// 7.3.9.5
		if (!this.IsCallable(func)) {
			throw new $TypeError(P + 'is not a function');
		}

		// 7.3.9.6
		return func;
	},

	/**
  * 7.3.1 Get (O, P) - https://ecma-international.org/ecma-262/6.0/#sec-get-o-p
  * 1. Assert: Type(O) is Object.
  * 2. Assert: IsPropertyKey(P) is true.
  * 3. Return O.[[Get]](P, O).
  */
	Get: function Get(O, P) {
		// 7.3.1.1
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		// 7.3.1.2
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		// 7.3.1.3
		return O[P];
	},

	Type: function Type(x) {
		if ((typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'symbol') {
			return 'Symbol';
		}
		return ES5.Type(x);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
	SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		var C = O.constructor;
		if (typeof C === 'undefined') {
			return defaultConstructor;
		}
		if (this.Type(C) !== 'Object') {
			throw new $TypeError('O.constructor is not an Object');
		}
		var S = hasSymbols && $Symbol.species ? C[$Symbol.species] : void 0;
		if (S == null) {
			return defaultConstructor;
		}
		if (this.IsConstructor(S)) {
			return S;
		}
		throw new $TypeError('no constructor found');
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-completepropertydescriptor
	CompletePropertyDescriptor: function CompletePropertyDescriptor(Desc) {
		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (this.IsGenericDescriptor(Desc) || this.IsDataDescriptor(Desc)) {
			if (!has(Desc, '[[Value]]')) {
				Desc['[[Value]]'] = void 0;
			}
			if (!has(Desc, '[[Writable]]')) {
				Desc['[[Writable]]'] = false;
			}
		} else {
			if (!has(Desc, '[[Get]]')) {
				Desc['[[Get]]'] = void 0;
			}
			if (!has(Desc, '[[Set]]')) {
				Desc['[[Set]]'] = void 0;
			}
		}
		if (!has(Desc, '[[Enumerable]]')) {
			Desc['[[Enumerable]]'] = false;
		}
		if (!has(Desc, '[[Configurable]]')) {
			Desc['[[Configurable]]'] = false;
		}
		return Desc;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-set-o-p-v-throw
	Set: function Set(O, P, V, Throw) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('P must be a Property Key');
		}
		if (this.Type(Throw) !== 'Boolean') {
			throw new $TypeError('Throw must be a Boolean');
		}
		if (Throw) {
			O[P] = V;
			return true;
		} else {
			try {
				O[P] = V;
			} catch (e) {
				return false;
			}
		}
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-hasownproperty
	HasOwnProperty: function HasOwnProperty(O, P) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('P must be a Property Key');
		}
		return has(O, P);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty
	HasProperty: function HasProperty(O, P) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('P must be a Property Key');
		}
		return P in O;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-isconcatspreadable
	IsConcatSpreadable: function IsConcatSpreadable(O) {
		if (this.Type(O) !== 'Object') {
			return false;
		}
		if (hasSymbols && _typeof($Symbol.isConcatSpreadable) === 'symbol') {
			var spreadable = this.Get(O, Symbol.isConcatSpreadable);
			if (typeof spreadable !== 'undefined') {
				return this.ToBoolean(spreadable);
			}
		}
		return this.IsArray(O);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-invoke
	Invoke: function Invoke(O, P) {
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('P must be a Property Key');
		}
		var argumentsList = arraySlice(arguments, 2);
		var func = this.GetV(O, P);
		return this.Call(func, O, argumentsList);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-getiterator
	GetIterator: function GetIterator(obj, method) {
		if (!hasSymbols) {
			throw new SyntaxError('ES.GetIterator depends on native iterator support.');
		}

		var actualMethod = method;
		if (arguments.length < 2) {
			actualMethod = this.GetMethod(obj, $Symbol.iterator);
		}
		var iterator = this.Call(actualMethod, obj);
		if (this.Type(iterator) !== 'Object') {
			throw new $TypeError('iterator must return an object');
		}

		return iterator;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-iteratornext
	IteratorNext: function IteratorNext(iterator, value) {
		var result = this.Invoke(iterator, 'next', arguments.length < 2 ? [] : [value]);
		if (this.Type(result) !== 'Object') {
			throw new $TypeError('iterator next must return an object');
		}
		return result;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-iteratorcomplete
	IteratorComplete: function IteratorComplete(iterResult) {
		if (this.Type(iterResult) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
		}
		return this.ToBoolean(this.Get(iterResult, 'done'));
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-iteratorvalue
	IteratorValue: function IteratorValue(iterResult) {
		if (this.Type(iterResult) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
		}
		return this.Get(iterResult, 'value');
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-iteratorstep
	IteratorStep: function IteratorStep(iterator) {
		var result = this.IteratorNext(iterator);
		var done = this.IteratorComplete(result);
		return done === true ? false : result;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-iteratorclose
	IteratorClose: function IteratorClose(iterator, completion) {
		if (this.Type(iterator) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(iterator) is not Object');
		}
		if (!this.IsCallable(completion)) {
			throw new $TypeError('Assertion failed: completion is not a thunk for a Completion Record');
		}
		var completionThunk = completion;

		var iteratorReturn = this.GetMethod(iterator, 'return');

		if (typeof iteratorReturn === 'undefined') {
			return completionThunk();
		}

		var completionRecord;
		try {
			var innerResult = this.Call(iteratorReturn, iterator, []);
		} catch (e) {
			// if we hit here, then "e" is the innerResult completion that needs re-throwing

			// if the completion is of type "throw", this will throw.
			completionRecord = completionThunk();
			completionThunk = null; // ensure it's not called twice.

			// if not, then return the innerResult completion
			throw e;
		}
		completionRecord = completionThunk(); // if innerResult worked, then throw if the completion does
		completionThunk = null; // ensure it's not called twice.

		if (this.Type(innerResult) !== 'Object') {
			throw new $TypeError('iterator .return must return an object');
		}

		return completionRecord;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-createiterresultobject
	CreateIterResultObject: function CreateIterResultObject(value, done) {
		if (this.Type(done) !== 'Boolean') {
			throw new $TypeError('Assertion failed: Type(done) is not Boolean');
		}
		return {
			value: value,
			done: done
		};
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-regexpexec
	RegExpExec: function RegExpExec(R, S) {
		if (this.Type(R) !== 'Object') {
			throw new $TypeError('R must be an Object');
		}
		if (this.Type(S) !== 'String') {
			throw new $TypeError('S must be a String');
		}
		var exec = this.Get(R, 'exec');
		if (this.IsCallable(exec)) {
			var result = this.Call(exec, R, [S]);
			if (result === null || this.Type(result) === 'Object') {
				return result;
			}
			throw new $TypeError('"exec" method must return `null` or an Object');
		}
		return regexExec(R, S);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate
	ArraySpeciesCreate: function ArraySpeciesCreate(originalArray, length) {
		if (!this.IsInteger(length) || length < 0) {
			throw new $TypeError('Assertion failed: length must be an integer >= 0');
		}
		var len = length === 0 ? 0 : length;
		var C;
		var isArray = this.IsArray(originalArray);
		if (isArray) {
			C = this.Get(originalArray, 'constructor');
			// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
			// if (this.IsConstructor(C)) {
			// 	if C is another realm's Array, C = undefined
			// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
			// }
			if (this.Type(C) === 'Object' && hasSymbols && $Symbol.species) {
				C = this.Get(C, $Symbol.species);
				if (C === null) {
					C = void 0;
				}
			}
		}
		if (typeof C === 'undefined') {
			return $Array(len);
		}
		if (!this.IsConstructor(C)) {
			throw new $TypeError('C must be a constructor');
		}
		return new C(len); // this.Construct(C, len);
	},

	CreateDataProperty: function CreateDataProperty(O, P, V) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		var oldDesc = $gOPD(O, P);
		var extensible = oldDesc || typeof $isExtensible !== 'function' || $isExtensible(O);
		var immutable = oldDesc && (!oldDesc.writable || !oldDesc.configurable);
		if (immutable || !extensible) {
			return false;
		}
		var newDesc = {
			configurable: true,
			enumerable: true,
			value: V,
			writable: true
		};
		$defineProperty(O, P, newDesc);
		return true;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow
	CreateDataPropertyOrThrow: function CreateDataPropertyOrThrow(O, P, V) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		var success = this.CreateDataProperty(O, P, V);
		if (!success) {
			throw new $TypeError('unable to create data property');
		}
		return success;
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-objectcreate
	ObjectCreate: function ObjectCreate(proto, internalSlotsList) {
		if (proto !== null && this.Type(proto) !== 'Object') {
			throw new $TypeError('Assertion failed: proto must be null or an object');
		}
		var slots = arguments.length < 2 ? [] : internalSlotsList;
		if (slots.length > 0) {
			throw new $SyntaxError('es-abstract does not yet support internal slots');
		}

		if (proto === null && !$ObjectCreate) {
			throw new $SyntaxError('native Object.create support is required to create null objects');
		}

		return $ObjectCreate(proto);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-advancestringindex
	AdvanceStringIndex: function AdvanceStringIndex(S, index, unicode) {
		if (this.Type(S) !== 'String') {
			throw new $TypeError('S must be a String');
		}
		if (!this.IsInteger(index) || index < 0 || index > MAX_SAFE_INTEGER) {
			throw new $TypeError('Assertion failed: length must be an integer >= 0 and <= 2**53');
		}
		if (this.Type(unicode) !== 'Boolean') {
			throw new $TypeError('Assertion failed: unicode must be a Boolean');
		}
		if (!unicode) {
			return index + 1;
		}
		var length = S.length;
		if (index + 1 >= length) {
			return index + 1;
		}

		var first = $charCodeAt(S, index);
		if (first < 0xD800 || first > 0xDBFF) {
			return index + 1;
		}

		var second = $charCodeAt(S, index + 1);
		if (second < 0xDC00 || second > 0xDFFF) {
			return index + 1;
		}

		return index + 2;
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-createmethodproperty
	CreateMethodProperty: function CreateMethodProperty(O, P, V) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}

		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		var newDesc = {
			configurable: true,
			enumerable: false,
			value: V,
			writable: true
		};
		return !!$defineProperty(O, P, newDesc);
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow
	DefinePropertyOrThrow: function DefinePropertyOrThrow(O, P, desc) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}

		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		return !!$defineProperty(O, P, desc);
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-deletepropertyorthrow
	DeletePropertyOrThrow: function DeletePropertyOrThrow(O, P) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}

		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		var success = delete O[P];
		if (!success) {
			throw new TypeError('Attempt to delete property failed.');
		}
		return success;
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-enumerableownnames
	EnumerableOwnNames: function EnumerableOwnNames(O) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}

		return keys(O);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-number-prototype-object
	thisNumberValue: function thisNumberValue(value) {
		if (this.Type(value) === 'Number') {
			return value;
		}

		return $NumberValueOf(value);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-boolean-prototype-object
	thisBooleanValue: function thisBooleanValue(value) {
		if (this.Type(value) === 'Boolean') {
			return value;
		}

		return $BooleanValueOf(value);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-string-prototype-object
	thisStringValue: function thisStringValue(value) {
		if (this.Type(value) === 'String') {
			return value;
		}

		return $StringValueOf(value);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-date-prototype-object
	thisTimeValue: function thisTimeValue(value) {
		return $DateValueOf(value);
	}
});

delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible

module.exports = ES6;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var GetIntrinsic = __webpack_require__(6);

var $Object = GetIntrinsic('%Object%');
var $TypeError = GetIntrinsic('%TypeError%');
var $String = GetIntrinsic('%String%');

var assertRecord = __webpack_require__(18);
var $isNaN = __webpack_require__(20);
var $isFinite = __webpack_require__(19);

var sign = __webpack_require__(22);
var mod = __webpack_require__(21);

var IsCallable = __webpack_require__(8);
var toPrimitive = __webpack_require__(42);

var has = __webpack_require__(3);

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return !!value;
	},
	ToNumber: function ToNumber(value) {
		return +value; // eslint-disable-line no-implicit-coercion
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) {
			return 0;
		}
		if (number === 0 || !$isFinite(number)) {
			return number;
		}
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) {
			return 0;
		}
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return $String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return $Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new $TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) {
			// 0 === -0, but they are not identical.
			if (x === 0) {
				return 1 / x === 1 / y;
			}
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// https://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
		if (this.Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};

		for (var key in Desc) {
			// eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}

		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.1
	IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
			return false;
		}

		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.2
	IsDataDescriptor: function IsDataDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
			return false;
		}

		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.3
	IsGenericDescriptor: function IsGenericDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
			return true;
		}

		return false;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.4
	FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return Desc;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (this.IsDataDescriptor(Desc)) {
			return {
				value: Desc['[[Value]]'],
				writable: !!Desc['[[Writable]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else if (this.IsAccessorDescriptor(Desc)) {
			return {
				get: Desc['[[Get]]'],
				set: Desc['[[Set]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else {
			throw new $TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
		}
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.5
	ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
		if (this.Type(Obj) !== 'Object') {
			throw new $TypeError('ToPropertyDescriptor requires an object');
		}

		var desc = {};
		if (has(Obj, 'enumerable')) {
			desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
		}
		if (has(Obj, 'configurable')) {
			desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
		}
		if (has(Obj, 'value')) {
			desc['[[Value]]'] = Obj.value;
		}
		if (has(Obj, 'writable')) {
			desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
		}
		if (has(Obj, 'get')) {
			var getter = Obj.get;
			if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
				throw new TypeError('getter must be a function');
			}
			desc['[[Get]]'] = getter;
		}
		if (has(Obj, 'set')) {
			var setter = Obj.set;
			if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
				throw new $TypeError('setter must be a function');
			}
			desc['[[Set]]'] = setter;
		}

		if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
			throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
		}
		return desc;
	}
};

module.exports = ES5;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(7);
var has = bind.call(Function.call, Object.prototype.hasOwnProperty);

var $assign = Object.assign;

module.exports = function assign(target, source) {
	if ($assign) {
		return $assign(target, source);
	}

	for (var key in source) {
		if (has(source, key)) {
			target[key] = source[key];
		}
	}
	return target;
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function isPrimitive(value) {
	return value === null || typeof value !== 'function' && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object';
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var hasSymbols = typeof Symbol === 'function' && _typeof(Symbol.iterator) === 'symbol';

var isPrimitive = __webpack_require__(23);
var isCallable = __webpack_require__(8);
var isDate = __webpack_require__(49);
var isSymbol = __webpack_require__(51);

var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || hint !== 'number' && hint !== 'string') {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
	return void 0;
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
module.exports = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (arguments[1] === String) {
			hint = 'string';
		} else if (arguments[1] === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDate(input) || isSymbol(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__(23);

var isCallable = __webpack_require__(8);

// http://ecma-international.org/ecma-262/5.1/#sec-8.12.8
var ES5internalSlots = {
	'[[DefaultValue]]': function DefaultValue(O) {
		var actualHint;
		if (arguments.length > 1) {
			actualHint = arguments[1];
		} else {
			actualHint = toStr.call(O) === '[object Date]' ? String : Number;
		}

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// http://ecma-international.org/ecma-262/5.1/#sec-9.1
module.exports = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	if (arguments.length > 1) {
		return ES5internalSlots['[[DefaultValue]]'](input, arguments[1]);
	}
	return ES5internalSlots['[[DefaultValue]]'](input);
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(41);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.6+9869a4bc
 */

(function (global, factory) {
  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.ES6Promise = factory();
})(undefined, function () {
  'use strict';

  function objectOrFunction(x) {
    var type = typeof x === 'undefined' ? 'undefined' : _typeof(x);
    return x !== null && (type === 'object' || type === 'function');
  }

  function isFunction(x) {
    return typeof x === 'function';
  }

  var _isArray = void 0;
  if (Array.isArray) {
    _isArray = Array.isArray;
  } else {
    _isArray = function _isArray(x) {
      return Object.prototype.toString.call(x) === '[object Array]';
    };
  }

  var isArray = _isArray;

  var len = 0;
  var vertxNext = void 0;
  var customSchedulerFn = void 0;

  var asap = function asap(callback, arg) {
    queue[len] = callback;
    queue[len + 1] = arg;
    len += 2;
    if (len === 2) {
      // If len is 2, that means that we need to schedule an async flush.
      // If additional callbacks are queued before the queue is flushed, they
      // will be processed by this flush that we are scheduling.
      if (customSchedulerFn) {
        customSchedulerFn(flush);
      } else {
        scheduleFlush();
      }
    }
  };

  function setScheduler(scheduleFn) {
    customSchedulerFn = scheduleFn;
  }

  function setAsap(asapFn) {
    asap = asapFn;
  }

  var browserWindow = typeof window !== 'undefined' ? window : undefined;
  var browserGlobal = browserWindow || {};
  var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
  var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

  // test for web worker but not in IE10
  var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

  // node
  function useNextTick() {
    // node version 0.10.x displays a deprecation warning when nextTick is used recursively
    // see https://github.com/cujojs/when/issues/410 for details
    return function () {
      return process.nextTick(flush);
    };
  }

  // vertx
  function useVertxTimer() {
    if (typeof vertxNext !== 'undefined') {
      return function () {
        vertxNext(flush);
      };
    }

    return useSetTimeout();
  }

  function useMutationObserver() {
    var iterations = 0;
    var observer = new BrowserMutationObserver(flush);
    var node = document.createTextNode('');
    observer.observe(node, { characterData: true });

    return function () {
      node.data = iterations = ++iterations % 2;
    };
  }

  // web worker
  function useMessageChannel() {
    var channel = new MessageChannel();
    channel.port1.onmessage = flush;
    return function () {
      return channel.port2.postMessage(0);
    };
  }

  function useSetTimeout() {
    // Store setTimeout reference so es6-promise will be unaffected by
    // other code modifying setTimeout (like sinon.useFakeTimers())
    var globalSetTimeout = setTimeout;
    return function () {
      return globalSetTimeout(flush, 1);
    };
  }

  var queue = new Array(1000);
  function flush() {
    for (var i = 0; i < len; i += 2) {
      var callback = queue[i];
      var arg = queue[i + 1];

      callback(arg);

      queue[i] = undefined;
      queue[i + 1] = undefined;
    }

    len = 0;
  }

  function attemptVertx() {
    try {
      var vertx = Function('return this')().require('vertx');
      vertxNext = vertx.runOnLoop || vertx.runOnContext;
      return useVertxTimer();
    } catch (e) {
      return useSetTimeout();
    }
  }

  var scheduleFlush = void 0;
  // Decide what async method to use to triggering processing of queued callbacks:
  if (isNode) {
    scheduleFlush = useNextTick();
  } else if (BrowserMutationObserver) {
    scheduleFlush = useMutationObserver();
  } else if (isWorker) {
    scheduleFlush = useMessageChannel();
  } else if (browserWindow === undefined && "function" === 'function') {
    scheduleFlush = attemptVertx();
  } else {
    scheduleFlush = useSetTimeout();
  }

  function then(onFulfillment, onRejection) {
    var parent = this;

    var child = new this.constructor(noop);

    if (child[PROMISE_ID] === undefined) {
      makePromise(child);
    }

    var _state = parent._state;

    if (_state) {
      var callback = arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    } else {
      subscribe(parent, child, onFulfillment, onRejection);
    }

    return child;
  }

  /**
    `Promise.resolve` returns a promise that will become resolved with the
    passed `value`. It is shorthand for the following:
  
    ```javascript
    let promise = new Promise(function(resolve, reject){
      resolve(1);
    });
  
    promise.then(function(value){
      // value === 1
    });
    ```
  
    Instead of writing the above, your code now simply becomes the following:
  
    ```javascript
    let promise = Promise.resolve(1);
  
    promise.then(function(value){
      // value === 1
    });
    ```
  
    @method resolve
    @static
    @param {Any} value value that the returned promise will be resolved with
    Useful for tooling.
    @return {Promise} a promise that will become fulfilled with the given
    `value`
  */
  function resolve$1(object) {
    /*jshint validthis:true */
    var Constructor = this;

    if (object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object.constructor === Constructor) {
      return object;
    }

    var promise = new Constructor(noop);
    resolve(promise, object);
    return promise;
  }

  var PROMISE_ID = Math.random().toString(36).substring(2);

  function noop() {}

  var PENDING = void 0;
  var FULFILLED = 1;
  var REJECTED = 2;

  var TRY_CATCH_ERROR = { error: null };

  function selfFulfillment() {
    return new TypeError("You cannot resolve a promise with itself");
  }

  function cannotReturnOwn() {
    return new TypeError('A promises callback cannot return that same promise.');
  }

  function getThen(promise) {
    try {
      return promise.then;
    } catch (error) {
      TRY_CATCH_ERROR.error = error;
      return TRY_CATCH_ERROR;
    }
  }

  function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
    try {
      then$$1.call(value, fulfillmentHandler, rejectionHandler);
    } catch (e) {
      return e;
    }
  }

  function handleForeignThenable(promise, thenable, then$$1) {
    asap(function (promise) {
      var sealed = false;
      var error = tryThen(then$$1, thenable, function (value) {
        if (sealed) {
          return;
        }
        sealed = true;
        if (thenable !== value) {
          resolve(promise, value);
        } else {
          fulfill(promise, value);
        }
      }, function (reason) {
        if (sealed) {
          return;
        }
        sealed = true;

        reject(promise, reason);
      }, 'Settle: ' + (promise._label || ' unknown promise'));

      if (!sealed && error) {
        sealed = true;
        reject(promise, error);
      }
    }, promise);
  }

  function handleOwnThenable(promise, thenable) {
    if (thenable._state === FULFILLED) {
      fulfill(promise, thenable._result);
    } else if (thenable._state === REJECTED) {
      reject(promise, thenable._result);
    } else {
      subscribe(thenable, undefined, function (value) {
        return resolve(promise, value);
      }, function (reason) {
        return reject(promise, reason);
      });
    }
  }

  function handleMaybeThenable(promise, maybeThenable, then$$1) {
    if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
      handleOwnThenable(promise, maybeThenable);
    } else {
      if (then$$1 === TRY_CATCH_ERROR) {
        reject(promise, TRY_CATCH_ERROR.error);
        TRY_CATCH_ERROR.error = null;
      } else if (then$$1 === undefined) {
        fulfill(promise, maybeThenable);
      } else if (isFunction(then$$1)) {
        handleForeignThenable(promise, maybeThenable, then$$1);
      } else {
        fulfill(promise, maybeThenable);
      }
    }
  }

  function resolve(promise, value) {
    if (promise === value) {
      reject(promise, selfFulfillment());
    } else if (objectOrFunction(value)) {
      handleMaybeThenable(promise, value, getThen(value));
    } else {
      fulfill(promise, value);
    }
  }

  function publishRejection(promise) {
    if (promise._onerror) {
      promise._onerror(promise._result);
    }

    publish(promise);
  }

  function fulfill(promise, value) {
    if (promise._state !== PENDING) {
      return;
    }

    promise._result = value;
    promise._state = FULFILLED;

    if (promise._subscribers.length !== 0) {
      asap(publish, promise);
    }
  }

  function reject(promise, reason) {
    if (promise._state !== PENDING) {
      return;
    }
    promise._state = REJECTED;
    promise._result = reason;

    asap(publishRejection, promise);
  }

  function subscribe(parent, child, onFulfillment, onRejection) {
    var _subscribers = parent._subscribers;
    var length = _subscribers.length;

    parent._onerror = null;

    _subscribers[length] = child;
    _subscribers[length + FULFILLED] = onFulfillment;
    _subscribers[length + REJECTED] = onRejection;

    if (length === 0 && parent._state) {
      asap(publish, parent);
    }
  }

  function publish(promise) {
    var subscribers = promise._subscribers;
    var settled = promise._state;

    if (subscribers.length === 0) {
      return;
    }

    var child = void 0,
        callback = void 0,
        detail = promise._result;

    for (var i = 0; i < subscribers.length; i += 3) {
      child = subscribers[i];
      callback = subscribers[i + settled];

      if (child) {
        invokeCallback(settled, child, callback, detail);
      } else {
        callback(detail);
      }
    }

    promise._subscribers.length = 0;
  }

  function tryCatch(callback, detail) {
    try {
      return callback(detail);
    } catch (e) {
      TRY_CATCH_ERROR.error = e;
      return TRY_CATCH_ERROR;
    }
  }

  function invokeCallback(settled, promise, callback, detail) {
    var hasCallback = isFunction(callback),
        value = void 0,
        error = void 0,
        succeeded = void 0,
        failed = void 0;

    if (hasCallback) {
      value = tryCatch(callback, detail);

      if (value === TRY_CATCH_ERROR) {
        failed = true;
        error = value.error;
        value.error = null;
      } else {
        succeeded = true;
      }

      if (promise === value) {
        reject(promise, cannotReturnOwn());
        return;
      }
    } else {
      value = detail;
      succeeded = true;
    }

    if (promise._state !== PENDING) {
      // noop
    } else if (hasCallback && succeeded) {
      resolve(promise, value);
    } else if (failed) {
      reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      reject(promise, value);
    }
  }

  function initializePromise(promise, resolver) {
    try {
      resolver(function resolvePromise(value) {
        resolve(promise, value);
      }, function rejectPromise(reason) {
        reject(promise, reason);
      });
    } catch (e) {
      reject(promise, e);
    }
  }

  var id = 0;
  function nextId() {
    return id++;
  }

  function makePromise(promise) {
    promise[PROMISE_ID] = id++;
    promise._state = undefined;
    promise._result = undefined;
    promise._subscribers = [];
  }

  function validationError() {
    return new Error('Array Methods must be provided an Array');
  }

  var Enumerator = function () {
    function Enumerator(Constructor, input) {
      this._instanceConstructor = Constructor;
      this.promise = new Constructor(noop);

      if (!this.promise[PROMISE_ID]) {
        makePromise(this.promise);
      }

      if (isArray(input)) {
        this.length = input.length;
        this._remaining = input.length;

        this._result = new Array(this.length);

        if (this.length === 0) {
          fulfill(this.promise, this._result);
        } else {
          this.length = this.length || 0;
          this._enumerate(input);
          if (this._remaining === 0) {
            fulfill(this.promise, this._result);
          }
        }
      } else {
        reject(this.promise, validationError());
      }
    }

    Enumerator.prototype._enumerate = function _enumerate(input) {
      for (var i = 0; this._state === PENDING && i < input.length; i++) {
        this._eachEntry(input[i], i);
      }
    };

    Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
      var c = this._instanceConstructor;
      var resolve$$1 = c.resolve;

      if (resolve$$1 === resolve$1) {
        var _then = getThen(entry);

        if (_then === then && entry._state !== PENDING) {
          this._settledAt(entry._state, i, entry._result);
        } else if (typeof _then !== 'function') {
          this._remaining--;
          this._result[i] = entry;
        } else if (c === Promise$1) {
          var promise = new c(noop);
          handleMaybeThenable(promise, entry, _then);
          this._willSettleAt(promise, i);
        } else {
          this._willSettleAt(new c(function (resolve$$1) {
            return resolve$$1(entry);
          }), i);
        }
      } else {
        this._willSettleAt(resolve$$1(entry), i);
      }
    };

    Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
      var promise = this.promise;

      if (promise._state === PENDING) {
        this._remaining--;

        if (state === REJECTED) {
          reject(promise, value);
        } else {
          this._result[i] = value;
        }
      }

      if (this._remaining === 0) {
        fulfill(promise, this._result);
      }
    };

    Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
      var enumerator = this;

      subscribe(promise, undefined, function (value) {
        return enumerator._settledAt(FULFILLED, i, value);
      }, function (reason) {
        return enumerator._settledAt(REJECTED, i, reason);
      });
    };

    return Enumerator;
  }();

  /**
    `Promise.all` accepts an array of promises, and returns a new promise which
    is fulfilled with an array of fulfillment values for the passed promises, or
    rejected with the reason of the first passed promise to be rejected. It casts all
    elements of the passed iterable to promises as it runs this algorithm.
  
    Example:
  
    ```javascript
    let promise1 = resolve(1);
    let promise2 = resolve(2);
    let promise3 = resolve(3);
    let promises = [ promise1, promise2, promise3 ];
  
    Promise.all(promises).then(function(array){
      // The array here would be [ 1, 2, 3 ];
    });
    ```
  
    If any of the `promises` given to `all` are rejected, the first promise
    that is rejected will be given as an argument to the returned promises's
    rejection handler. For example:
  
    Example:
  
    ```javascript
    let promise1 = resolve(1);
    let promise2 = reject(new Error("2"));
    let promise3 = reject(new Error("3"));
    let promises = [ promise1, promise2, promise3 ];
  
    Promise.all(promises).then(function(array){
      // Code here never runs because there are rejected promises!
    }, function(error) {
      // error.message === "2"
    });
    ```
  
    @method all
    @static
    @param {Array} entries array of promises
    @param {String} label optional string for labeling the promise.
    Useful for tooling.
    @return {Promise} promise that is fulfilled when all `promises` have been
    fulfilled, or rejected if any of them become rejected.
    @static
  */
  function all(entries) {
    return new Enumerator(this, entries).promise;
  }

  /**
    `Promise.race` returns a new promise which is settled in the same way as the
    first passed promise to settle.
  
    Example:
  
    ```javascript
    let promise1 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 1');
      }, 200);
    });
  
    let promise2 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 2');
      }, 100);
    });
  
    Promise.race([promise1, promise2]).then(function(result){
      // result === 'promise 2' because it was resolved before promise1
      // was resolved.
    });
    ```
  
    `Promise.race` is deterministic in that only the state of the first
    settled promise matters. For example, even if other promises given to the
    `promises` array argument are resolved, but the first settled promise has
    become rejected before the other promises became fulfilled, the returned
    promise will become rejected:
  
    ```javascript
    let promise1 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 1');
      }, 200);
    });
  
    let promise2 = new Promise(function(resolve, reject){
      setTimeout(function(){
        reject(new Error('promise 2'));
      }, 100);
    });
  
    Promise.race([promise1, promise2]).then(function(result){
      // Code here never runs
    }, function(reason){
      // reason.message === 'promise 2' because promise 2 became rejected before
      // promise 1 became fulfilled
    });
    ```
  
    An example real-world use case is implementing timeouts:
  
    ```javascript
    Promise.race([ajax('foo.json'), timeout(5000)])
    ```
  
    @method race
    @static
    @param {Array} promises array of promises to observe
    Useful for tooling.
    @return {Promise} a promise which settles in the same way as the first passed
    promise to settle.
  */
  function race(entries) {
    /*jshint validthis:true */
    var Constructor = this;

    if (!isArray(entries)) {
      return new Constructor(function (_, reject) {
        return reject(new TypeError('You must pass an array to race.'));
      });
    } else {
      return new Constructor(function (resolve, reject) {
        var length = entries.length;
        for (var i = 0; i < length; i++) {
          Constructor.resolve(entries[i]).then(resolve, reject);
        }
      });
    }
  }

  /**
    `Promise.reject` returns a promise rejected with the passed `reason`.
    It is shorthand for the following:
  
    ```javascript
    let promise = new Promise(function(resolve, reject){
      reject(new Error('WHOOPS'));
    });
  
    promise.then(function(value){
      // Code here doesn't run because the promise is rejected!
    }, function(reason){
      // reason.message === 'WHOOPS'
    });
    ```
  
    Instead of writing the above, your code now simply becomes the following:
  
    ```javascript
    let promise = Promise.reject(new Error('WHOOPS'));
  
    promise.then(function(value){
      // Code here doesn't run because the promise is rejected!
    }, function(reason){
      // reason.message === 'WHOOPS'
    });
    ```
  
    @method reject
    @static
    @param {Any} reason value that the returned promise will be rejected with.
    Useful for tooling.
    @return {Promise} a promise rejected with the given `reason`.
  */
  function reject$1(reason) {
    /*jshint validthis:true */
    var Constructor = this;
    var promise = new Constructor(noop);
    reject(promise, reason);
    return promise;
  }

  function needsResolver() {
    throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
  }

  function needsNew() {
    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
  }

  /**
    Promise objects represent the eventual result of an asynchronous operation. The
    primary way of interacting with a promise is through its `then` method, which
    registers callbacks to receive either a promise's eventual value or the reason
    why the promise cannot be fulfilled.
  
    Terminology
    -----------
  
    - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
    - `thenable` is an object or function that defines a `then` method.
    - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
    - `exception` is a value that is thrown using the throw statement.
    - `reason` is a value that indicates why a promise was rejected.
    - `settled` the final resting state of a promise, fulfilled or rejected.
  
    A promise can be in one of three states: pending, fulfilled, or rejected.
  
    Promises that are fulfilled have a fulfillment value and are in the fulfilled
    state.  Promises that are rejected have a rejection reason and are in the
    rejected state.  A fulfillment value is never a thenable.
  
    Promises can also be said to *resolve* a value.  If this value is also a
    promise, then the original promise's settled state will match the value's
    settled state.  So a promise that *resolves* a promise that rejects will
    itself reject, and a promise that *resolves* a promise that fulfills will
    itself fulfill.
  
  
    Basic Usage:
    ------------
  
    ```js
    let promise = new Promise(function(resolve, reject) {
      // on success
      resolve(value);
  
      // on failure
      reject(reason);
    });
  
    promise.then(function(value) {
      // on fulfillment
    }, function(reason) {
      // on rejection
    });
    ```
  
    Advanced Usage:
    ---------------
  
    Promises shine when abstracting away asynchronous interactions such as
    `XMLHttpRequest`s.
  
    ```js
    function getJSON(url) {
      return new Promise(function(resolve, reject){
        let xhr = new XMLHttpRequest();
  
        xhr.open('GET', url);
        xhr.onreadystatechange = handler;
        xhr.responseType = 'json';
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.send();
  
        function handler() {
          if (this.readyState === this.DONE) {
            if (this.status === 200) {
              resolve(this.response);
            } else {
              reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
            }
          }
        };
      });
    }
  
    getJSON('/posts.json').then(function(json) {
      // on fulfillment
    }, function(reason) {
      // on rejection
    });
    ```
  
    Unlike callbacks, promises are great composable primitives.
  
    ```js
    Promise.all([
      getJSON('/posts'),
      getJSON('/comments')
    ]).then(function(values){
      values[0] // => postsJSON
      values[1] // => commentsJSON
  
      return values;
    });
    ```
  
    @class Promise
    @param {Function} resolver
    Useful for tooling.
    @constructor
  */

  var Promise$1 = function () {
    function Promise(resolver) {
      this[PROMISE_ID] = nextId();
      this._result = this._state = undefined;
      this._subscribers = [];

      if (noop !== resolver) {
        typeof resolver !== 'function' && needsResolver();
        this instanceof Promise ? initializePromise(this, resolver) : needsNew();
      }
    }

    /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
     ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
     Chaining
    --------
     The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
     ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
     findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
     ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
     Assimilation
    ------------
     Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
     ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
     If the assimliated promise rejects, then the downstream promise will also reject.
     ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
     Simple Example
    --------------
     Synchronous Example
     ```javascript
    let result;
     try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
     Errback Example
     ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
     Promise Example;
     ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
     Advanced Example
    --------------
     Synchronous Example
     ```javascript
    let author, books;
     try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
     Errback Example
     ```js
     function foundBooks(books) {
     }
     function failure(reason) {
     }
     findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
     Promise Example;
     ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
     @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
    */

    /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
    ```js
    function findAuthor(){
    throw new Error('couldn't find that author');
    }
    // synchronous
    try {
    findAuthor();
    } catch(reason) {
    // something went wrong
    }
    // async with promises
    findAuthor().catch(function(reason){
    // something went wrong
    });
    ```
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
    */

    Promise.prototype.catch = function _catch(onRejection) {
      return this.then(null, onRejection);
    };

    /**
      `finally` will be invoked regardless of the promise's fate just as native
      try/catch/finally behaves
    
      Synchronous example:
    
      ```js
      findAuthor() {
        if (Math.random() > 0.5) {
          throw new Error();
        }
        return new Author();
      }
    
      try {
        return findAuthor(); // succeed or fail
      } catch(error) {
        return findOtherAuther();
      } finally {
        // always runs
        // doesn't affect the return value
      }
      ```
    
      Asynchronous example:
    
      ```js
      findAuthor().catch(function(reason){
        return findOtherAuther();
      }).finally(function(){
        // author was either found, or not
      });
      ```
    
      @method finally
      @param {Function} callback
      @return {Promise}
    */

    Promise.prototype.finally = function _finally(callback) {
      var promise = this;
      var constructor = promise.constructor;

      if (isFunction(callback)) {
        return promise.then(function (value) {
          return constructor.resolve(callback()).then(function () {
            return value;
          });
        }, function (reason) {
          return constructor.resolve(callback()).then(function () {
            throw reason;
          });
        });
      }

      return promise.then(callback, callback);
    };

    return Promise;
  }();

  Promise$1.prototype.then = then;
  Promise$1.all = all;
  Promise$1.race = race;
  Promise$1.resolve = resolve$1;
  Promise$1.reject = reject$1;
  Promise$1._setScheduler = setScheduler;
  Promise$1._setAsap = setAsap;
  Promise$1._asap = asap;

  /*global self*/
  function polyfill() {
    var local = void 0;

    if (typeof global !== 'undefined') {
      local = global;
    } else if (typeof self !== 'undefined') {
      local = self;
    } else {
      try {
        local = Function('return this')();
      } catch (e) {
        throw new Error('polyfill failed because global object is unavailable in this environment');
      }
    }

    var P = local.Promise;

    if (P) {
      var promiseToString = null;
      try {
        promiseToString = Object.prototype.toString.call(P.resolve());
      } catch (e) {
        // silently ignored
      }

      if (promiseToString === '[object Promise]' && !P.cast) {
        return;
      }
    }

    local.Promise = Promise$1;
  }

  // Strange compat..
  Promise$1.polyfill = polyfill;
  Promise$1.Promise = Promise$1;

  return Promise$1;
});

//# sourceMappingURL=es6-promise.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(53), __webpack_require__(9)))

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat(slice.call(arguments)));
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(that, args.concat(slice.call(arguments)));
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var origSymbol = global.Symbol;
var hasSymbolSham = __webpack_require__(47);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') {
		return false;
	}
	if (typeof Symbol !== 'function') {
		return false;
	}
	if (_typeof(origSymbol('foo')) !== 'symbol') {
		return false;
	}
	if (_typeof(Symbol('bar')) !== 'symbol') {
		return false;
	}

	return hasSymbolSham();
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 17], max-statements: [2, 33] */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
		return false;
	}
	if (_typeof(Symbol.iterator) === 'symbol') {
		return true;
	}

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') {
		return false;
	}

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
		return false;
	}
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
		return false;
	}

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) {
		return false;
	} // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
		return false;
	}

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
		return false;
	}

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) {
		return false;
	}

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
		return false;
	}

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) {
			return false;
		}
	}

	return true;
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 * 
 */

(function (window, document) {
  'use strict';

  // Exits early if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.

  if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function get() {
          return this.intersectionRatio > 0;
        }
      });
    }
    return;
  }

  /**
   * An IntersectionObserver registry. This registry exists to hold a strong
   * reference to IntersectionObserver instances currently observering a target
   * element. Without this registry, instances without another reference may be
   * garbage collected.
   */
  var registry = [];

  /**
   * Creates the global IntersectionObserverEntry constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
   * @param {Object} entry A dictionary of instance properties.
   * @constructor
   */
  function IntersectionObserverEntry(entry) {
    this.time = entry.time;
    this.target = entry.target;
    this.rootBounds = entry.rootBounds;
    this.boundingClientRect = entry.boundingClientRect;
    this.intersectionRect = entry.intersectionRect || getEmptyRect();
    this.isIntersecting = !!entry.intersectionRect;

    // Calculates the intersection ratio.
    var targetRect = this.boundingClientRect;
    var targetArea = targetRect.width * targetRect.height;
    var intersectionRect = this.intersectionRect;
    var intersectionArea = intersectionRect.width * intersectionRect.height;

    // Sets intersection ratio.
    if (targetArea) {
      this.intersectionRatio = intersectionArea / targetArea;
    } else {
      // If area is zero and is intersecting, sets to 1, otherwise to 0
      this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
  }

  /**
   * Creates the global IntersectionObserver constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
   * @param {Function} callback The function to be invoked after intersection
   *     changes have queued. The function is not invoked if the queue has
   *     been emptied by calling the `takeRecords` method.
   * @param {Object=} opt_options Optional configuration options.
   * @constructor
   */
  function IntersectionObserver(callback, opt_options) {

    var options = opt_options || {};

    if (typeof callback != 'function') {
      throw new Error('callback must be a function');
    }

    if (options.root && options.root.nodeType != 1) {
      throw new Error('root must be an Element');
    }

    // Binds and throttles `this._checkForIntersections`.
    this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

    // Private properties.
    this._callback = callback;
    this._observationTargets = [];
    this._queuedEntries = [];
    this._rootMarginValues = this._parseRootMargin(options.rootMargin);

    // Public properties.
    this.thresholds = this._initThresholds(options.threshold);
    this.root = options.root || null;
    this.rootMargin = this._rootMarginValues.map(function (margin) {
      return margin.value + margin.unit;
    }).join(' ');
  }

  /**
   * The minimum interval within which the document will be checked for
   * intersection changes.
   */
  IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;

  /**
   * The frequency in which the polyfill polls for intersection changes.
   * this can be updated on a per instance basis and must be set prior to
   * calling `observe` on the first target.
   */
  IntersectionObserver.prototype.POLL_INTERVAL = null;

  /**
   * Starts observing a target element for intersection changes based on
   * the thresholds values.
   * @param {Element} target The DOM element to observe.
   */
  IntersectionObserver.prototype.observe = function (target) {
    // If the target is already being observed, do nothing.
    if (this._observationTargets.some(function (item) {
      return item.element == target;
    })) {
      return;
    }

    if (!(target && target.nodeType == 1)) {
      throw new Error('target must be an Element');
    }

    this._registerInstance();
    this._observationTargets.push({ element: target, entry: null });
    this._monitorIntersections();
    this._checkForIntersections();
  };

  /**
   * Stops observing a target element for intersection changes.
   * @param {Element} target The DOM element to observe.
   */
  IntersectionObserver.prototype.unobserve = function (target) {
    this._observationTargets = this._observationTargets.filter(function (item) {

      return item.element != target;
    });
    if (!this._observationTargets.length) {
      this._unmonitorIntersections();
      this._unregisterInstance();
    }
  };

  /**
   * Stops observing all target elements for intersection changes.
   */
  IntersectionObserver.prototype.disconnect = function () {
    this._observationTargets = [];
    this._unmonitorIntersections();
    this._unregisterInstance();
  };

  /**
   * Returns any queue entries that have not yet been reported to the
   * callback and clears the queue. This can be used in conjunction with the
   * callback to obtain the absolute most up-to-date intersection information.
   * @return {Array} The currently queued entries.
   */
  IntersectionObserver.prototype.takeRecords = function () {
    var records = this._queuedEntries.slice();
    this._queuedEntries = [];
    return records;
  };

  /**
   * Accepts the threshold value from the user configuration object and
   * returns a sorted array of unique threshold values. If a value is not
   * between 0 and 1 and error is thrown.
   * @private
   * @param {Array|number=} opt_threshold An optional threshold value or
   *     a list of threshold values, defaulting to [0].
   * @return {Array} A sorted list of unique and valid threshold values.
   */
  IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
    var threshold = opt_threshold || [0];
    if (!Array.isArray(threshold)) threshold = [threshold];

    return threshold.sort().filter(function (t, i, a) {
      if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
        throw new Error('threshold must be a number between 0 and 1 inclusively');
      }
      return t !== a[i - 1];
    });
  };

  /**
   * Accepts the rootMargin value from the user configuration object
   * and returns an array of the four margin values as an object containing
   * the value and unit properties. If any of the values are not properly
   * formatted or use a unit other than px or %, and error is thrown.
   * @private
   * @param {string=} opt_rootMargin An optional rootMargin value,
   *     defaulting to '0px'.
   * @return {Array<Object>} An array of margin objects with the keys
   *     value and unit.
   */
  IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
    var marginString = opt_rootMargin || '0px';
    var margins = marginString.split(/\s+/).map(function (margin) {
      var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
      if (!parts) {
        throw new Error('rootMargin must be specified in pixels or percent');
      }
      return { value: parseFloat(parts[1]), unit: parts[2] };
    });

    // Handles shorthand.
    margins[1] = margins[1] || margins[0];
    margins[2] = margins[2] || margins[0];
    margins[3] = margins[3] || margins[1];

    return margins;
  };

  /**
   * Starts polling for intersection changes if the polling is not already
   * happening, and if the page's visibilty state is visible.
   * @private
   */
  IntersectionObserver.prototype._monitorIntersections = function () {
    if (!this._monitoringIntersections) {
      this._monitoringIntersections = true;

      // If a poll interval is set, use polling instead of listening to
      // resize and scroll events or DOM mutations.
      if (this.POLL_INTERVAL) {
        this._monitoringInterval = setInterval(this._checkForIntersections, this.POLL_INTERVAL);
      } else {
        addEvent(window, 'resize', this._checkForIntersections, true);
        addEvent(document, 'scroll', this._checkForIntersections, true);

        if ('MutationObserver' in window) {
          this._domObserver = new MutationObserver(this._checkForIntersections);
          this._domObserver.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
          });
        }
      }
    }
  };

  /**
   * Stops polling for intersection changes.
   * @private
   */
  IntersectionObserver.prototype._unmonitorIntersections = function () {
    if (this._monitoringIntersections) {
      this._monitoringIntersections = false;

      clearInterval(this._monitoringInterval);
      this._monitoringInterval = null;

      removeEvent(window, 'resize', this._checkForIntersections, true);
      removeEvent(document, 'scroll', this._checkForIntersections, true);

      if (this._domObserver) {
        this._domObserver.disconnect();
        this._domObserver = null;
      }
    }
  };

  /**
   * Scans each observation target for intersection changes and adds them
   * to the internal entries queue. If new entries are found, it
   * schedules the callback to be invoked.
   * @private
   */
  IntersectionObserver.prototype._checkForIntersections = function () {
    var rootIsInDom = this._rootIsInDom();
    var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

    this._observationTargets.forEach(function (item) {
      var target = item.element;
      var targetRect = getBoundingClientRect(target);
      var rootContainsTarget = this._rootContainsTarget(target);
      var oldEntry = item.entry;
      var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, rootRect);

      var newEntry = item.entry = new IntersectionObserverEntry({
        time: now(),
        target: target,
        boundingClientRect: targetRect,
        rootBounds: rootRect,
        intersectionRect: intersectionRect
      });

      if (!oldEntry) {
        this._queuedEntries.push(newEntry);
      } else if (rootIsInDom && rootContainsTarget) {
        // If the new entry intersection ratio has crossed any of the
        // thresholds, add a new entry.
        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
          this._queuedEntries.push(newEntry);
        }
      } else {
        // If the root is not in the DOM or target is not contained within
        // root but the previous entry for this target had an intersection,
        // add a new record indicating removal.
        if (oldEntry && oldEntry.isIntersecting) {
          this._queuedEntries.push(newEntry);
        }
      }
    }, this);

    if (this._queuedEntries.length) {
      this._callback(this.takeRecords(), this);
    }
  };

  /**
   * Accepts a target and root rect computes the intersection between then
   * following the algorithm in the spec.
   * TODO(philipwalton): at this time clip-path is not considered.
   * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
   * @param {Element} target The target DOM element
   * @param {Object} rootRect The bounding rect of the root after being
   *     expanded by the rootMargin value.
   * @return {?Object} The final intersection rect object or undefined if no
   *     intersection is found.
   * @private
   */
  IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, rootRect) {

    // If the element isn't displayed, an intersection can't happen.
    if (window.getComputedStyle(target).display == 'none') return;

    var targetRect = getBoundingClientRect(target);
    var intersectionRect = targetRect;
    var parent = getParentNode(target);
    var atRoot = false;

    while (!atRoot) {
      var parentRect = null;
      var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};

      // If the parent isn't displayed, an intersection can't happen.
      if (parentComputedStyle.display == 'none') return;

      if (parent == this.root || parent == document) {
        atRoot = true;
        parentRect = rootRect;
      } else {
        // If the element has a non-visible overflow, and it's not the <body>
        // or <html> element, update the intersection rect.
        // Note: <body> and <html> cannot be clipped to a rect that's not also
        // the document rect, so no need to compute a new intersection.
        if (parent != document.body && parent != document.documentElement && parentComputedStyle.overflow != 'visible') {
          parentRect = getBoundingClientRect(parent);
        }
      }

      // If either of the above conditionals set a new parentRect,
      // calculate new intersection data.
      if (parentRect) {
        intersectionRect = computeRectIntersection(parentRect, intersectionRect);

        if (!intersectionRect) break;
      }
      parent = getParentNode(parent);
    }
    return intersectionRect;
  };

  /**
   * Returns the root rect after being expanded by the rootMargin value.
   * @return {Object} The expanded root rect.
   * @private
   */
  IntersectionObserver.prototype._getRootRect = function () {
    var rootRect;
    if (this.root) {
      rootRect = getBoundingClientRect(this.root);
    } else {
      // Use <html>/<body> instead of window since scroll bars affect size.
      var html = document.documentElement;
      var body = document.body;
      rootRect = {
        top: 0,
        left: 0,
        right: html.clientWidth || body.clientWidth,
        width: html.clientWidth || body.clientWidth,
        bottom: html.clientHeight || body.clientHeight,
        height: html.clientHeight || body.clientHeight
      };
    }
    return this._expandRectByRootMargin(rootRect);
  };

  /**
   * Accepts a rect and expands it by the rootMargin value.
   * @param {Object} rect The rect object to expand.
   * @return {Object} The expanded rect.
   * @private
   */
  IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
    var margins = this._rootMarginValues.map(function (margin, i) {
      return margin.unit == 'px' ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
    });
    var newRect = {
      top: rect.top - margins[0],
      right: rect.right + margins[1],
      bottom: rect.bottom + margins[2],
      left: rect.left - margins[3]
    };
    newRect.width = newRect.right - newRect.left;
    newRect.height = newRect.bottom - newRect.top;

    return newRect;
  };

  /**
   * Accepts an old and new entry and returns true if at least one of the
   * threshold values has been crossed.
   * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
   *    particular target element or null if no previous entry exists.
   * @param {IntersectionObserverEntry} newEntry The current entry for a
   *    particular target element.
   * @return {boolean} Returns true if a any threshold has been crossed.
   * @private
   */
  IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {

    // To make comparing easier, an entry that has a ratio of 0
    // but does not actually intersect is given a value of -1
    var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
    var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;

    // Ignore unchanged ratios
    if (oldRatio === newRatio) return;

    for (var i = 0; i < this.thresholds.length; i++) {
      var threshold = this.thresholds[i];

      // Return true if an entry matches a threshold or if the new ratio
      // and the old ratio are on the opposite sides of a threshold.
      if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
        return true;
      }
    }
  };

  /**
   * Returns whether or not the root element is an element and is in the DOM.
   * @return {boolean} True if the root element is an element and is in the DOM.
   * @private
   */
  IntersectionObserver.prototype._rootIsInDom = function () {
    return !this.root || containsDeep(document, this.root);
  };

  /**
   * Returns whether or not the target element is a child of root.
   * @param {Element} target The target element to check.
   * @return {boolean} True if the target element is a child of root.
   * @private
   */
  IntersectionObserver.prototype._rootContainsTarget = function (target) {
    return containsDeep(this.root || document, target);
  };

  /**
   * Adds the instance to the global IntersectionObserver registry if it isn't
   * already present.
   * @private
   */
  IntersectionObserver.prototype._registerInstance = function () {
    if (registry.indexOf(this) < 0) {
      registry.push(this);
    }
  };

  /**
   * Removes the instance from the global IntersectionObserver registry.
   * @private
   */
  IntersectionObserver.prototype._unregisterInstance = function () {
    var index = registry.indexOf(this);
    if (index != -1) registry.splice(index, 1);
  };

  /**
   * Returns the result of the performance.now() method or null in browsers
   * that don't support the API.
   * @return {number} The elapsed time since the page was requested.
   */
  function now() {
    return window.performance && performance.now && performance.now();
  }

  /**
   * Throttles a function and delays its executiong, so it's only called at most
   * once within a given time period.
   * @param {Function} fn The function to throttle.
   * @param {number} timeout The amount of time that must pass before the
   *     function can be called again.
   * @return {Function} The throttled function.
   */
  function throttle(fn, timeout) {
    var timer = null;
    return function () {
      if (!timer) {
        timer = setTimeout(function () {
          fn();
          timer = null;
        }, timeout);
      }
    };
  }

  /**
   * Adds an event handler to a DOM node ensuring cross-browser compatibility.
   * @param {Node} node The DOM node to add the event handler to.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to add.
   * @param {boolean} opt_useCapture Optionally adds the even to the capture
   *     phase. Note: this only works in modern browsers.
   */
  function addEvent(node, event, fn, opt_useCapture) {
    if (typeof node.addEventListener == 'function') {
      node.addEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.attachEvent == 'function') {
      node.attachEvent('on' + event, fn);
    }
  }

  /**
   * Removes a previously added event handler from a DOM node.
   * @param {Node} node The DOM node to remove the event handler from.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to remove.
   * @param {boolean} opt_useCapture If the event handler was added with this
   *     flag set to true, it should be set to true here in order to remove it.
   */
  function removeEvent(node, event, fn, opt_useCapture) {
    if (typeof node.removeEventListener == 'function') {
      node.removeEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.detatchEvent == 'function') {
      node.detatchEvent('on' + event, fn);
    }
  }

  /**
   * Returns the intersection between two rect objects.
   * @param {Object} rect1 The first rect.
   * @param {Object} rect2 The second rect.
   * @return {?Object} The intersection rect or undefined if no intersection
   *     is found.
   */
  function computeRectIntersection(rect1, rect2) {
    var top = Math.max(rect1.top, rect2.top);
    var bottom = Math.min(rect1.bottom, rect2.bottom);
    var left = Math.max(rect1.left, rect2.left);
    var right = Math.min(rect1.right, rect2.right);
    var width = right - left;
    var height = bottom - top;

    return width >= 0 && height >= 0 && {
      top: top,
      bottom: bottom,
      left: left,
      right: right,
      width: width,
      height: height
    };
  }

  /**
   * Shims the native getBoundingClientRect for compatibility with older IE.
   * @param {Element} el The element whose bounding rect to get.
   * @return {Object} The (possibly shimmed) rect of the element.
   */
  function getBoundingClientRect(el) {
    var rect;

    try {
      rect = el.getBoundingClientRect();
    } catch (err) {
      // Ignore Windows 7 IE11 "Unspecified error"
      // https://github.com/w3c/IntersectionObserver/pull/205
    }

    if (!rect) return getEmptyRect();

    // Older IE
    if (!(rect.width && rect.height)) {
      rect = {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };
    }
    return rect;
  }

  /**
   * Returns an empty rect object. An empty rect is returned when an element
   * is not in the DOM.
   * @return {Object} The empty rect.
   */
  function getEmptyRect() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }

  /**
   * Checks to see if a parent element contains a child elemnt (including inside
   * shadow DOM).
   * @param {Node} parent The parent element.
   * @param {Node} child The child element.
   * @return {boolean} True if the parent node contains the child node.
   */
  function containsDeep(parent, child) {
    var node = child;
    while (node) {
      if (node == parent) return true;

      node = getParentNode(node);
    }
    return false;
  }

  /**
   * Gets the parent node of an element or its host element if the parent node
   * is a shadow root.
   * @param {Node} node The node whose parent to get.
   * @return {Node|null} The parent node or null if no parent exists.
   */
  function getParentNode(node) {
    var parent = node.parentNode;

    if (parent && parent.nodeType == 11 && parent.host) {
      // If the parent is a shadow root, return the host element.
      return parent.host;
    }
    return parent;
  }

  // Exposes the constructors globally.
  window.IntersectionObserver = IntersectionObserver;
  window.IntersectionObserverEntry = IntersectionObserverEntry;
})(window, document);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateObject(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && _typeof(Symbol.toStringTag) === 'symbol';

module.exports = function isDateObject(value) {
	if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var has = __webpack_require__(3);
var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0;

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex;
	}
};
var toStr = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag = typeof Symbol === 'function' && _typeof(Symbol.toStringTag) === 'symbol';

module.exports = function isRegex(value) {
	if (!value || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		return toStr.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var toStr = Object.prototype.toString;
var hasSymbols = __webpack_require__(46)();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (_typeof(value.valueOf()) !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false && value;
	};
}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(25); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];
	var equalsConstructorPrototype = function equalsConstructorPrototype(o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = function () {
		/* global window */
		if (typeof window === 'undefined') {
			return false;
		}
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && _typeof(window[k]) === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}();
	var equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.observer = undefined;

var _background = __webpack_require__(11);

var _svgTransitionManager = __webpack_require__(60);

var _subtitles = __webpack_require__(62);

var _googleAnalytics = __webpack_require__(27);

var observer = exports.observer = function observer(sectionElements, videoElements, muteButton, shareButtons, setSectionId, byline) {
  var options = {
    threshold: [0]
    //rootMargin: `-98% 0px -2% 0px`
  };

  var callback = function callback(changes) {
    changes.forEach(function (change, i) {
      var target = change.target,
          isIntersecting = change.isIntersecting,
          intersectionRatio = change.intersectionRatio;


      var backgroundId = target.getAttribute('data-background-id');
      var backgroundEl = document.getElementById(backgroundId);

      if (isIntersecting) {
        setSectionId(backgroundId);
        (0, _googleAnalytics.trackAction)('LOAD_SUCCESS/' + backgroundId);
        backgroundEl.classList.add(_background.visible);

        if (target.getAttribute('data-share')) {
          shareButtons.classList.add(_background.visible);
        } else {
          shareButtons.classList.remove(_background.visible);
        }

        if (target.getAttribute('data-video-has-sound')) {
          muteButton.classList.add(_background.visible);
        } else {
          muteButton.classList.remove(_background.visible);
        }

        if (target.getAttribute('data-map-element')) {
          (0, _svgTransitionManager.transitionSvg)(target);
        }
        if (target.getAttribute('data-video-element')) {
          var bgVideo = backgroundEl.querySelector('video');
          if (target.getAttribute('data-video-subtitles') && !target.getAttribute('data-already-subtitled')) {
            (0, _subtitles.fakeSubtitles)(bgVideo, target.getAttribute('data-video-subtitles'));
          }
          //fakeSubtitles(bgVideo)

          bgVideo.play();
          var videoIsPlaying = !bgVideo.paused;
          if (videoIsPlaying) {
            (0, _googleAnalytics.trackAction)('VIDEO_PLAYING/' + backgroundId);
          }
        } else if (target.getAttribute('data-background-byline')) {
          //byline.classList.add(visible)
        }
      } else {
        backgroundEl.classList.remove(_background.visible);
        if (target.getAttribute('data-map-element')) {
          (0, _svgTransitionManager.resetSvg)(target);
        }
        if (target.getAttribute('data-video-element')) {
          var _bgVideo = backgroundEl.querySelector('video');
          _bgVideo.pause();
        }
      }
    });
  };
  var observer = new IntersectionObserver(callback, options);
  observer.POLL_INTERVAL = 500;
  sectionElements.forEach(function (sectionElement) {
    return observer.observe(sectionElement);
  });
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.seeMoreHandler = exports.bylineHandler = undefined;

var _section8_byline = __webpack_require__(65);

var bylineHandler = exports.bylineHandler = {
  property: 'data-background-byline',
  load: function load(card) {
    var elem = document.createElement('div');

    elem.setAttribute('style', 'background-color: #06090a; background-size: cover; background-position-x: center;');
    elem.id = card.getAttribute('data-background-id');
    //elem.innerHTML = renderSeeMoreContent()
    return elem;
  }
};

var seeMoreHandler = exports.seeMoreHandler = {
  property: 'data-background-see-more',
  load: function load(card) {
    var elem = document.createElement('div');

    elem.setAttribute('style', 'background-color: #06090a; background-size: cover; background-position-x: center;');
    elem.id = card.getAttribute('data-background-id');
    //elem.innerHTML = renderBylineContent()
    return elem;
  }
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fullscreenVideoHandler = undefined;

var _polopolyImage = __webpack_require__(10);

var _serumImagecropUtils = __webpack_require__(5);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fullscreenVideoHandler = exports.fullscreenVideoHandler = {
  property: 'data-fullscreen-video-element',
  load: function load(card) {
    var elem = document.createElement('div');
    var id = card.getAttribute('data-background-id');
    elem.id = id;

    var polopolyId = card.getAttribute('data-background-polopoly-id');

    var defaultUrl = (0, _serumImagecropUtils.createImageUrl)({ id: polopolyId, width: 1600, ratio: '1:1' });
    var desktopSourceSet = (0, _polopolyImage.createSrcSet)(polopolyId, '1:1', _serumImagecropUtils.widths);
    var mobileSourceSet = (0, _polopolyImage.createSrcSet)(polopolyId, '3:4', _serumImagecropUtils.widths);
    var backgroundImage = '\n      <picture class="' + _index2.default['blurred'] + '" style="object-fit: cover;">\n      <source media="(min-aspect-ratio: 3/4)" srcset="' + desktopSourceSet + '">\n      <img src="' + defaultUrl + '" srcset="' + mobileSourceSet + '" style="min-width: 100%; min-height: 100%; position: relative; left: 50%; transform: translate3d(-50%, -50%, 0); top: 50%;">\n      </picture>\n      <div class="' + _index2.default['overlay'] + ' ' + _index2.default['darkedout'] + '"></div>\n    ';

    // const backgroundImage = card.getAttribute('data-background-image')
    // elem.setAttribute('style', `background-image: url(${backgroundImage}); background-size: cover; background-position-x: center;`)
    elem.innerHTML = backgroundImage;
    return elem;
  }
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var imageHandler = exports.imageHandler = {
  property: 'data-background-image',
  load: function load(card) {
    var elem = document.createElement('div');

    var backgroundImage = card.getAttribute('data-background-image');
    elem.setAttribute('style', 'background-image: url(' + backgroundImage + '); background-size: cover; background-position-x: center;');
    elem.id = card.getAttribute('data-background-id');

    return elem;
  }
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadSections = loadSections;

var _background = __webpack_require__(11);

var _image = __webpack_require__(57);

var _video = __webpack_require__(61);

var _map = __webpack_require__(59);

var _polopolyImage = __webpack_require__(10);

var _fullscreenVideo = __webpack_require__(56);

var _byline = __webpack_require__(55);

var _getLogo = __webpack_require__(63);

var _getShareButtons = __webpack_require__(64);

var _muteButtons = __webpack_require__(28);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var sectionHandlers = [_fullscreenVideo.fullscreenVideoHandler, _map.mapHandler, _image.imageHandler, _polopolyImage.polopolyIdHandler, _video.videoHandler, _byline.bylineHandler, _byline.seeMoreHandler];

function loadSections(sectionElements, backgroundContainer, overlayContainer) {
  [].concat(_toConsumableArray(sectionElements)).forEach(function (card, idx) {
    var handler = sectionHandlers.find(function (handler) {
      return !!card.getAttribute(handler.property);
    });

    var elem = handler.load(card);
    elem.className = _background.background;
    (0, _getShareButtons.getShareButtons)();

    backgroundContainer.appendChild(elem);
    backgroundContainer.setAttribute('aria-hidden', 'true');

    if (handler.init) {
      try {
        handler.init(card, elem);
      } catch (e) {
        console.error('Error initializing background', e);
      }
    }

    if (idx === 0) {
      elem.className = _background.background + ' ' + _background.visible;
    }
    if (card.getAttribute('data-background-gradient')) {
      elem.classList.add(_background.backgroundGradient);
    }
  });

  overlayContainer.innerHTML += (0, _getLogo.getLogo)() + ' ' + (0, _getShareButtons.getShareButtons)() + ' ' + (0, _muteButtons.getInitialMuteButton)();
}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapHandler = undefined;

var _polopolyImage = __webpack_require__(10);

var _serumImagecropUtils = __webpack_require__(5);

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _map = __webpack_require__(68);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapHandler = exports.mapHandler = {
  property: 'data-map-element',
  load: function load(card) {
    var elem = document.createElement('div');
    var id = card.getAttribute('data-background-id');
    elem.id = id;

    var polopolyId = card.getAttribute('data-background-polopoly-id');

    var defaultUrl = (0, _serumImagecropUtils.createImageUrl)({
      id: polopolyId,
      width: 1600,
      ratio: '1:1'
    });
    var desktopSourceSet = (0, _polopolyImage.createSrcSet)(polopolyId, '1:1', _serumImagecropUtils.widths);
    var mobileSourceSet = (0, _polopolyImage.createSrcSet)(polopolyId, '3:4', _serumImagecropUtils.widths);

    var mapEl = '\n      <div class="' + _map2.default['mapContainer'] + '">\n        ' + mapSVG(id) + '\n        ' + mobileMapSVG(id) + '\n        ' + pathSVG(id) + '\n      </div>\n    ';
    elem.innerHTML = mapEl;
    return elem;
  }
};

var mapSVG = function mapSVG(id) {
  return '\n    <svg id="svg-map-background-' + id + '" class="' + _map2.default['desktop-map'] + '" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1600 1302.3">\n      <pattern y="163.4" width="90" height="90" patternUnits="userSpaceOnUse" id="a" viewBox="0 -90 90 90" overflow="visible">\n        <path fill="#FDD42F" d="M0-90v1.4L1.4-90z"/>\n        <path fill="#333" d="M6.8-90L0-83.2v2.8L9.6-90zm8.1 0L0-75.1v2.9L17.8-90zm8.2 0L0-66.9v2.9l26-26zm8.2 0L0-58.7v2.8L34.1-90zm8.2 0L0-50.5v2.8L42.3-90zm8.2 0L0-42.3v2.8L50.5-90zm8.2 0L0-34.1v2.8L58.7-90zm8.1 0L0-26v2.9L66.9-90zm8.2 0L0-17.8v2.9L75.1-90zm8.2 0L0-9.6v2.8L83.2-90zm9.6 0h-1.4L0-1.4V0h1.4L90-88.6zM9.6 0L90-80.4v-2.8L6.8 0zm8.2 0L90-72.2v-2.9L14.9 0zM26 0l64-64v-2.9L23.1 0zm8.1 0L90-55.9v-2.8L31.3 0zm8.2 0L90-47.7v-2.8L39.5 0zm8.2 0L90-39.5v-2.8L47.7 0zm8.2 0L90-31.3v-2.8L55.9 0zm8.2 0L90-23.1V-26L64 0zm8.2 0L90-14.9v-2.9L72.2 0zm8.1 0L90-6.8v-2.8L80.4 0z"/>\n        <path fill="#FDD42F" d="M90 0v-1.4L88.6 0z"/>\n      </pattern>\n    <circle fill="#FFF" cx="395.9" cy="848.6" r="4.3"/>\n    <circle fill="#FFF" cx="472.6" cy="583.6" r="4"/>\n    <circle fill="#FFF" cx="549.3" cy="259.5" r="4"/>\n    <circle fill="#FFF" cx="715.9" cy="315.6" r="4"/>\n    <path fill="none" stroke="#FFF" stroke-miterlimit="10" d="M549.3 259.5l46 6.3 31.5 4 21.5-5.1 26.5 14.1 17.5 6 8.3 15.2 8.7 3 6.6 12.6"/>\n    <path fill="none" stroke="#FFF" stroke-miterlimit="10" d="M549.3 259.5l27.5 4 14 22.2 26 15 15.8 14.8-2.5 18.7-6 11 5.2 9.9 16.3 5 12.7 31.5 13.8 22 7.6 18.1-19.4 14.4-19.6 7.9-29.9 11.6-19.5 2.5-13.4 8.1-15.6 17.9-9.4 1.5-7.6 5-9.5 24.7-24.5 28.8s-39.2 30.1-38.7 29.3"/>\n    <path opacity=".8" fill="#FDD42F" d="M480.4 227.5l10.9-1.7 6 1.7 9.5 2.6 9 10.2 9.5-6 1-9.7-7.4-4.3-1.3-9 12.7-5 19 5 25 12 22-3-9.4-16.7-30.8-2.6-6.8-11.6-25-21.8-.8-13.3.3-5.8 5.9-7.6-8.4-2.8-.5-5.4L509 128l-5.3 2.2-41-11.7.7 4.6-10.5 12.3 4.8 8.5-11.3 10.1 2.4 15.3-9.8 24.2 3.9 4.7.2 10 3.9 5.8 4.6-.2.2 6.8 3.5 2.7-5.9 2.4 1.3 2.5 3.2-2.9 6.5 2.2 12.2.8"/>\n    <pattern id="b" xlink:href="#a" patternTransform="translate(720 -150.015)"/>\n    <path fill="url(#b)" d="M627.8 591.8c.2 0 .1-.1 0-.2-.3.1-.3.2 0 .2z"/>\n    <path fill="#FDD42F" d="M547.6 247.8v-4.5l6.8-4.7 3.7 7v3.2h-3.7l-1.1-1"/>\n    <path opacity=".8" fill="#A4CD44" d="M429.5 1099.2c1.4-2.9 12.7-22.9 12.7-22.9l-12.7-34 6.4-9.3-3.6-9.3-14 9.3-8.7-4.7 4-8.7-13.3-41.3 11.3-6.7 9.7-11.3 16.3-2v-10.7L421.3 933l-3 8-22.3 14.7-5.4 16 5.4 32.7-13 11.8-16.6 24.9-9.4-4.7 9.4-13.3 8.6-18-12.7-8 10.7-14-.7-24.7-11.3-9.3.7-16-12.7-11.7-10 3.7-18.7 5.3-4-18.7-10-9.3 2.7 14.7-2.7 16.7 7.3 14.7 10.7 24.7-8.7 14 28.7 4v22.7l-17.3-2.7-3.5 10.7 6 1.2v4.2l11.4 3.2-5.8 1.8 1.8 3.5 10.3-1-.8 12.1 10.7 20.3 6.7-2.9 7.8 3.7 4.8-5.3 36.9 33.7 16.2 2.8zm94-944.9l.8 13.3 16.7 14.7 8.3 7.1 6.8 11.6 30.8 2.6 9.4 16.7 12.6 6.7 14.7-6v-9.7l7.3 3.4 5.4 2.6 4.3 6.3 15-9.3-1.8-12.4-17-17.6 13.5-6h10v-14h7v-9l9-5 19.8 4.8 6.7-3.3 5 7 12.1-9.5-11.1-29.5h-15.3l-28.8 16.4-16.5-2.8-36.1 20.8-3.3 8.8-32.1-8.6-15.2-2.6L551 157l-2.5-4.4-2.7 2.1-3.3-1.1-3.9 8.8"/>\n    <path opacity=".8" fill="#6D6E71" d="M1312 338l-18.9-48.4s5.4-66.4 4.2-64.2l11.7-21.1h-13.2l-7.5 17.8-8.1 19.2 3.1 26.5-14.1 19.8-8.9 12.7-28.2 8.9-3.8 12.6-38.5-4.2-22.8 6.2-39.9 2.8-39.4 10.6-32.3 16.6 3.8 16.4-18.5.5-5.8-18.9-12-6.3-16.5-2.6-15.2-.4-.6 21.2 3.5 20-25 10.5-21.5 1v-18l-16.5-3.5-6.5 9.5-20.5 10.5s0 8 .5 10.5-9.5-1-12 0-18.8 22.5-18.8 22.5l-5.2 27.5h-13.5l-3.4-8.5-26.6-10-10.5-21-24 1 1.5-4s-12.5-5.5-14-5-12.5 10.5-12.5 10.5l-17.8 20-31-6-10.7 14h-21.5c1.5 0-47.5 20.5-47.5 20.5l-3.3 9.5-12.2-3.5-16.2 6-16.8-6-8 8 3 9-10 4.5-3 21 5 11.2s.5 6.8-2.5 8.3 13.5 0 13.5 0 5 11 3 11-3 24.5-3 24.5l5.5 15 13.3 15.1 2.2-6.6-2.2-9.2s21.2 6.9 23.1 8c1.4-.8 12.9-4 12.9-4l13.2 2.2 3-5.5 2-12-5-8v-11.1l11-11.9 21.5-12.5 20.5-3.3s18 6.8 16.5 6.8 1.5 15 1.5 15l-8.8 16.5 4 8 5.8 15.8h21.2l48.8-22.3 9 4 38.5-16.1 24-8.4 3.5 25.5-11.5 44.5 10 9.5 45 6.7h81l71.5 20.8 9-4 5 10.5h9l2.5 10 88.3 8.3 62.6-19 41.7-83.3-.1-106.7 8.6-25.6-.5-23.2 21.6-31.6-3.3-49.1zm-14.6-112.6c-.1.1-.1.1 0 0z"/>\n    <path fill="#A4CD44" d="M942.6 771.3s-68.3-16-69.6-13-32.7-23.3-32.7-23.3l-38 5.9-6 7.4-18 20-63.3 5.3-3 12.4 20.7 20.2v6l-53.3-18-46.3 38-19.7 37 7 21 7 23 9 20-24 11-7.7-29-24.3-21-10.5-25h-44.5l-49.7 39.2-1.7 11.2 8.3 11.7v22l30 21h37l14 10 24-10 1 26.5 16.3 18.5-34.8 13-54.2 29.3 9 29.2 450.1-284.2-32.1-35.3zm-482.7-544l-.1-.3c-.7.1-.6.2.1.3zm170.4 168c2 0-7.5-25.5-7.5-25.5l-15-14.5-6.5-9.5 10.5-15.5 4.5-10.7-16-8-11.5 8-10.5-4-2-20.8-12 7-6.3 7.3 1 6.5-9.7.7-16-.7-6.5-11.3 7-9.5-2.5-4 8.5-3.2.2-15.1 4.2-5.2-4.3-3.8-3-15.7 9.8-6 4.8-8.2-12.2-16.3-12.5 2.5-1.5 14.5-9.5 6-9-10.2-15.5-4.3-18.7 2.5s-10.2-.5-12.7-1l1.4 8.5 5.9 2-2.8 4.8 4.8 4.3-5.4 4.1-8.8-.1-.1 5.2-11.7-4.2-12.1-.8-6.4 8.9-13.3-3.7 2.7 4.4-5.2 4.6 5.1 5.2-5.4 5.6 4.2 8.3-1.7 16.8-8.9 5.1-7.3-4.1 1.1 12.2-11.2-2.6-10.4 6.7-2.1 27-6.4.3s3 5.2 4.5 5.7 15 8 15 8l18.5 6.5 3 40v30.5l19.5-5 14.5 1.5v24.5h9.9l7.6 5.5 10.3-6.5 2-12.7 12.2-4.3h12.5l15-6 11.5 11.5 15 6.3h16.5l19.5 11.7 13 2.5 12-9 15.5-1 17-16 6-19.5c-.1.3-8.1-24.7-6.1-24.7zm-168 178.5l-3-24.5h-10.5l-3 12.2-20-8.3V544l-3-8.2 10-4.5 9.7 5 19.8-1 21.5-4 14.5-8.5 7-7 7 7 10 7.5-18 14.5-17.7 17.7-14.1-4-3.9 13.3m11 233.8c-2.7 0-11-10.7-11-10.7l18-30.7h28.3l13.3-14 16.2-15.3h21.7l-3.2 16 6.8 8.7-20.5 22.7-30.1 9.3-17.9 14h-21.6zm-11 20l-6.3-10 6.3-2.6 4 6.3m-157 80.3c-2-1.3-9.3-13.5-9.3-13.5l9.3-3.1h18.7l8.7-4.7 6 14.7-16.7 6.7h-16.7z" opacity=".8"/>\n    <g opacity=".8" fill="#FDD42F">\n      <path d="M1365.8 51c-.1-.1-.1 0 0 0zm-352.9 85.6c-.1 0-.1.1 0 0 .1 0 .1 0 0 0zM771.3 103c-.1 0 0 0 0 0 .1 0 .1 0 0 0z"/>\n      <path d="M1484.3 36.4l4.6-6.6.3-4.9-10.8-6.7-.3-4.4-2.9 3.4-10-2.6 2.1-7.4-3.9-.9-3 5.6S1433 36.5 1434 36.5s-51.9 15.8-51.9 15.8-16.5-1.2-17.7-1.4c.8.3-19.5 7.4-19.5 7.4l-48.5 1.6-10.5 4.2-10.7-6.4-45.2-8.9-10.8 1.9-2.8 7.8-3.3-9.6h-9l-2.5 5.4-9.5.2-30.2 17.1-20.6 2.6-10.5 12.1-17.7 8.4-13.4 11.6-23.7 4.2-4.2 6.9s-40.1 16.3-41.1 16.9c.4-.3-16.1.8-17.2.5-2.5 1-38.6 12.3-38.6 12.3l-23-.3-25 7.3-36.6-9.7-52.7-.3-32.3-31s-30.8-11.3-30.9-11.6c-.6.1-7.7.9-8.4 1-.4-.4-18-5.8-18-5.8l-15 2.1-1 4.4-20.5 6.9-2.6 9.7 11.1 29.5-12.2 9.5-5-7-6.7 3.3-19.8-4.8-8.9 5v9h-7v14h-10l-13.5 6 16 16.5 14.5 3.5 19.5 20.5 39.5 19v9.8l-5.8 21.2 48.3 42.8-3.3 13.9 1.9 4.2 4.5 10.5 1 13.8 18.3 9.3h21l27.5-7 22-5.5 37-10.5 17-11.5 4.3-12 7.2 5.5 7-2 5 8.5s11-2.5 13-4 15.5 12.5 15.5 12.5l8-8 6.5 8s9.8-2.3 8.2-1.7c-1.7.7 14.7 1.3 16 1.3 1.3 0 14.7 2.3 15.7 2.3s12.7 6.4 13.2 8 3.8 17.5 5.5 17.5 18.5-.5 18.5-.5l-3.8-16.4 32.3-16.6 39.4-10.6 38.9-2.8 23.8-6.2 38.5 4.2 3.8-12.6 28.2-8.9 23-32.5-3.1-26.5 15.6-37h12.2l10-18 79.6-17.4 97-105.9-2.6-4.7v-3.7l-7.9-18.2zM765.5 331.5l12.5-1-14.7-.2"/>\n    </g>\n    <path fill="none" stroke="#FFF" stroke-miterlimit="10" d="M472.6 584.3v19l6 23.7 5.7 74.3-4.4 9.3 4.4 11.7-10.7 19.7v13l-26 36 6 6.6-23 28.7-34.7 22.3"/>\n    <g fill="#A4CD44">\n      <path d="M1125.6 937.3c5.8 0 9.7 3.8 9.7 11 0 7.8-4.1 11.4-9.8 11.4-5.7 0-9.9-3.6-9.9-11.4 0-7.2 4.1-11 10-11zm-.1 19.9c4.2 0 6.9-3 6.9-8.9 0-5.4-2.7-8.4-6.9-8.4-4.3 0-7 3.1-7 8.4 0 5.9 2.8 8.9 7 8.9zm13.6 8.1v-21.7h2.3l.2 2.3c1.4-1.7 3.2-2.7 5.3-2.7 4.1 0 6.3 3 6.3 8.2 0 5-2.1 8.3-6.5 8.3-2.7 0-4.3-1.4-4.9-2.2v7.9h-2.7zm2.7-10.3c.7.9 2.3 2.2 4.3 2.2 2.7 0 4.3-1.9 4.3-5.8 0-3.8-1.4-5.9-3.9-5.9-2 0-3.7 1.4-4.7 2.6v6.9zm15.2 10.3v-21.7h2.3l.2 2.3c1.4-1.7 3.2-2.7 5.3-2.7 4.1 0 6.3 3 6.3 8.2 0 5-2.1 8.3-6.5 8.3-2.7 0-4.3-1.4-4.9-2.2v7.9h-2.7zm2.6-10.3c.7.9 2.3 2.2 4.3 2.2 2.7 0 4.3-1.9 4.3-5.8 0-3.8-1.4-5.9-3.9-5.9-2 0-3.7 1.4-4.7 2.6v6.9zm17.6-9.1c.7-1.5 2-2.8 3.6-2.8.5 0 1.1.1 1.5.3l-.3 2.6c-.4-.2-.8-.2-1.3-.2-1.4 0-2.6 1.4-3.2 2.5v10.9h-2.6v-15.7h2.2l.1 2.4zm14-2.7c.4 0 .8 0 1.1.1l.5-1.7h2.2l-.7 2.3c2.5 1.1 4 3.7 4 7.6 0 5.2-3.1 8.2-7.6 8.2-.5 0-.9-.1-1.3-.1l-.6 2h-2.2l.8-2.6c-2.4-1.2-3.8-3.7-3.8-7.4.1-5.4 3.1-8.4 7.6-8.4zm-3 13.2l3.4-10.9h-.6c-2.6 0-4.5 1.9-4.5 5.9-.1 2.5.6 4.1 1.7 5zm5.4-10.1l-3.4 10.9c.2.1.5.1.8.1 2.6 0 4.6-1.8 4.6-5.9 0-2.5-.8-4.2-2-5.1zm10.8-.4c.7-1.5 2-2.8 3.6-2.8.5 0 1.1.1 1.5.3l-.3 2.6c-.4-.2-.8-.2-1.3-.2-1.4 0-2.6 1.4-3.2 2.5v10.9h-2.6v-15.7h2.2l.1 2.4zm7.5 9.5c1.5 1.2 3.4 2 5 2 2.1 0 3.3-.9 3.3-2.3 0-1.5-.8-2-3.7-2.7-3.6-.9-5.1-2.1-5.1-4.6 0-2.8 2.3-4.6 5.7-4.6 2.3 0 4.3.8 5.8 2.3l-1.2 1.6c-1.4-1.2-3-1.8-4.5-1.8-1.9 0-3 .8-3 2.2 0 1.5 1.1 2 3.8 2.7 3.5.9 5 2.1 5 4.6 0 3-2.4 4.9-6 4.9-2.6 0-4.9-1.1-6.4-2.5l1.3-1.8zm28.2 3.3c0 5.2-2.2 6.8-6.9 6.8-2.1 0-4.2-.5-5.5-1l.5-2.2c1.3.5 3 .9 4.9.9 3.5 0 4.4-1.4 4.4-4.7V957c-1.1 1.4-2.8 2.4-5.2 2.4-4.4 0-6.4-3.3-6.4-8s2.1-8.3 6.6-8.3c2.5 0 4.2 1.5 5 2.6l.2-2.3h2.3v15.3zm-2.7-10.6c-.7-1-2.3-2.5-4.3-2.5-2.9 0-4.3 2.2-4.3 5.8 0 3.5 1.2 5.8 4.2 5.8 2.2 0 3.6-1.4 4.4-2.2v-6.9zm9.5-2.2c.7-1.5 2-2.8 3.6-2.8.5 0 1.1.1 1.5.3l-.3 2.6c-.4-.2-.8-.2-1.3-.2-1.4 0-2.6 1.4-3.2 2.5v10.9h-2.6v-15.7h2.2l.1 2.4zm17.8 13.4l-.2-2.3c-1 1.3-2.8 2.6-5.2 2.6-3.8 0-4.9-2.4-4.9-5.5v-10.6h2.7v9.9c0 2.4.7 3.8 3 3.8 1.9 0 3.2-1.2 4.2-2.3v-11.4h2.6v15.7h-2.2zm6.7 6v-21.7h2.3l.2 2.3c1.4-1.7 3.1-2.7 5.3-2.7 4.1 0 6.3 3 6.3 8.2 0 5-2.1 8.3-6.5 8.3-2.7 0-4.3-1.4-4.9-2.2v7.9h-2.7zm2.6-10.3c.7.9 2.3 2.2 4.3 2.2 2.7 0 4.3-1.9 4.3-5.8 0-3.8-1.4-5.9-3.9-5.9-2 0-3.7 1.4-4.7 2.6v6.9zm15.3 10.3v-21.7h2.3l.2 2.3c1.4-1.7 3.1-2.7 5.3-2.7 4.1 0 6.3 3 6.3 8.2 0 5-2.1 8.3-6.5 8.3-2.7 0-4.3-1.4-4.9-2.2v7.9h-2.7zm2.6-10.3c.7.9 2.3 2.2 4.3 2.2 2.7 0 4.3-1.9 4.3-5.8 0-3.8-1.4-5.9-3.9-5.9-2 0-3.7 1.4-4.7 2.6v6.9zm27.8 2.5c-1.8 1.5-3.8 2.1-6 2.1-4.5 0-7.3-2.7-7.3-8.2 0-5 2.8-8.3 7.3-8.3 4.1 0 6.3 2.5 6.3 7.7v1.4h-10.7c.1 3 1.4 5.2 4.7 5.2 1.7 0 3.1-.5 4.8-1.7l.9 1.8zm-2.3-7.5c0-2.5-.9-4.7-3.7-4.7-3.5 0-4.4 3.1-4.5 4.7h8.2zm8.5-4.1c.7-1.5 2-2.8 3.6-2.8.5 0 1.1.1 1.5.3l-.3 2.6c-.4-.2-.8-.2-1.3-.2-1.4 0-2.6 1.4-3.2 2.5v10.9h-2.6v-15.7h2.2l.1 2.4z"/>\n      <path opacity=".8" d="M1035.1 929.4h45.1v45.1h-45.1z"/>\n    </g>\n    <g fill="#FDD42F">\n      <path d="M1116.3 876.2h2.8v9.3h3.9l5.4-9.3h3.1l-6.1 10.4 7.1 11.2h-3.2l-6.4-9.9h-3.9v9.9h-2.8v-21.6zm28.5 21.6l-.2-2.3c-1.1 1.3-2.8 2.6-5.2 2.6-3.8 0-4.9-2.4-4.9-5.5V882h2.7v9.9c0 2.4.7 3.8 3 3.8 1.9 0 3.2-1.2 4.2-2.3V882h2.6v15.8h-2.2zm9-13.4c.7-1.5 2-2.8 3.6-2.8.5 0 1.1.1 1.5.3l-.3 2.6c-.4-.2-.8-.2-1.3-.2-1.4 0-2.6 1.4-3.2 2.5v10.9h-2.6V882h2.2l.1 2.4zm18.2 11.2c-.8 1-2.5 2.5-5.2 2.5-4.4 0-6.4-3.2-6.4-8.2 0-5.1 2.5-8.3 6.5-8.3 2.3 0 3.8 1 4.9 2.3v-7.8h2.6v21.6h-2.3l-.1-2.1zm-.1-8.9c-.7-.9-2.3-2.6-4.6-2.6-2.4 0-4.1 2-4.1 5.8 0 2.9 1 5.8 4.3 5.8 2.1 0 3.4-1.4 4.3-2.5v-6.5zm19.6 9.3c-1.8 1.5-3.8 2.1-6 2.1-4.5 0-7.3-2.7-7.3-8.2 0-5 2.8-8.3 7.3-8.3 4.1 0 6.3 2.5 6.3 7.6v1.4H1181c.1 3 1.4 5.2 4.7 5.2 1.7 0 3.1-.5 4.8-1.7l1 1.9zm-2.3-7.5c0-2.5-.9-4.7-3.7-4.7-3.5 0-4.4 3.2-4.5 4.7h8.2zm8.6-4.1c.7-1.5 2-2.8 3.6-2.8.5 0 1.1.1 1.5.3l-.3 2.6c-.4-.2-.8-.2-1.3-.2-1.4 0-2.6 1.4-3.2 2.5v10.9h-2.6V882h2.2l.1 2.4zm19.8 11.6c-1.8 1.5-3.8 2.1-6 2.1-4.5 0-7.3-2.7-7.3-8.2 0-5 2.8-8.3 7.3-8.3 4.1 0 6.3 2.5 6.3 7.6v1.4h-10.7c.1 3 1.4 5.2 4.7 5.2 1.7 0 3.1-.5 4.8-1.7l.9 1.9zm-2.4-7.5c0-2.5-.9-4.7-3.7-4.7-3.5 0-4.4 3.2-4.5 4.7h8.2z"/>\n      <path opacity=".8" d="M1035.1 867.2h45.1v45.1h-45.1z"/>\n    </g>\n    <path d="M1116.3 1002.4h2.8v21.6h-2.8v-21.6zm7.7 16.8c1.9 1.7 4 2.8 6.2 2.8 2.6 0 4.4-1.3 4.4-3.7 0-2.2-1.1-3.1-4.9-4.3-4.7-1.4-6.4-2.9-6.4-6.2 0-3.9 3-5.9 7-5.9 2.8 0 5.2 1 7 3.1l-1.5 1.7c-1.6-1.7-3.6-2.5-5.5-2.5-2.4 0-4.2 1.1-4.2 3.3 0 2.4 1.9 3 5.4 4.2 4.3 1.4 6 3 6 6.2 0 3.9-3 6.3-7.3 6.3-3.2 0-5.8-1.3-7.7-3.3l1.5-1.7z" fill="#CDCCCC"/>\n    <path opacity=".8" fill="#6D6E71" d="M1035.1 991.6h45.1v45.1h-45.1z"/>\n    <path fill="none" stroke="#FFF" stroke-width="2" stroke-miterlimit="10" d="M299.4 1019.1v-56.9l-14.8-65.4h4.7l1.6-6.9 2.6 2.6 15.3-7.9v-8.4l22.7-14.8c-.7-8.1-1.4-11.9-2.1-11.6-.7.4 1.6-1.4 6.9-5.3l7.9 4.2 6.3-12.7-8.4-7.9-10.5-1.1-2.1-6.9 6.9-5.8V803l16.9-17.4 23.2-6.3 6.3 5.3 3.7-7.9 25.3 7.9v-5.3l-4.2-7.4-9.5-1.6-5.8-7.4c9.1-10.9 13.5-16.2 13.2-15.8-.4.4 2.3-.2 7.9-1.6-.4-3.9-.9-5.8-1.6-5.8h3.7l-2.1-4.7 4.7 2.1 1.6-4.2c5.3 2.8 7.9 4.2 7.9 4.2s1.6-.7 4.7-2.1l2.1-11.6 11.1-8.4 2.6-12.1 7.4-1.6-7.4-7.4V677l-4.7 1.6-1.1-3.7-5.3-10.5 6.3-9c-12.7-8.1-18.6-12.1-17.9-12.1.7 0-.2-3.2-2.6-9.5l-20.6 1.6v-4.7l14.8-7.4-1.6-12.1 7.4 3.7 2.6-7.4-7.4 1.1-3.7-2.6h-4.2l-6.3-11.1H398s-1.1 3.7-3.2 11.1l-6.9 2.6-25.3-3.7-16.3 3.7c-4.6-4.2-6.7-6.3-6.3-6.3.4 0-.9.9-3.7 2.6l-6.9-20.6v-12.7l-12.7-25.8c.4-12.7.9-19 1.6-19 .7 0 3.2-1.6 7.4-4.7l-4.2-5.3-2.1-15.8 9-13.7 3.2-4.7-5.8-15.8v-36.4L307.3 414h-6.9l-1.1-7.4-8.4-8.4c6.3-6 9.5-8.6 9.5-7.9 0 .7.5-1.9 1.6-7.9l-2.6-6.3c8.1-7.4 12-10.9 11.6-10.5-.4.4.5-1.8 2.6-6.3l-7.9-23.2 10-3.2 9-14.8 2.6 3.7c9.8-3.9 14.8-5.4 14.8-4.7 0 .7.7 2.3 2.1 4.7l-2.1 8.4 17.9 2.6 6.3 12.1h4.7l2.1-26.9 11.1-6.9 10.5 2.1-1.1-12.7 8.4 4.7 7.9-4.7 1.6-15.8-4.2-9c4.9-3.5 5.8-5.3 5.8-5.3l-5.8-5.3s1.2-1.6 5.8-4.7l-4.2-5.8 15.3 4.2 6.3-9 12.7 1.1 10.5 3.7v-4.7h9.5l4.2-3.2-4.2-4.2 2.6-4.7-5.8-1.6-1.6-10-4.7-1.1-3.2 4.7-2.6-4.7 5.8-2.1-3.2-2.6v-5.8H447l-4.7-6.3v-10l-4.2-4.7 10-24.8-2.6-15.3 11.1-10-4.7-8.4c7.7-8.8 11.6-12.1 11.6-12.1s-.8-1.3-2.1-5.8l42.2 12.1 5.3-2.1 13.2 5.3v4.7l9.5 3.2-6.9 8.4v4.7l13.7 7.4 3.7-8.4 3.7 1.1 3.2-2.6 2.6 4.7 10-4.7 15.3 2.6c21.4 6.3 31.6 8.4 31.6 8.4s.7-3.5 3.2-8.4l36.4-21.1 16.9 2.6 28.5-16.3H708l2.6-9.5 20.6-6.9 1.1-4.7 15.8-2.1 17.9 5.8 7.9-1.1 31.6 12.1 31.1 31.1h54.3c21.4 6.7 32.3 10 32.7 10 .4 0 10.4-2.5 30.1-7.4h21.1l39-12.1h16.9l41.1-16.9 4.2-6.9 23.7-4.2 11.1-10.5 20-9.5 10.5-12.1 20.6-2.6 28.5-16.9 11.6-1.1 2.1-4.7h9l3.2 6.9 1.6-4.7c8.4-1.4 12.5-2.1 12.1-2.1-.5 0 46.4 9 45.9 8.4-.4-.4 3 1.9 10 6.9l10.5-4.2 48.5-1.6 19.5-7.4 16.9 1.1 52.2-15.3c18.3-16.5 27.2-24.8 26.9-24.8s.4-1.9 2.1-5.8l4.7 1.1-2.1 7.4 10 2.6 3.2-3.7v4.7l10.5 6.3v5.3l-4.7 6.9 7.9 17.9v3.7l2.6 4.7-97 105.9-79.6 17.4-21.6 39c-2.5 43.2-3.9 64.7-4.2 64.3-.4-.4 6.5 15.6 20.6 48l2.6 49.5-21.1 31.1V442c-4.9 16.5-7.7 24.8-8.4 24.8-1.1 0 0 108.6 0 108.1 0-.4-14.2 27.2-42.7 82.8l-63.3 19.5-687 433.8c-52-9.5-78.6-14.4-79.6-14.8-1.1-.4-13.4-11.6-36.9-33.7l-5.3 5.8c-5.3-2.8-7.7-4.2-7.4-4.2.5 0-8.4 3.7-7.9 3.2s-9.5-19-9.5-20.6v-11.1h-10l-2.6-4.2 5.3-1.1c-6.3-2.1-9.5-3.2-9.5-3.2v-4.2c0-.4-7.9-1.6-23.7-3.7h-6.4z"/>\n    <g class="text-homs">\n      <path fill="#FFF" d="M510.3 598.9v-9.5h-7.8v9.5h-4.6v-22.2h4.6v8.5h7.8v-8.5h4.6v22.2"/>\n      <path d="M513.9 577.7v20.2h-2.6v-9.5h-9.8v9.5h-2.6v-20.2h2.6v8.5h9.8v-8.5h2.6m2-2h-6.6v8.5h-5.8v-8.5h-6.6v24.2h6.6v-9.5h5.8v9.5h6.6v-24.2z"/>\n      <path fill="#FFF" d="M526.3 599.2c-5.9 0-10.1-4.6-10.1-11.3 0-6.8 4.3-11.6 10.4-11.6 5.9 0 10.1 4.6 10.1 11.2 0 8.1-5.2 11.7-10.4 11.7zm.2-18.7c-4 0-5.5 4-5.5 7.4 0 3.5 1.7 7.2 5.4 7.2 3.8 0 5.5-3.7 5.5-7.4.1-3.5-1.6-7.2-5.4-7.2z"/>\n      <path d="M526.6 577.4c5.5 0 9.1 4.2 9.1 10.2 0 7-4.2 10.7-9.4 10.7-5.3 0-9.1-4.1-9.1-10.3 0-6.4 4-10.6 9.4-10.6m-.1 18.7c4.1 0 6.5-3.8 6.5-8.4 0-4-2.1-8.2-6.4-8.2-4.3 0-6.5 4-6.5 8.4-.1 4.3 2.3 8.2 6.4 8.2m.1-20.7c-6.6 0-11.4 5.3-11.4 12.6 0 7.2 4.6 12.3 11.1 12.3 5.7 0 11.4-3.9 11.4-12.7 0-7.2-4.5-12.2-11.1-12.2zm-.1 18.7c-3.1 0-4.4-3.2-4.4-6.2s1.2-6.4 4.5-6.4c3.5 0 4.4 4.1 4.4 6.2 0 3.2-1.4 6.4-4.5 6.4z"/>\n      <path fill="#FFF" d="M555.7 598.9l-.6-9.8c-.1-1-.1-2-.2-3.1-.3.8-.5 1.6-.8 2.4l-3.8 10.5h-3.4l-3.5-10.3c-.2-.7-.5-1.4-.7-2.1 0 1-.1 1.9-.2 2.9l-.6 9.6h-4.5l1.5-22.2h5l3.7 10.4c.5 1.3.8 2.5 1.2 3.6.3-1.1.7-2.3 1.2-3.6l3.8-10.4h5l1.4 22.2h-4.5z"/>\n      <path d="M557.9 577.7l1.3 20.2h-2.5l-.5-8.9c-.2-2.8-.3-6.2-.3-8.7h-.1c-.7 2.4-1.5 4.9-2.6 7.7l-3.6 9.8h-2l-3.3-9.6c-1-2.8-1.8-5.5-2.3-7.9-.1 2.5-.2 5.9-.4 8.9l-.5 8.7h-2.5l1.4-20.2h3.3l3.5 9.8c.8 2.5 1.5 4.7 2 6.8h.1c.5-2 1.2-4.3 2.1-6.8l3.6-9.8h3.3m1.9-2h-6.6l-.5 1.3-3.6 9.8c-.1.3-.2.5-.3.7-.1-.2-.2-.5-.2-.7l-3.5-9.8-.5-1.3h-6.5l-.1 1.9-1.4 20.2-.1 2.1h6.5l.1-1.9.4-6.4 2.3 6.8.5 1.4h4.8l.5-1.3 2.7-7.5.4 7.1.1 1.9h6.5l-.1-2.1-1.3-20.2-.1-2z"/>\n      <path fill="#FFF" d="M567.4 599.2c-2.1 0-4.4-.6-5.7-1.5l-.6-.4 1.2-4.1 1.1.7c1.2.7 2.7 1.2 4.2 1.2 2 0 3.2-.9 3.2-2.4 0-1.2-.5-2.1-3.2-3.1-4-1.4-6-3.6-6-6.7 0-3.8 3.2-6.5 7.5-6.5 2.6 0 4.2.7 5 1.1l.7.4-1.4 4-1-.6c-.7-.4-1.9-.8-3.4-.8-2.1 0-2.8 1.1-2.8 2 0 1.1.5 1.9 3.4 3s5.8 2.8 5.8 6.9c0 3.4-2.5 6.8-8 6.8z"/>\n      <path d="M569.2 577.4c2.1 0 3.6.5 4.5 1l-.7 2.1c-.7-.4-2-1-3.8-1-2.8 0-3.8 1.7-3.8 3 0 1.9 1.2 2.8 4 3.9 3.4 1.3 5.2 3 5.2 5.9 0 3.1-2.3 5.8-7.1 5.8-2 0-4.1-.6-5.2-1.3l.7-2.2c1.2.7 2.9 1.3 4.7 1.3 2.7 0 4.2-1.4 4.2-3.4 0-1.9-1.1-3-3.8-4-3.3-1.2-5.3-2.9-5.3-5.7-.2-3.1 2.4-5.4 6.4-5.4m0-2c-4.9 0-8.5 3.2-8.5 7.5 0 3.5 2.2 6 6.6 7.6 2.5 1 2.5 1.6 2.5 2.1 0 1.2-1.2 1.4-2.2 1.4-1.2 0-2.6-.4-3.6-1l-2.2-1.4-.8 2.5-.7 2.2-.4 1.4 1.2.8c1.5 1 4 1.6 6.3 1.6 6.3 0 9.1-3.9 9.1-7.8 0-4.7-3.4-6.6-6.4-7.8-2.7-1.1-2.7-1.6-2.7-2 0-.6.7-1 1.8-1 1.3 0 2.3.4 2.9.7l2.1 1.1.8-2.3.7-2.1.5-1.6-1.4-.8c-1.6-.7-3.5-1.1-5.6-1.1z"/>\n    </g>\n    <g class="text-aleppo">\n      <path fill="#FFF" d="M580.3 254.3l-2.2-6.4h-5.7l-2.1 6.4h-4.8l7.5-22.2h4.6l7.6 22.2h-4.9zm-3.4-10.4s-1.6-4.8-1.7-4.9c0 .1-.1.2-.1.3l-1.5 4.5h3.3z"/>\n      <path d="M576.9 233.1l6.9 20.2H581l-2.2-6.4h-7.2l-2.1 6.4h-2.7l6.9-20.2h3.2m-4.7 11.8h6.1l-2-5.8c-.4-1.3-.8-2.5-1-3.7h-.1c-.3 1.2-.6 2.4-1 3.7l-2 5.8m6.1-13.8h-5.9l-.5 1.4-6.9 20.2-.9 2.6h6.9l.5-1.4 1.6-5h4.3l1.7 5 .5 1.4h7l-.9-2.6-6.9-20.2-.5-1.4zm-3.3 11.8l.3-.7.3.7h-.6z"/>\n      <path fill="#FFF" d="M585.7 254.3v-22.2h4.6v18h8.7v4.2"/>\n      <path d="M589.3 233.1v18h8.6v2.2h-11.2v-20.2h2.6m2-2h-6.6v24.2H600v-6.2h-8.6v-18h-.1z"/>\n      <path fill="#FFF" d="M599.9 254.3v-22.2h12.9v4.2h-8.3v4.4h7.9v4.2h-7.9v5.2h8.8v4.2"/>\n      <path d="M611.8 233.1v2.2h-8.3v6.4h7.9v2.2h-7.9v7.3h8.8v2.2h-11.4v-20.2h10.9m2-2.1h-14.9v24.2h15.4v-6.2h-8.8v-3.3h7.9v-6.2h-7.9v-2.4h8.3v-6.1z"/>\n      <path fill="#FFF" d="M614.7 254.3v-21.8l.8-.1c1.6-.3 3.3-.4 5.2-.4 2.8 0 4.9.7 6.3 1.9 1.4 1.2 2.1 2.9 2.1 5s-.6 3.8-1.8 5c-1.5 1.6-4 2.5-6.9 2.5h-1.1v7.9h-4.6zm4.6-12c.3 0 .7.1 1.2.1 1.9 0 4.1-.6 4.1-3.3 0-2-1.3-3-3.8-3-.6 0-1.1 0-1.5.1v6.1z"/>\n      <path d="M620.7 233c2.6 0 4.5.6 5.7 1.7 1.1 1 1.8 2.4 1.8 4.2 0 1.8-.5 3.3-1.6 4.3-1.4 1.5-3.6 2.2-6.2 2.2-.8 0-1.5 0-2.1-.2v8.1h-2.6v-20c1.2-.2 2.9-.3 5-.3m-.3 10.3c3.1 0 5.1-1.5 5.1-4.3 0-2.7-1.9-4-4.8-4-1.1 0-2 .1-2.5.2v7.9c.6.2 1.4.2 2.2.2m.3-12.3c-1.9 0-3.7.1-5.3.4l-1.7.3v23.7h6.6v-7.9h.1c3.2 0 5.9-1 7.6-2.9 1.4-1.4 2.1-3.3 2.1-5.7 0-2.3-.9-4.4-2.5-5.7-1.5-1.5-3.9-2.2-6.9-2.2zm-.4 6h.5c2.8 0 2.8 1.3 2.8 2 0 .6 0 2.3-3.1 2.3h-.2V237z"/>\n      <path fill="#FFF" d="M630.6 254.3v-21.8l.8-.1c1.6-.3 3.3-.4 5.2-.4 2.8 0 4.9.7 6.3 1.9 1.4 1.2 2.1 2.9 2.1 5s-.6 3.8-1.8 5c-1.5 1.6-4 2.5-6.9 2.5h-1.1v7.9h-4.6zm4.6-12c.3 0 .7.1 1.2.1 1.9 0 4.1-.6 4.1-3.3 0-2-1.3-3-3.8-3-.6 0-1.1 0-1.5.1v6.1z"/>\n      <path d="M636.6 233c2.6 0 4.5.6 5.7 1.7 1.1 1 1.8 2.4 1.8 4.2 0 1.8-.5 3.3-1.6 4.3-1.4 1.5-3.6 2.2-6.2 2.2-.8 0-1.5 0-2.1-.2v8.1h-2.6v-20c1.3-.2 2.9-.3 5-.3m-.2 10.3c3.1 0 5.1-1.5 5.1-4.3 0-2.7-1.9-4-4.8-4-1.1 0-2 .1-2.5.2v7.9c.6.2 1.3.2 2.2.2m.2-12.3c-1.9 0-3.7.1-5.3.4l-1.7.3v23.7h6.6v-7.9h.1c3.2 0 5.9-1 7.6-2.9 1.4-1.4 2.1-3.3 2.1-5.7 0-2.3-.9-4.4-2.5-5.7-1.5-1.5-3.8-2.2-6.9-2.2zm-.4 6h.5c2.8 0 2.8 1.3 2.8 2 0 .6 0 2.3-3.1 2.3h-.2V237z"/>\n      <path fill="#FFF" d="M655.5 254.7c-5.9 0-10.1-4.6-10.1-11.3 0-6.8 4.3-11.6 10.4-11.6 5.9 0 10.1 4.6 10.1 11.2 0 8.1-5.3 11.7-10.4 11.7zm.1-18.8c-4 0-5.5 4-5.5 7.4 0 3.5 1.7 7.2 5.4 7.2 3.8 0 5.5-3.7 5.5-7.4.1-3.4-1.6-7.2-5.4-7.2z"/>\n      <path d="M655.8 232.8c5.5 0 9.1 4.2 9.1 10.2 0 7-4.2 10.6-9.4 10.6-5.3 0-9.1-4.1-9.1-10.3 0-6.3 4-10.5 9.4-10.5m-.2 18.7c4.1 0 6.5-3.8 6.5-8.4 0-4-2.1-8.2-6.5-8.2-4.3 0-6.5 4-6.5 8.4.1 4.4 2.4 8.2 6.5 8.2m.2-20.7c-6.6 0-11.4 5.3-11.4 12.6 0 7.2 4.6 12.3 11.1 12.3 5.7 0 11.4-3.9 11.4-12.6 0-7.3-4.6-12.3-11.1-12.3zm-.2 18.7c-3.1 0-4.4-3.2-4.4-6.2s1.2-6.4 4.5-6.4c3.5 0 4.5 4.1 4.5 6.2-.1 3.2-1.5 6.4-4.6 6.4z"/>\n    </g>\n    <g class="text-damaskus">\n      <path fill="#FFF" d="M438.8 860c-1.8 0-3.4-.1-4.9-.2l-.9-.1V838l.9-.1c1.9-.3 3.8-.4 5.7-.4 4 0 6.9.9 8.9 2.8 2.1 1.9 3.2 4.6 3.2 8 0 3.5-1.1 6.5-3.2 8.6-2.1 2-5.5 3.1-9.7 3.1zm-1.1-4.1h1.6c5 0 7.6-2.6 7.6-7.6 0-2.1-.6-3.8-1.7-5-1.2-1.2-3.1-1.8-5.5-1.8-.9 0-1.5.1-2.1.1v14.3z"/>\n      <path d="M439.6 838.5c3.7 0 6.4.9 8.2 2.5 1.8 1.6 2.8 4 2.8 7.3s-1 6-2.9 7.9c-1.9 1.9-5 2.9-8.9 2.9-1.9 0-3.4-.1-4.7-.2V839c1.6-.4 3.5-.5 5.5-.5m-.3 18.4c5.6 0 8.6-3.1 8.6-8.6 0-4.8-2.7-7.8-8.2-7.8-1.3 0-2.4.1-3.1.3v16c.8.1 1.7.1 2.7.1m.3-20.4c-1.9 0-3.9.1-5.8.4l-1.7.3v23.4l1.8.2c1.5.2 3.2.3 5 .3 4.5 0 8.1-1.2 10.4-3.5 2.3-2.2 3.5-5.5 3.5-9.3 0-3.7-1.2-6.6-3.5-8.7-2.3-2.1-5.4-3.1-9.7-3.1zm-.9 6.1h1.1c2.2 0 3.8.5 4.8 1.5.9 1 1.4 2.4 1.4 4.2 0 4.4-2.2 6.6-6.6 6.6h-.6v-12.3h-.1z"/>\n      <path fill="#FFF" d="M465.5 859.8l-2.2-6.4h-5.7l-2.1 6.4h-4.8l7.5-22.2h4.6l7.6 22.2h-4.9zm-3.3-10.4s-1.6-4.8-1.7-4.9c0 .1-.1.2-.1.3l-1.5 4.5h3.3z"/>\n      <path d="M462.1 838.6l6.9 20.2h-2.8l-2.2-6.4h-7.2l-2.1 6.4H452l6.9-20.2h3.2m-4.6 11.8h6.1l-2-5.8c-.4-1.3-.8-2.5-1-3.7h-.1c-.3 1.2-.6 2.4-1 3.7l-2 5.8m6.1-13.8h-6l-.5 1.4-6.9 20.2-.9 2.6h6.9l.5-1.4 1.6-5h4.3l1.7 5 .5 1.4h7l-.9-2.6L464 838l-.4-1.4zm-3.4 11.8l.3-.7.3.7h-.6z"/>\n      <path fill="#FFF" d="M488.5 859.8l-.6-9.8c-.1-1-.1-2-.2-3.1-.3.8-.5 1.6-.8 2.4l-3.8 10.5h-3.4l-3.5-10.3c-.2-.7-.5-1.4-.7-2.1 0 1-.1 1.9-.2 2.9l-.6 9.6h-4.5l1.5-22.2h5l3.7 10.4c.5 1.3.8 2.5 1.2 3.6.3-1.1.7-2.3 1.2-3.6l3.8-10.4h5l1.4 22.2h-4.5z"/>\n      <path d="M490.7 838.6l1.3 20.2h-2.5l-.5-8.9c-.2-2.8-.3-6.2-.3-8.7h-.1c-.7 2.4-1.5 4.9-2.6 7.7l-3.6 9.8h-2l-3.3-9.6c-1-2.9-1.8-5.5-2.3-7.9h-.1c-.1 2.5-.2 5.9-.4 8.9l-.5 8.7h-2.5l1.4-20.2h3.3l3.5 9.8c.8 2.5 1.5 4.7 2 6.8h.1c.5-2 1.2-4.3 2.1-6.8l3.6-9.8h3.4m1.9-2H486l-.5 1.3-3.6 9.8c-.1.3-.2.5-.3.7-.1-.2-.2-.5-.2-.7L478 838l-.5-1.3h-6.6l-.1 1.9-1.4 20.2-.1 2.1h6.5l.1-1.9.4-6.4 2.3 6.8.5 1.4h4.8l.5-1.3 2.7-7.5.4 7.1.1 1.9h6.5l-.1-2.1-1.3-20.2-.1-2.1z"/>\n      <path fill="#FFF" d="M507.6 859.8l-2.2-6.4h-5.7l-2.1 6.4h-4.8l7.5-22.2h4.6l7.6 22.2h-4.9zm-3.4-10.4s-1.6-4.8-1.7-4.9c0 .1-.1.2-.1.3l-1.5 4.5h3.3z"/>\n      <path d="M504.2 838.6l6.9 20.2h-2.8l-2.2-6.4H499l-2.1 6.4h-2.7l6.9-20.2h3.1m-4.7 11.8h6.1l-2-5.8c-.4-1.3-.8-2.5-1-3.7h-.1c-.3 1.2-.6 2.4-1 3.7l-2 5.8m6.1-13.8h-5.9l-.5 1.4-6.9 20.2-.9 2.6h6.9l.5-1.4 1.6-5h4.3l1.7 5 .5 1.4h7l-.9-2.6-6.9-20.2-.5-1.4zm-3.3 11.8l.3-.7.3.7h-.6z"/>\n      <path fill="#FFF" d="M518.2 860.1c-2.1 0-4.4-.6-5.7-1.5l-.6-.4 1.2-4.1 1.1.7c1.2.7 2.7 1.2 4.2 1.2 2 0 3.2-.9 3.2-2.5 0-1.2-.5-2.1-3.2-3.1-4-1.4-6-3.6-6-6.7 0-3.8 3.2-6.5 7.5-6.5 2.6 0 4.2.7 5 1.1l.7.4-1.4 4-1-.6c-.7-.4-1.9-.8-3.4-.8-2.1 0-2.8 1.1-2.8 2 0 1.1.5 1.9 3.4 3s5.8 2.8 5.8 6.9c.1 3.5-2.4 6.9-8 6.9z"/>\n      <path d="M520 838.3c2.1 0 3.6.5 4.5 1l-.7 2.1c-.7-.4-2-1-3.8-1-2.8 0-3.8 1.6-3.8 3 0 1.9 1.2 2.8 4 3.9 3.4 1.3 5.2 3 5.2 5.9 0 3.1-2.3 5.8-7.1 5.8-2 0-4.1-.6-5.2-1.3l.7-2.2c1.2.7 2.9 1.3 4.7 1.3 2.7 0 4.2-1.4 4.2-3.5 0-1.9-1.1-3-3.8-4-3.3-1.2-5.3-2.9-5.3-5.7-.1-3 2.5-5.3 6.4-5.3m0-2c-4.9 0-8.5 3.1-8.5 7.5 0 3.5 2.2 6 6.6 7.6 2.5 1 2.5 1.6 2.5 2.1 0 1.2-1.2 1.5-2.2 1.5-1.2 0-2.6-.4-3.6-1l-2.2-1.4-.7 2.5-.7 2.2-.4 1.4 1.2.8c1.5 1 4 1.6 6.3 1.6 6.3 0 9.1-3.9 9.1-7.8 0-4.7-3.4-6.6-6.4-7.8-2.7-1.1-2.7-1.6-2.7-2 0-.6.7-1 1.8-1 1.4 0 2.4.4 2.9.7l2.1 1.1.8-2.3.7-2.1.5-1.6-1.4-.8c-1.7-.8-3.6-1.2-5.7-1.2z"/>\n      <path fill="#FFF" d="M539.5 859.8l-6.2-9.2-.8.9v8.3h-4.6v-22.2h4.6v7.9l6.4-7.9h5.8l-8.2 9.7 8.5 12.5"/>\n      <path d="M542.6 838.6l-7.3 8.6 7.9 11.6h-3.1l-6.7-9.9-1.9 2.2v7.7h-2.6v-20.2h2.6v9.7h.1c.5-.8 1.1-1.5 1.6-2.2l6.2-7.6h3.2m4.3-1.9h-8.5l-.6.7-4.3 5.3v-6h-6.6v24.2h6.6v-8.2l4.9 7.3.6.9h8l-2.1-3.1-7-10.4 6.3-7.4 2.7-3.3z"/>\n      <path fill="#FFF" d="M552.4 860.2c-5.2 0-8.3-3.5-8.3-9.6v-12.9h4.6v13c0 2.5.6 5.4 3.7 5.4 1 0 3.9 0 3.9-5.4v-13h4.6v12.8c.1 6.1-3.1 9.7-8.5 9.7z"/>\n      <path d="M560 838.6v11.8c0 6.2-3.3 8.8-7.6 8.8-4.1 0-7.3-2.4-7.3-8.6v-11.9h2.6v12c0 4.5 2 6.4 4.7 6.4 3 0 4.9-2 4.9-6.4v-12h2.7m2-2.1h-6.6v14c0 4.4-2 4.4-2.9 4.4-.7 0-2.7 0-2.7-4.4v-14h-6.6v13.9c0 9.6 6.5 10.6 9.3 10.6 6 0 9.6-4 9.6-10.8v-13.7h-.1z"/>\n      <path fill="#FFF" d="M568.7 860.1c-2.1 0-4.4-.6-5.7-1.5l-.6-.4 1.2-4.1 1.1.7c1.2.7 2.7 1.2 4.2 1.2 2 0 3.2-.9 3.2-2.5 0-1.2-.5-2.1-3.2-3.1-4-1.4-6-3.6-6-6.7 0-3.8 3.2-6.5 7.5-6.5 2.6 0 4.2.7 5 1.1l.7.4-1.4 4-1-.6c-.7-.4-1.9-.8-3.4-.8-2.1 0-2.8 1.1-2.8 2 0 1.1.5 1.9 3.4 3s5.8 2.8 5.8 6.9c0 3.5-2.4 6.9-8 6.9z"/>\n      <path d="M570.5 838.3c2.1 0 3.6.5 4.5 1l-.7 2.1c-.7-.4-2-1-3.8-1-2.8 0-3.8 1.6-3.8 3 0 1.9 1.2 2.8 4 3.9 3.4 1.3 5.2 3 5.2 5.9 0 3.1-2.3 5.8-7.1 5.8-2 0-4.1-.6-5.2-1.3l.7-2.2c1.2.7 2.9 1.3 4.7 1.3 2.7 0 4.2-1.4 4.2-3.5 0-1.9-1.1-3-3.8-4-3.3-1.2-5.3-2.9-5.3-5.7-.2-3 2.4-5.3 6.4-5.3m0-2c-4.9 0-8.5 3.1-8.5 7.5 0 3.5 2.2 6 6.6 7.6 2.5 1 2.5 1.6 2.5 2.1 0 1.2-1.2 1.5-2.2 1.5-1.2 0-2.6-.4-3.6-1l-2.2-1.4-.7 2.5-.7 2.2-.4 1.4 1.2.8c1.5 1 4 1.6 6.3 1.6 6.3 0 9.1-3.9 9.1-7.8 0-4.7-3.4-6.6-6.4-7.8-2.7-1.1-2.7-1.6-2.7-2 0-.6.7-1 1.8-1 1.4 0 2.4.4 2.9.7l2.1 1.1.8-2.3.7-2.1.5-1.6-1.4-.8c-1.7-.8-3.6-1.2-5.7-1.2z"/>\n    </g>\n    <g class="text-maskalah">\n      <path fill="#FFF" d="M687.5 351l-.6-9.8c-.1-1-.1-2-.2-3.1-.3.8-.5 1.6-.8 2.4l-3.8 10.5h-3.4l-3.5-10.3c-.2-.7-.5-1.4-.7-2.1 0 1-.1 1.9-.2 2.9l-.6 9.6h-4.5l1.5-22.2h5l3.7 10.4c.5 1.3.8 2.5 1.2 3.6.3-1.1.7-2.3 1.2-3.6l3.8-10.4h5L692 351h-4.5z"/>\n      <path d="M689.7 329.8L691 350h-2.5l-.5-8.9c-.2-2.8-.3-6.2-.3-8.7h-.1c-.7 2.4-1.5 4.9-2.6 7.7l-3.6 9.8h-2l-3.3-9.6c-1-2.9-1.8-5.5-2.3-7.9h-.1c-.1 2.5-.2 5.9-.4 8.9l-.5 8.7h-2.5l1.4-20.2h3.3l3.5 9.8c.8 2.5 1.5 4.7 2 6.8h.1c.5-2 1.2-4.3 2.1-6.8l3.6-9.8h3.4m1.9-2H685l-.5 1.3-3.6 9.8c-.1.3-.2.5-.3.7-.1-.2-.2-.5-.2-.7l-3.5-9.8-.5-1.3h-6.6l-.1 1.9-1.4 20.2-.1 2.1h6.5l.1-1.9.4-6.4 2.3 6.8.5 1.4h4.8l.5-1.3 2.7-7.5.4 7.1.1 1.9h6.5l-.1-2.1-1.3-20.2v-2z"/>\n      <path fill="#FFF" d="M706.6 351l-2.2-6.4h-5.7l-2.1 6.4h-4.8l7.5-22.2h4.6l7.6 22.2h-4.9zm-3.4-10.4s-1.6-4.8-1.7-4.9c0 .1-.1.2-.1.3l-1.5 4.5h3.3z"/>\n      <path d="M703.2 329.8l6.9 20.2h-2.8l-2.2-6.4H698l-2.1 6.4h-2.7l6.9-20.2h3.1m-4.7 11.8h6.1l-2-5.8c-.4-1.3-.8-2.5-1-3.7h-.1c-.3 1.2-.6 2.4-1 3.7l-2 5.8m6.1-13.8h-6l-.5 1.4-6.9 20.2-.9 2.6h6.9l.5-1.4 1.6-5h4.3l1.7 5 .5 1.4h7l-.9-2.6-6.9-20.2-.4-1.4zm-3.3 11.8l.3-.7.3.7h-.6z"/>\n      <path fill="#FFF" d="M717.2 351.3c-2.1 0-4.4-.6-5.7-1.5l-.6-.4 1.2-4.1 1.1.7c1.2.7 2.7 1.2 4.2 1.2 2 0 3.2-.9 3.2-2.5 0-1.2-.5-2.1-3.2-3.1-4-1.4-6-3.6-6-6.7 0-3.8 3.2-6.5 7.5-6.5 2.6 0 4.2.7 5 1.1l.7.4-1.4 4-1-.6c-.7-.4-1.9-.8-3.4-.8-2.1 0-2.8 1.1-2.8 2 0 1.1.5 1.9 3.4 3s5.8 2.8 5.8 6.9c.1 3.5-2.4 6.9-8 6.9z"/>\n      <path d="M719 329.4c2.1 0 3.6.5 4.5 1l-.7 2.1c-.7-.4-2-1-3.8-1-2.8 0-3.8 1.6-3.8 3 0 1.9 1.2 2.8 4 3.9 3.4 1.3 5.2 3 5.2 5.9 0 3.1-2.3 5.8-7.1 5.8-2 0-4.1-.6-5.2-1.3l.7-2.2c1.2.7 2.9 1.3 4.7 1.3 2.7 0 4.2-1.4 4.2-3.5 0-1.9-1.1-3-3.8-4-3.3-1.2-5.3-2.9-5.3-5.7-.1-2.9 2.5-5.3 6.4-5.3m0-2c-4.9 0-8.5 3.1-8.5 7.5 0 3.5 2.2 6 6.6 7.6 2.5 1 2.5 1.6 2.5 2.1 0 1.2-1.2 1.5-2.2 1.5-1.2 0-2.6-.4-3.6-1l-2.2-1.4-.7 2.5-.7 2.2-.4 1.4 1.2.8c1.5 1 4 1.6 6.3 1.6 6.3 0 9.1-3.9 9.1-7.8 0-4.7-3.4-6.6-6.4-7.8-2.7-1.1-2.7-1.6-2.7-2 0-.6.7-1 1.8-1 1.4 0 2.4.4 2.9.7l2.1 1.1.8-2.3.7-2.1.5-1.6-1.4-.8c-1.7-.7-3.6-1.2-5.7-1.2z"/>\n      <path fill="#FFF" d="M738.5 351l-6.2-9.3-.8.9v8.4h-4.7v-22.2h4.7v7.8l6.3-7.8h5.9l-8.2 9.6L744 351"/>\n      <path d="M741.6 329.8l-7.3 8.6 7.9 11.6H739l-6.7-9.9-1.9 2.2v7.7h-2.6v-20.2h2.6v9.7h.1c.5-.8 1.1-1.5 1.6-2.2l6.2-7.6h3.3m4.3-1.9h-8.5l-.6.7-4.3 5.3v-6h-6.6V352h6.6v-8.2l4.9 7.3.6.9h8l-2.1-3.1-7-10.4 6.3-7.4 2.7-3.3z"/>\n      <path fill="#FFF" d="M756.3 351l-2.2-6.4h-5.7l-2.1 6.4h-4.8l7.5-22.2h4.6l7.6 22.2h-4.9zm-3.4-10.4s-1.6-4.8-1.7-4.9c0 .1-.1.2-.1.3l-1.5 4.5h3.3z"/>\n      <path d="M752.9 329.8l6.9 20.2H757l-2.2-6.4h-7.2l-2.1 6.4h-2.7l6.9-20.2h3.2m-4.7 11.8h6.1l-2-5.8c-.4-1.3-.8-2.5-1-3.7h-.1c-.3 1.2-.6 2.4-1 3.7l-2 5.8m6.1-13.8h-5.9l-.5 1.4-6.9 20.2-.9 2.6h6.9l.5-1.4 1.6-5h4.3l1.7 5 .5 1.4h7l-.9-2.6-6.9-20.2-.5-1.4zm-3.3 11.8l.3-.7.3.7h-.6z"/>\n      <path fill="#FFF" d="M774.7 351l-6.7-10.7c-.7-1.1-1.3-2.1-1.9-3.1V351h-4.5v-22.2h4.4l6.8 10.7c.6.9 1.1 1.8 1.6 2.6v-13.4h4.5V351h-4.2z"/>\n      <path d="M777.9 329.8V350h-2.6l-6.4-10.3c-1.4-2.2-2.8-4.6-3.8-6.7h-.1c.1 2.6.2 5 .2 8.3v8.6h-2.5v-20.2h2.8l6.5 10.2c1.5 2.4 2.7 4.5 3.6 6.6h.1c-.2-2.7-.3-5.2-.3-8.3v-8.5h2.5m2-1.9h-6.5v10.7l-6.2-9.8-.6-.9h-5.9V352h6.5v-11.1l6.4 10.2.6.9h5.7v-24.2z"/>\n      <path fill="#FFF" d="M794.4 351l-2.2-6.4h-5.7l-2.1 6.4h-4.8l7.5-22.2h4.6l7.6 22.2h-4.9zm-3.4-10.4s-1.6-4.8-1.7-4.9c0 .1-.1.2-.1.3l-1.5 4.5h3.3z"/>\n      <path d="M791 329.8l6.9 20.2h-2.8l-2.2-6.4h-7.2l-2.1 6.4H781l6.9-20.2h3.1m-4.7 11.8h6.1l-2-5.8c-.4-1.3-.8-2.5-1-3.7h-.1c-.3 1.2-.6 2.4-1 3.7l-2 5.8m6.1-13.8h-5.9l-.5 1.4-6.9 20.2-.9 2.6h6.9l.5-1.4 1.6-5h4.3l1.7 5 .5 1.4h7l-.9-2.6-6.9-20.2-.5-1.4zm-3.3 11.8l.3-.7.3.7h-.6z"/>\n      <path fill="#FFF" d="M812.3 351v-9.5h-7.8v9.5h-4.6v-22.2h4.6v8.4h7.8v-8.4h4.6V351"/>\n      <path d="M815.9 329.8V350h-2.6v-9.5h-9.8v9.5h-2.6v-20.2h2.6v8.5h9.8v-8.5h2.6m2-2h-6.6v8.5h-5.8v-8.5h-6.6V352h6.6v-9.5h5.8v9.5h6.6v-24.2z"/>\n    </g>\n  </svg>\n  ';
};

var mobileMapSVG = function mobileMapSVG(id) {

  return '\n    <svg class="' + _map2.default['mobile-map'] + '" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1600 1302.3">\n      <pattern x="-1682" y="-1060.6" width="90" height="90" patternUnits="userSpaceOnUse" id="a" viewBox="0 -90 90 90" overflow="visible">\n        <path fill="none" d="M0 0h90v-90H0z"/>\n        <path fill="none" d="M72.2 0L90-17.8v-5.3L66.9 0zM80.4 0L90-9.6v-5.3L75.1 0zM1.4-90L0-88.6v5.4L6.8-90zM9.6-90L0-80.4v5.3L14.9-90zM83.2-90L0-6.8v5.4L88.6-90zM39.5 0L90-50.5v-5.4L34.1 0zM75.1-90L0-14.9v5.3L80.4-90zM47.7 0L90-42.3v-5.4L42.3 0zM31.3 0L90-58.7V-64L26 0zM17.8-90L0-72.2v5.3L23.1-90zM23.1 0L90-66.9v-5.3L17.8 0zM55.9 0L90-34.1v-5.4L50.5 0zM64 0l26-26v-5.3L58.7 0zM88.6 0L90-1.4v-5.4L83.2 0zM34.1-90L0-55.9v5.4L39.5-90zM42.3-90L0-47.7v5.4L47.7-90zM50.5-90L0-39.5v5.4L55.9-90zM14.9 0L90-75.1v-5.3L9.6 0zM58.7-90L0-31.3v5.3l64-64zM90-83.2v-5.4L1.4 0h5.4zM26-90L0-64v5.3L31.3-90zM66.9-90L0-23.1v5.3L72.2-90z"/>\n        <path fill="#FDD42F" d="M0-90v1.4L1.4-90z"/>\n        <path fill="#333" d="M6.8-90L0-83.2v2.8L9.6-90zM14.9-90L0-75.1v2.9L17.8-90zM23.1-90L0-66.9v2.9l26-26zM31.3-90L0-58.7v2.8L34.1-90zM39.5-90L0-50.5v2.8L42.3-90zM47.7-90L0-42.3v2.8L50.5-90zM55.9-90L0-34.1v2.8L58.7-90zM64-90L0-26v2.9L66.9-90zM72.2-90L0-17.8v2.9L75.1-90zM80.4-90L0-9.6v2.8L83.2-90zM90-90h-1.4L0-1.4V0h1.4L90-88.6zM9.6 0L90-80.4v-2.8L6.8 0zM17.8 0L90-72.2v-2.9L14.9 0zM26 0l64-64v-2.9L23.1 0zM34.1 0L90-55.9v-2.8L31.3 0zM42.3 0L90-47.7v-2.8L39.5 0zM50.5 0L90-39.5v-2.8L47.7 0zM58.7 0L90-31.3v-2.8L55.9 0zM66.9 0L90-23.1V-26L64 0zM75.1 0L90-14.9v-2.9L72.2 0zM83.2 0L90-6.8v-2.8L80.4 0z"/>\n        <path fill="#FDD42F" d="M90 0v-1.4L88.6 0z"/>\n      </pattern>\n      <path opacity=".8" fill="#A4CD44" d="M661.3 1164.5h45.1v45.1h-45.1z"/>\n      <path opacity=".8" fill="#FDD42F" d="M331.6 1164.5h45.1v45.1h-45.1z"/>\n      <g fill="#FFF">\n        <path d="M413.6 1170.2h4.4v16.3h.2c.9-1.3 1.8-2.5 2.6-3.6l10.3-12.7h5.4l-12.2 14.3 13.2 19.4h-5.2l-11.1-16.6-3.2 3.7v12.9h-4.4v-33.7zM460.5 1197.3c0 2.5 0 4.7.2 6.6h-3.9l-.2-4h-.1c-1.2 2-3.7 4.5-8 4.5-3.8 0-8.4-2.1-8.4-10.6v-14.2h4.4v13.4c0 4.6 1.4 7.7 5.4 7.7 3 0 5-2 5.8-4 .2-.6.4-1.5.4-2.2v-14.9h4.4v17.7zM467.8 1187.3c0-2.8 0-5.3-.2-7.5h3.9l.1 4.8h.2c1.1-3.2 3.8-5.3 6.7-5.3.5 0 .9.1 1.2.2v4.2c-.4-.1-.9-.2-1.5-.2-3.1 0-5.3 2.4-5.9 5.7-.1.6-.2 1.3-.2 2.1v12.9h-4.3v-16.9zM504.5 1168.4v29.3c0 2.1 0 4.6.2 6.2h-4l-.2-4.2h-.1c-1.3 2.7-4.3 4.8-8.2 4.8-5.9 0-10.4-5-10.4-12.3 0-8 5-13 10.9-13 3.7 0 6.2 1.8 7.3 3.7h.1v-14.5h4.4zm-4.4 21.2c0-.6 0-1.3-.2-1.9-.7-2.8-3-5.1-6.4-5.1-4.5 0-7.2 4-7.2 9.4 0 4.9 2.4 9 7.2 9 3 0 5.7-2 6.5-5.3.2-.6.2-1.2.2-1.9v-4.2zM514.3 1192.6c.1 6 3.9 8.4 8.3 8.4 3.1 0 5-.5 6.7-1.2l.8 3.2c-1.6.7-4.2 1.5-8.1 1.5-7.5 0-11.9-4.9-11.9-12.2 0-7.3 4.3-13.1 11.4-13.1 7.9 0 10 7 10 11.4 0 .9-.1 1.6-.1 2h-17.1zm12.9-3.1c0-2.8-1.1-7.2-6.1-7.2-4.5 0-6.4 4.1-6.8 7.2h12.9zM536.9 1187.3c0-2.8 0-5.3-.2-7.5h3.9l.1 4.8h.2c1.1-3.2 3.8-5.3 6.7-5.3.5 0 .9.1 1.2.2v4.2c-.4-.1-.9-.2-1.5-.2-3.1 0-5.3 2.4-5.9 5.7-.1.6-.2 1.3-.2 2.1v12.9h-4.3v-16.9zM555.2 1192.6c.1 6 3.9 8.4 8.3 8.4 3.1 0 5-.5 6.7-1.2l.8 3.2c-1.6.7-4.2 1.5-8.1 1.5-7.5 0-11.9-4.9-11.9-12.2 0-7.3 4.3-13.1 11.4-13.1 7.9 0 10 7 10 11.4 0 .9-.1 1.6-.1 2h-17.1zm12.9-3.1c0-2.8-1.1-7.2-6.1-7.2-4.5 0-6.4 4.1-6.8 7.2h12.9z"/>\n      </g>\n      <path opacity=".8" fill="#6D6E71" d="M1163.6 1164.5h45.1v45.1h-45.1z"/>\n      <g fill="#FFF">\n        <path d="M1242.9 1170.2v33.7h-4.4v-33.7h4.4zM1249.9 1198.6c2 1.2 4.8 2.2 7.8 2.2 4.5 0 7-2.3 7-5.8 0-3.2-1.8-5-6.3-6.7-5.5-2-8.9-4.8-8.9-9.6 0-5.2 4.4-9.2 10.9-9.2 3.5 0 6 .8 7.5 1.7l-1.2 3.5c-1.1-.6-3.4-1.6-6.4-1.6-4.6 0-6.4 2.8-6.4 5.1 0 3.2 2.1 4.7 6.7 6.5 5.7 2.2 8.6 5 8.6 9.9 0 5.2-3.8 9.7-11.8 9.7-3.2 0-6.8-1-8.6-2.2l1.1-3.5z"/>\n      </g>\n      <g fill="#FFF">\n        <path d="M767.7 1186.7c0 11.6-7 17.8-15.7 17.8-8.9 0-15.2-6.9-15.2-17.1 0-10.7 6.7-17.7 15.7-17.7 9.2 0 15.2 7 15.2 17zm-26.2.6c0 7.2 3.9 13.7 10.8 13.7s10.8-6.4 10.8-14c0-6.7-3.5-13.7-10.8-13.7-7.2-.1-10.8 6.6-10.8 14zM773.2 1187.6c0-3.1-.1-5.6-.2-7.9h4l.2 4.2h.1c1.8-3 4.7-4.7 8.6-4.7 5.9 0 10.3 5 10.3 12.3 0 8.7-5.3 13-11 13-3.2 0-6-1.4-7.5-3.8h-.1v13.2h-4.4v-26.3zm4.3 6.5c0 .7.1 1.2.2 1.8.8 3.1 3.5 5.2 6.6 5.2 4.7 0 7.4-3.8 7.4-9.4 0-4.8-2.5-9-7.2-9-3 0-5.8 2.1-6.7 5.5-.2.5-.3 1.2-.3 1.8v4.1zM801.6 1187.6c0-3.1-.1-5.6-.2-7.9h4l.2 4.2h.1c1.8-3 4.7-4.7 8.6-4.7 5.9 0 10.3 5 10.3 12.3 0 8.7-5.3 13-11 13-3.2 0-6-1.4-7.5-3.8h-.1v13.2h-4.4v-26.3zm4.4 6.5c0 .7.1 1.2.2 1.8.8 3.1 3.5 5.2 6.6 5.2 4.7 0 7.4-3.8 7.4-9.4 0-4.8-2.5-9-7.2-9-3 0-5.8 2.1-6.7 5.5-.2.5-.3 1.2-.3 1.8v4.1zM830.1 1187.3c0-2.8 0-5.3-.2-7.5h3.9l.1 4.8h.2c1.1-3.2 3.8-5.3 6.7-5.3.5 0 .9.1 1.2.2v4.2c-.4-.1-.9-.2-1.5-.2-3.1 0-5.3 2.4-5.9 5.7-.1.6-.2 1.3-.2 2.1v12.9H830v-16.9zM862.2 1180.9l2.1-3 1.9 1.4-2.1 3.1c2.4 2.3 3.7 5.5 3.7 9.3 0 8.9-6.2 12.9-11.8 12.9-2.2 0-4.5-.5-6.2-1.7l-2.2 3.1-1.9-1.5 2.1-3c-2.4-2.2-3.8-5.4-3.8-9.4 0-8 5.3-12.8 11.9-12.8 2.4-.1 4.5.5 6.3 1.6zm-2 3c-1.1-.9-2.5-1.5-4.2-1.5-5.4 0-7.6 5-7.6 9.4 0 2.1.5 4.3 1.8 6.1h.1l9.9-14zm-8.4 15.9c1.1 1 2.5 1.4 4 1.4 4.6 0 7.7-4 7.7-9.4 0-1.7-.4-4-1.7-5.9h-.1l-9.9 13.9zM873.4 1187.3c0-2.8 0-5.3-.2-7.5h3.9l.1 4.8h.2c1.1-3.2 3.8-5.3 6.7-5.3.5 0 .9.1 1.2.2v4.2c-.4-.1-.9-.2-1.5-.2-3.1 0-5.3 2.4-5.9 5.7-.1.6-.2 1.3-.2 2.1v12.9h-4.3v-16.9zM889.1 1199.4c1.3.8 3.6 1.8 5.8 1.8 3.2 0 4.7-1.6 4.7-3.6 0-2.1-1.2-3.2-4.5-4.5-4.4-1.5-6.4-4-6.4-6.9 0-3.9 3.2-7.1 8.4-7.1 2.5 0 4.6.7 6 1.5l-1.1 3.2c-.9-.6-2.7-1.4-5-1.4-2.6 0-4 1.5-4 3.3 0 2 1.5 2.9 4.6 4.1 4.2 1.6 6.3 3.7 6.3 7.3 0 4.2-3.3 7.2-9 7.2-2.7 0-5.1-.7-6.8-1.7l1-3.2zM930.4 1179.7c-.1 1.8-.2 3.7-.2 6.7v14.1c0 5.5-1.1 9-3.5 11.1-2.4 2.2-5.8 2.9-8.8 2.9-2.9 0-6.1-.7-8.1-2l1.1-3.3c1.6 1 4.1 1.9 7.1 1.9 4.5 0 7.8-2.3 7.8-8.5v-2.7h-.1c-1.4 2.2-4 4.1-7.7 4.1-6 0-10.3-5.1-10.3-11.8 0-8.2 5.3-12.9 10.9-12.9 4.2 0 6.5 2.2 7.6 4.2h.1l.2-3.7h3.9zm-4.6 9.6c0-.8 0-1.4-.2-2-.8-2.5-3-4.7-6.2-4.7-4.2 0-7.2 3.6-7.2 9.2 0 4.8 2.4 8.7 7.2 8.7 2.7 0 5.2-1.7 6.1-4.5.2-.8.3-1.6.3-2.4v-4.3zM937.2 1187.3c0-2.8 0-5.3-.2-7.5h3.9l.1 4.8h.2c1.1-3.2 3.8-5.3 6.7-5.3.5 0 .9.1 1.2.2v4.2c-.4-.1-.9-.2-1.5-.2-3.1 0-5.3 2.4-5.9 5.7-.1.6-.2 1.3-.2 2.1v12.9h-4.3v-16.9zM973.8 1197.3c0 2.5 0 4.7.2 6.6h-3.9l-.2-4h-.1c-1.2 2-3.7 4.5-8 4.5-3.8 0-8.4-2.1-8.4-10.6v-14.2h4.4v13.4c0 4.6 1.4 7.7 5.4 7.7 3 0 5-2 5.8-4 .2-.6.4-1.5.4-2.2v-14.9h4.4v17.7zM981.1 1187.6c0-3.1-.1-5.6-.2-7.9h4l.2 4.2h.1c1.8-3 4.7-4.7 8.6-4.7 5.9 0 10.3 5 10.3 12.3 0 8.7-5.3 13-11 13-3.2 0-6-1.4-7.5-3.8h-.1v13.2h-4.4v-26.3zm4.3 6.5c0 .7.1 1.2.2 1.8.8 3.1 3.5 5.2 6.6 5.2 4.7 0 7.4-3.8 7.4-9.4 0-4.8-2.5-9-7.2-9-3 0-5.8 2.1-6.7 5.5-.2.5-.3 1.2-.3 1.8v4.1zM1009.5 1187.6c0-3.1-.1-5.6-.2-7.9h4l.2 4.2h.1c1.8-3 4.7-4.7 8.6-4.7 5.9 0 10.3 5 10.3 12.3 0 8.7-5.3 13-11 13-3.2 0-6-1.4-7.5-3.8h-.1v13.2h-4.4v-26.3zm4.4 6.5c0 .7.1 1.2.2 1.8.8 3.1 3.5 5.2 6.6 5.2 4.7 0 7.4-3.8 7.4-9.4 0-4.8-2.5-9-7.2-9-3 0-5.8 2.1-6.7 5.5-.2.5-.3 1.2-.3 1.8v4.1zM1040.4 1192.6c.1 6 3.9 8.4 8.3 8.4 3.1 0 5-.5 6.7-1.2l.8 3.2c-1.6.7-4.2 1.5-8.1 1.5-7.5 0-11.9-4.9-11.9-12.2 0-7.3 4.3-13.1 11.4-13.1 7.9 0 10 7 10 11.4 0 .9-.1 1.6-.1 2h-17.1zm12.9-3.1c0-2.8-1.1-7.2-6.1-7.2-4.5 0-6.4 4.1-6.8 7.2h12.9zM1063 1187.3c0-2.8 0-5.3-.2-7.5h3.9l.1 4.8h.2c1.1-3.2 3.8-5.3 6.7-5.3.5 0 .9.1 1.2.2v4.2c-.4-.1-.9-.2-1.5-.2-3.1 0-5.3 2.4-5.9 5.7-.1.6-.2 1.3-.2 2.1v12.9h-4.3v-16.9z"/>\n      </g>\n      <path fill="none" stroke="#FFF" stroke-width="4" stroke-miterlimit="10" d="M549.3 259.5l46 6.3 31.5 4 21.5-5.1 26.5 14.1 17.5 6 8.3 15.2 8.7 3 6.6 12.6"/>\n      <pattern id="b" xlink:href="#a" patternTransform="translate(1862 713.985)"/>\n      <path fill="none" stroke="#FFF" stroke-width="4" stroke-miterlimit="10" d="M549.3 259.5l27.5 4 14 22.3 26 15 15.8 14.8-2.5 18.7-6 11 5.2 9.9 16.3 5 12.7 31.5 13.8 22 7.6 18.1-19.4 14.4-19.6 7.9-29.9 11.6-19.5 2.5-13.4 8.1-15.6 17.9-9.4 1.5-7.6 5-9.5 24.7-24.5 28.8s-39.2 30.1-38.7 29.3"/>\n      <path opacity=".8" fill="#FDD42F" d="M480.4 227.5l10.9-1.7 6 1.7 9.5 2.6 9 10.2 9.5-6 1-9.7-7.4-4.3-1.3-9 12.7-5 19 5 25 12 22-3-9.4-16.7-30.8-2.6-6.8-11.6-25-21.8-.8-13.3.3-5.8 5.9-7.6-8.4-2.8-.6-5.4L509 128l-5.3 2.2-41-11.7.7 4.6-10.5 12.3 4.8 8.5-11.3 10.1 2.4 15.3-9.8 24.2 3.9 4.7.2 10 3.9 5.8 4.6-.2.2 6.8 3.5 2.7-5.9 2.4 1.3 2.5 3.2-2.9 6.5 2.2 12.2.8"/>\n      <pattern id="c" xlink:href="#a" patternTransform="translate(1862 713.985)"/>\n      <path fill="url(#c)" d="M627.8 591.8c.2 0 .1-.1 0-.2-.3.1-.3.2 0 .2z"/>\n      <path fill="#FDD42F" d="M547.6 247.8v-4.5l6.8-4.7 3.7 7v3.2h-3.7l-1.1-1"/>\n      <path opacity=".8" fill="#A4CD44" d="M429.5 1099.2c1.4-2.9 12.7-22.9 12.7-22.9l-12.7-34 6.4-9.3-3.6-9.3-14 9.3-8.7-4.7 4-8.7-13.3-41.3 11.3-6.7 9.7-11.3 16.3-2v-10.7L421.3 933l-3 8-22.3 14.7-5.4 16 5.4 32.7-13 11.8-16.6 24.9-9.4-4.7 9.4-13.3 8.6-18-12.7-8 10.7-14-.7-24.7-11.3-9.3.7-16-12.7-11.7-10 3.7-18.7 5.3-4-18.7-10-9.3 2.7 14.7-2.7 16.7 7.3 14.7 10.7 24.7-8.7 14 28.7 4v22.7l-17.3-2.7-3.5 10.7 6 1.2v4.2l11.4 3.2-5.8 1.8 1.8 3.5 10.3-1-.8 12.1 10.7 20.3 6.7-2.9 7.8 3.7 4.8-5.3 36.9 33.7 16.2 2.8zM523.5 154.3l.8 13.3 16.7 14.7 8.3 7.1 6.8 11.6 30.8 2.6 9.4 16.7 12.6 6.7 14.7-6v-9.7l7.3 3.4 5.4 2.6 4.3 6.3 15-9.3-1.9-12.4-16.9-17.6 13.5-6h10v-14h7v-9l9-5 19.8 4.8 6.7-3.3 5 7 12.1-9.5-11.1-29.5h-15.3l-28.8 16.4-16.5-2.8-36.1 20.8-3.3 8.8-32.1-8.6-15.2-2.6L551 157l-2.5-4.4-2.7 2.1-3.3-1.1-3.9 8.8"/>\n      <path opacity=".8" fill="#6D6E71" d="M1312 338l-18.9-48.4s5.4-66.4 4.2-64.2l11.7-21.1h-13.2l-7.5 17.8-8.1 19.2 3.1 26.5-14.1 19.8-8.9 12.7-28.2 8.9-3.8 12.6-38.5-4.2-22.8 6.2-39.9 2.8-39.4 10.6-32.3 16.6 3.8 16.4-18.5.5-5.8-18.9-12-6.3-16.5-2.6-15.2-.4-.6 21.2 3.5 20-25 10.5-21.5 1v-18l-16.5-3.5-6.5 9.5-20.5 10.5s0 8 .5 10.5-9.5-1-12 0-18.8 22.5-18.8 22.5l-5.2 27.5h-13.5l-3.4-8.5-26.6-10-10.5-21-24 1 1.5-4s-12.5-5.5-14-5-12.5 10.5-12.5 10.5l-17.8 20-31-6-10.7 14h-21.5c1.5 0-47.5 20.5-47.5 20.5l-3.3 9.5-12.2-3.5-16.2 6-16.8-6-8 8 3 9-10 4.5-3 21 5 11.2s.5 6.8-2.5 8.3 13.5 0 13.5 0 5 11 3 11-3 24.5-3 24.5l5.5 15 13.3 15.1 2.2-6.6-2.2-9.2s21.2 6.9 23.1 8c1.4-.8 12.9-4 12.9-4l13.2 2.2 3-5.5 2-12-5-8v-11.1l11-11.9 21.5-12.5 20.5-3.3s18 6.8 16.5 6.8 1.5 15 1.5 15l-8.8 16.5 4 8 5.8 15.8h21.2l48.8-22.3 9 4 38.5-16.1 24-8.4 3.5 25.5-11.5 44.5 10 9.5 45 6.7h81l71.5 20.8 9-4 5 10.5h9l2.5 10 88.3 8.3 62.6-19 41.7-83.3-.1-106.7 8.6-25.6-.5-23.2 21.6-31.6-3.3-49.1zm-14.6-112.6c-.1.1-.1.1 0 0z"/>\n      <path fill="#A4CD44" d="M942.6 771.3s-68.3-16-69.6-13-32.7-23.3-32.7-23.3l-38 5.9-6 7.4-18 20-63.3 5.3-3 12.4 20.7 20.2v6l-53.3-18-46.3 38-19.7 37 7 21 7 23 9 20-24 11-7.7-29-24.3-21-10.5-25h-44.5l-49.7 39.2-1.7 11.2 8.3 11.7v22l30 21h37l14 10 24-10 1 26.5 16.3 18.5-34.8 13-54.2 29.3 9 29.2 450.1-284.2-32.1-35.3zM459.9 227.3l-.1-.3c-.7.1-.6.2.1.3zm170.4 168c2 0-7.5-25.5-7.5-25.5l-15-14.5-6.5-9.5 10.5-15.5 4.5-10.7-16-8-11.5 8-10.5-4-2-20.8-12 7-6.3 7.3 1 6.5-9.7.7-16-.7-6.5-11.3 7-9.5-2.5-4 8.5-3.2.2-15.1 4.2-5.2-4.3-3.8-3-15.7 9.8-6 4.8-8.2-12.2-16.3-12.5 2.5-1.5 14.5-9.5 6-9-10.2-15.5-4.3-18.7 2.5s-10.2-.5-12.7-1l1.4 8.5 5.9 2-2.8 4.8 4.8 4.3-5.4 4.1-8.8-.1-.1 5.2-11.7-4.2-12.1-.8-6.4 8.9-13.3-3.7 2.7 4.4-5.2 4.6 5.1 5.2-5.4 5.6 4.2 8.3-1.7 16.8-8.9 5.1-7.3-4.1 1.1 12.2-11.2-2.6-10.4 6.7-2.1 27-6.4.3s3 5.2 4.5 5.7 15 8 15 8l18.5 6.5 3 40v30.5l19.5-5 14.5 1.5v24.5h9.9l7.6 5.5 10.3-6.5 2-12.7 12.2-4.3h12.5l15-6 11.5 11.5 15 6.3h16.5l19.5 11.7 13 2.5 12-9 15.5-1 17-16 6-19.5c-.1.3-8.1-24.7-6.1-24.7zM462.3 573.8l-3-24.5h-10.5l-3 12.2-20-8.3V544l-3-8.2 10-4.5 9.7 5 19.8-1 21.5-4 14.5-8.5 7-7 7 7 10 7.5-18 14.5-17.7 17.7-14.1-4-3.9 13.3M479.6 805.6c-2.7 0-11-10.7-11-10.7l18-30.7h28.3l13.3-14 16.2-15.3h21.7l-3.2 16 6.8 8.7-20.5 22.7-30.1 9.3-17.9 14h-21.6zM468.6 825.6l-6.3-10 6.3-2.6 4 6.3M315.6 899.6c-2-1.3-9.3-13.5-9.3-13.5l9.3-3.1h18.7l8.7-4.7 6 14.7-16.7 6.7h-16.7z" opacity=".8"/>\n      <g opacity=".8" fill="#FDD42F">\n        <path d="M1365.8 51c-.1-.1-.1 0 0 0zM1012.9 136.6c-.1 0-.1.1 0 0 .1 0 .1 0 0 0zM771.3 103c-.1 0 0 0 0 0 .1 0 .1 0 0 0z"/>\n        <path d="M1484.3 36.4l4.6-6.6.3-4.9-10.8-6.7-.3-4.4-2.9 3.4-10-2.6 2.1-7.4-3.9-.9-3 5.6S1433 36.5 1434 36.5s-51.9 15.8-51.9 15.8-16.5-1.2-17.7-1.4c.8.3-19.5 7.4-19.5 7.4l-48.5 1.6-10.5 4.2-10.7-6.4-45.2-8.9-10.8 1.9-2.8 7.8-3.3-9.6h-9l-2.5 5.4-9.5.2-30.2 17.1-20.6 2.6-10.5 12.1-17.7 8.4-13.4 11.6-23.7 4.2-4.2 6.9s-40.1 16.3-41.1 16.9c.4-.3-16.1.8-17.2.5-2.5 1-38.6 12.3-38.6 12.3l-23-.3-25 7.3-36.6-9.7-52.7-.3-32.3-31s-30.8-11.3-30.9-11.6c-.6.1-7.7.9-8.4 1-.4-.4-18-5.8-18-5.8l-15 2.1-1 4.4-20.5 6.9-2.6 9.7 11.1 29.5-12.2 9.5-5-7-6.7 3.3-19.8-4.8-8.9 5v9h-7v14h-10l-13.5 6 16 16.5 14.5 3.5 19.5 20.5 39.5 19v9.8l-5.8 21.3 48.3 42.8-3.3 13.9 1.9 4.2 4.5 10.5 1 13.7 18.3 9.3h21l27.5-7 22-5.5 37-10.5 17-11.5 4.3-12 7.2 5.5 7-2 5 8.5s11-2.5 13-4 15.5 12.5 15.5 12.5l8-8 6.5 8s9.8-2.3 8.2-1.7c-1.7.7 14.7 1.3 16 1.3 1.3 0 14.7 2.3 15.7 2.3s12.7 6.4 13.2 8 3.8 17.5 5.5 17.5 18.5-.5 18.5-.5l-3.8-16.4 32.3-16.6 39.4-10.6 38.9-2.8 23.8-6.2 38.5 4.2 3.8-12.6 28.2-8.9 23-32.5-3.1-26.5 15.6-37h12.2l10-18 79.6-17.4 97-105.9-2.6-4.7v-3.7l-7.9-18.2zM765.5 331.5l12.5-1-14.7-.2"/>\n      </g>\n      <path fill="none" stroke="#FFF" stroke-width="4" stroke-miterlimit="10" d="M472.6 584.3v19l6 23.7 5.7 74.3-4.4 9.3 4.4 11.7-10.7 19.7v13l-26 36 6 6.6-23 28.7-34.7 22.3"/>\n      <path fill="none" stroke="#FFF" stroke-width="4" stroke-miterlimit="10" d="M299.4 1019.1v-56.9l-14.8-65.4h4.7l1.6-6.9 2.6 2.6 15.3-7.9v-8.4l22.7-14.8c-.7-8.1-1.4-11.9-2.1-11.6-.7.4 1.6-1.4 6.9-5.3l7.9 4.2 6.3-12.7-8.4-7.9-10.5-1.1-2.1-6.9 6.9-5.8V803l16.9-17.4 23.2-6.3 6.3 5.3 3.7-7.9 25.3 7.9v-5.3l-4.2-7.4-9.5-1.6-5.8-7.4c9.1-10.9 13.5-16.2 13.2-15.8-.4.4 2.3-.2 7.9-1.6-.4-3.9-.9-5.8-1.6-5.8h3.7l-2.1-4.7 4.7 2.1 1.6-4.2c5.3 2.8 7.9 4.2 7.9 4.2s1.6-.7 4.7-2.1l2.1-11.6 11.1-8.4 2.6-12.1 7.4-1.6-7.4-7.4V677l-4.7 1.6-1.1-3.7-5.3-10.5 6.3-9c-12.7-8.1-18.6-12.1-17.9-12.1.7 0-.2-3.2-2.6-9.5l-20.6 1.6v-4.7l14.8-7.4-1.6-12.1 7.4 3.7 2.6-7.4-7.4 1.1-3.7-2.6h-4.2l-6.3-11.1H398s-1.1 3.7-3.2 11.1l-6.9 2.6-25.3-3.7-16.3 3.7c-4.6-4.2-6.7-6.3-6.3-6.3.4 0-.9.9-3.7 2.6l-6.9-20.6v-12.7l-12.7-25.8c.4-12.7.9-19 1.6-19 .7 0 3.2-1.6 7.4-4.7l-4.2-5.3-2.1-15.8 9-13.7 3.2-4.7-5.8-15.8v-36.4L307.3 414h-6.9l-1.1-7.4-8.4-8.4c6.3-6 9.5-8.6 9.5-7.9 0 .7.5-1.9 1.6-7.9l-2.6-6.3c8.1-7.4 12-10.9 11.6-10.5s.5-1.8 2.6-6.3l-7.9-23.2 10-3.2 9-14.8 2.6 3.7c9.8-3.9 14.8-5.4 14.8-4.7 0 .7.7 2.3 2.1 4.7l-2.1 8.4 17.9 2.6 6.3 12.1h4.7l2.1-26.9 11.1-6.9 10.5 2.1-1.1-12.7 8.4 4.7 7.9-4.7 1.6-15.8-4.2-9c4.9-3.5 5.8-5.3 5.8-5.3l-5.8-5.3s1.2-1.6 5.8-4.7l-4.2-5.8 15.3 4.2 6.3-9 12.7 1.1 10.5 3.7v-4.7h9.5l4.2-3.2-4.2-4.2 2.6-4.7-5.8-1.6-1.6-10-4.7-1.1-3.2 4.7-2.6-4.7 5.8-2.1-3.2-2.6v-5.8H447l-4.7-6.3v-10l-4.2-4.7 10-24.8-2.6-15.3 11.1-10-4.7-8.4c7.7-8.8 11.6-12.1 11.6-12.1s-.8-1.3-2.1-5.8l42.2 12.1 5.3-2.1 13.2 5.3v4.7l9.5 3.2-6.9 8.4v4.7l13.7 7.4 3.7-8.4 3.7 1.1 3.2-2.6 2.6 4.7 10-4.7 15.3 2.6c21.4 6.3 31.6 8.4 31.6 8.4s.7-3.5 3.2-8.4l36.4-21.1 16.9 2.6 28.5-16.3H708l2.6-9.5 20.6-6.9 1.1-4.7 15.8-2.1 17.9 5.8 7.9-1.1 31.6 12.1 31.1 31.1h54.3c21.4 6.7 32.3 10 32.7 10s10.4-2.5 30.1-7.4h21.1l39-12.1h16.9l41.1-16.9 4.2-6.9 23.7-4.2 11.1-10.5 20-9.5 10.5-12.1 20.6-2.6 28.5-16.9 11.6-1.1 2.1-4.7h9l3.2 6.9 1.6-4.7c8.4-1.4 12.5-2.1 12.1-2.1-.5 0 46.4 9 45.9 8.4-.4-.4 3 1.9 10 6.9l10.5-4.2 48.5-1.6 19.5-7.4 16.9 1.1 52.2-15.3c18.3-16.5 27.2-24.8 26.9-24.8-.4 0 .4-1.9 2.1-5.8l4.7 1.1-2.1 7.4 10 2.6 3.2-3.7v4.7l10.5 6.3v5.3l-4.7 6.9 7.9 17.9v3.7l2.6 4.7-97 105.9-79.6 17.4-21.6 39c-2.5 43.2-3.9 64.7-4.2 64.3-.4-.4 6.5 15.6 20.6 48l2.6 49.5-21.1 31.1V442c-4.9 16.5-7.7 24.8-8.4 24.8-1.1 0 0 108.6 0 108.1 0-.4-14.2 27.2-42.7 82.8l-63.3 19.5-687 433.8c-52-9.5-78.6-14.4-79.6-14.8-1.1-.4-13.4-11.6-36.9-33.7l-5.3 5.8c-5.3-2.8-7.7-4.2-7.4-4.2.5 0-8.4 3.7-7.9 3.2s-9.5-19-9.5-20.6v-11.1h-10l-2.6-4.2 5.3-1.1c-6.3-2.1-9.5-3.2-9.5-3.2v-4.2c0-.4-7.9-1.6-23.7-3.7h-6.4z"/>\n      <path fill="#FFF" d="M558 603.2v-16.6h-13.3v16.6h-10.6v-42.6h10.6v16.1H558v-16.1h10.6v42.6"/>\n      <path d="M567.1 562.1v39.6h-7.6v-16.6h-16.3v16.6h-7.6v-39.6h7.6v16.1h16.3v-16.1h7.6m3-3h-13.6v16.1h-10.3v-16.1h-13.6v45.6h13.6v-16.6h10.3v16.6h13.6v-45.6z"/>\n      <path fill="#FFF" d="M592.8 603.9c-12.6 0-20.4-8.5-20.4-22.2 0-13.2 8-21.7 20.4-21.7 12.6 0 20.4 8.3 20.4 21.7-.1 13.9-7.7 22.2-20.4 22.2zm0-34c-5.9 0-9.4 4.4-9.4 11.8 0 4.6 1.2 12.3 9.4 12.3 7.8 0 9.4-6.7 9.4-12.3-.1-7.4-3.5-11.8-9.4-11.8z"/>\n      <path d="M592.8 561.5c11.4 0 18.9 7.5 18.9 20.2 0 13.5-7.5 20.7-18.9 20.7-11.3 0-18.9-7.3-18.9-20.7 0-12.8 7.5-20.2 18.9-20.2m0 34c6.9 0 10.9-4.9 10.9-13.8 0-8.1-4-13.3-10.8-13.3-6.9 0-10.9 5.2-10.9 13.3-.1 8.9 3.9 13.8 10.8 13.8m0-37c-13.3 0-21.9 9.1-21.9 23.2 0 14.6 8.4 23.7 21.9 23.7s21.9-9.1 21.9-23.7c-.1-14.1-8.7-23.2-21.9-23.2zm0 34c-6.5 0-7.9-5.9-7.9-10.8 0-3.1.8-10.3 7.9-10.3 2.4 0 7.8 1 7.8 10.3 0 7.2-2.6 10.8-7.8 10.8z"/>\n      <path fill="#FFF" d="M651.6 603.2l-2-20.9-6.8 20.9h-8.3l-6.8-20.9-2 20.9h-10.3l4.2-42.6h10.5l8.5 25.9 8.7-25.9h10.3l4.2 42.6"/>\n      <path d="M656.2 562.1l3.9 39.6H653l-2.6-26.7-8.7 26.7h-6.1l-8.7-26.8-2.6 26.8H617l3.8-39.6h8.1l9.6 29.1 9.8-29.1h7.9m2.7-3h-12.7l-.7 2-6.9 20.5-6.8-20.5-.7-2.1h-13l-.3 2.7-3.8 39.6-.3 3.3H627l.3-2.7 1.2-12.4 4.2 13.1.7 2.1h10.5l.7-2.1 4.2-13L650 602l.3 2.7H663.4l-.3-3.3-3.9-39.6-.3-2.7z"/>\n      <path fill="#FFF" d="M679.7 603.9c-6.3 0-11.9-2.4-16.3-7.1l-.9-1 5.6-6.9 1.2 1c3.6 3 7.3 4.6 10.8 4.6 2.2 0 4.5-1 4.5-3.7 0-1.8-.5-3.2-7.2-5-7.6-2.1-12.7-5.2-12.7-12.9 0-8 5.8-13 15.2-13 5.6 0 10.7 2.1 14.6 6l1 1-5.5 6.8-1.2-1c-2.6-2.3-5.6-3.5-8.7-3.5-1.7 0-4.6.4-4.6 3.1 0 2.2 1.5 3 8.2 5.1 7.3 2.4 11.9 5.4 11.9 12.9-.3 8.2-6.4 13.6-15.9 13.6z"/>\n      <path d="M679.8 561.5c5.2 0 9.8 1.9 13.5 5.6l-3.7 4.5c-2.9-2.6-6.4-3.9-9.7-3.9-3.6 0-6.1 1.5-6.1 4.6 0 3.4 2.6 4.4 9.2 6.5 7.6 2.5 10.8 5.3 10.8 11.4 0 7.6-5.6 12.3-14.2 12.3-6.2 0-11.3-2.5-15.2-6.6l3.8-4.7c3.6 3 7.7 4.9 11.7 4.9 3.5 0 6-1.9 6-5.2 0-3-1.6-4.6-8.3-6.5-8.2-2.3-11.6-5.3-11.6-11.5 0-7.7 6-11.4 13.8-11.4m0-3c-10.2 0-16.7 5.7-16.7 14.5 0 9.2 6.6 12.4 13.8 14.4 6.1 1.7 6.1 2.7 6.1 3.6 0 1.9-1.9 2.2-3 2.2-3.1 0-6.5-1.5-9.8-4.3l-2.3-1.9-1.9 2.4-3.8 4.7-1.7 2 1.8 1.9c4.7 4.9 10.7 7.5 17.4 7.5 10.4 0 17.2-6 17.2-15.3 0-8.4-5.2-11.8-12.9-14.3-6.6-2.2-7.1-2.7-7.1-3.7 0-1.3 1.7-1.6 3.1-1.6 2.7 0 5.4 1.1 7.7 3.1l2.3 2.1 2-2.4 3.7-4.5 1.7-2.1-1.9-1.9c-4.3-4.2-9.7-6.4-15.7-6.4z"/>\n      <g>\n        <path fill="#FFF" d="M464 874.4v-42.6h14.5c13.5 0 21.2 7.6 21.2 20.9 0 14.8-7.1 21.7-22.3 21.7H464zm14.6-9.7c7 0 10.2-3.6 10.2-11.5 0-8-3.2-11.7-10.2-11.7h-4.1v23.2h4.1z"/>\n        <path d="M478.5 833.3c13 0 19.7 7.2 19.7 19.4 0 14.2-6.9 20.2-20.8 20.2h-11.9v-39.6h13m-5.4 32.9h5.6c8.1 0 11.7-4.4 11.7-13 0-8.5-3.6-13.2-11.7-13.2h-5.6v26.2m5.4-35.9h-16v45.6h14.9c16 0 23.8-7.6 23.8-23.2 0-14.3-8.3-22.4-22.7-22.4zm-2.4 12.7h2.6c4.3 0 8.7 1.2 8.7 10.2 0 6-1.5 10-8.7 10h-2.6V843z"/>\n        <path fill="#FFF" d="M527.3 874.4l-2.9-9h-11.8l-2.9 9h-11.4l15.3-42.6h9.8l15.3 42.6h-11.4zm-5.9-18.4l-2.9-9.1-2.9 9.1h5.8z"/>\n        <path d="M522.3 833.3l14.2 39.6h-8.1l-2.9-9h-14l-2.9 9h-8.2l14.2-39.6h7.7m-8.7 24.2h9.8l-5-15.6-4.8 15.6m10.8-27.2H512.6l-.7 2-14.2 39.6-1.4 4H511l.7-2.1 2.2-6.9h9.6l2.2 6.9.7 2.1H541l-1.4-4-14.2-39.6-1-2zm-6.7 24.2l.8-2.6.8 2.6h-1.6z"/>\n        <path fill="#FFF" d="M574.8 874.4l-2.1-20.9-6.8 20.9h-8.2l-6.8-21-2.1 21h-10.2l4.1-42.6h10.6l8.5 25.8 8.7-25.8h10.2l4.2 42.6"/>\n        <path d="M579.4 833.3l3.9 39.6h-7.1l-2.6-26.7-8.7 26.7h-6.1l-8.7-26.8-2.6 26.8h-7.3l3.8-39.6h8.1l9.6 29.1 9.8-29.1h7.9m2.7-3h-12.7l-.7 2-6.9 20.5-6.8-20.5-.7-2.1h-13l-.3 2.7-3.8 39.6-.3 3.3h13.3l.3-2.7 1.2-12.4 4.2 13.1.7 2.1h10.5l.7-2.1 4.2-13 1.2 12.4.3 2.7H586.6l-.3-3.3-3.9-39.6-.3-2.7z"/>\n        <path fill="#FFF" d="M613.8 874.4l-2.9-9H599l-2.9 9h-11.4l15.3-42.6h9.8l15.3 42.6h-11.3zm-6-18.4l-2.9-9.1-2.9 9.1h5.8z"/>\n        <path d="M608.7 833.3l14.2 39.6h-8.1l-2.9-9h-14l-2.9 9h-8.2l14.2-39.6h7.7m-8.7 24.2h9.8l-5-15.6-4.8 15.6m10.8-27.2H599l-.7 2-14.3 39.6-1.4 4h14.7l.7-2.1 2.2-6.9h9.6l2.2 6.9.7 2.1H627.3l-1.4-4-14.2-39.6-.9-2zm-6.7 24.2l.8-2.6.8 2.6h-1.6z"/>\n        <g>\n          <path fill="#FFF" d="M640.3 875.1c-6.3 0-11.9-2.4-16.3-7.1l-.9-1 5.6-6.9 1.2 1c3.6 3 7.3 4.6 10.8 4.6 2.2 0 4.5-1 4.5-3.7 0-1.8-.5-3.2-7.2-5-7.6-2.1-12.7-5.2-12.7-12.9 0-8 5.8-13 15.2-13 5.6 0 10.7 2.1 14.6 6l1 1-5.5 6.8-1.2-1c-2.6-2.3-5.6-3.5-8.7-3.5-1.7 0-4.6.4-4.6 3.1 0 2.2 1.5 3 8.2 5.1 7.3 2.4 11.9 5.4 11.9 12.9-.3 8.2-6.4 13.6-15.9 13.6z"/>\n          <path d="M640.4 832.6c5.2 0 9.8 1.9 13.5 5.6l-3.7 4.5c-2.9-2.6-6.4-3.9-9.7-3.9-3.6 0-6.1 1.5-6.1 4.6 0 3.4 2.6 4.4 9.2 6.5 7.6 2.5 10.8 5.3 10.8 11.4 0 7.6-5.6 12.3-14.2 12.3-6.2 0-11.3-2.5-15.2-6.6l3.8-4.7c3.6 3 7.7 4.9 11.7 4.9 3.5 0 6-1.9 6-5.2 0-3-1.6-4.6-8.3-6.5-8.2-2.3-11.6-5.3-11.6-11.5 0-7.6 6-11.4 13.8-11.4m0-3c-10.2 0-16.7 5.7-16.7 14.5 0 9.2 6.6 12.4 13.8 14.4 6.1 1.7 6.1 2.7 6.1 3.6 0 1.9-1.9 2.2-3 2.2-3.1 0-6.5-1.5-9.8-4.3l-2.3-1.9-1.9 2.4-3.8 4.7-1.7 2 1.8 1.9c4.7 4.9 10.7 7.5 17.4 7.5 10.4 0 17.2-6 17.2-15.3 0-8.4-5.2-11.8-12.9-14.3-6.6-2.2-7.1-2.7-7.1-3.7 0-1.3 1.7-1.6 3.1-1.6 2.7 0 5.4 1.1 7.7 3.1l2.3 2.1 2-2.4 3.7-4.5 1.7-2.1-1.9-1.9c-4.3-4.1-9.7-6.4-15.7-6.4z"/>\n        </g>\n        <g>\n          <path fill="#FFF" d="M683.6 874.4l-10.4-17h-3.1v17h-10.6v-42.6h10.6v16.3h3.2l9.1-16.3h11.9l-11.8 20.8 13.4 21.8"/>\n          <path d="M691.7 833.3l-11 19.3 12.5 20.3h-8.8l-10.3-17h-5.4v17H661v-39.6h7.6v16.3h5.6l9.1-16.3h8.4m5.2-3h-15.5l-.9 1.5-8.2 14.8h-.8v-16.3H658v45.6h13.6v-17h.8l9.5 15.6.9 1.4h15.9l-2.8-4.6-11.6-18.8 10.1-17.8 2.5-4.4z"/>\n        </g>\n        <g>\n          <path fill="#FFF" d="M713.1 875c-11.1 0-17.2-6.1-17.2-17.1v-26.1h10.6v25.8c0 5.1 2.2 7.7 6.6 7.7 4.7 0 6.6-2.2 6.6-7.7v-25.8h10.6v26.1c0 11.1-6.1 17.1-17.2 17.1z"/>\n          <path d="M728.8 833.3v24.6c0 10.4-5.7 15.6-15.7 15.6-9.7 0-15.7-4.8-15.7-15.6v-24.6h7.6v24.3c0 6.3 3.1 9.2 8.1 9.2 5.7 0 8.1-3.1 8.1-9.2v-24.3h7.6m3-3h-13.6v27.3c0 5.2-1.8 6.2-5.1 6.2-2.4 0-5.1-.7-5.1-6.2v-27.3h-13.6v27.6c0 12 6.6 18.6 18.7 18.6 11.9 0 18.7-6.8 18.7-18.6v-27.6z"/>\n        </g>\n        <g>\n          <path fill="#FFF" d="M749.5 875.1c-6.3 0-11.9-2.4-16.3-7.1l-.9-1 5.6-6.9 1.2 1c3.6 3 7.3 4.6 10.8 4.6 2.2 0 4.5-1 4.5-3.7 0-1.8-.5-3.2-7.2-5-7.6-2.1-12.7-5.2-12.7-12.9 0-8 5.8-13 15.2-13 5.6 0 10.7 2.1 14.6 6l1 1-5.5 6.8-1.2-1c-2.6-2.3-5.6-3.5-8.7-3.5-1.7 0-4.6.4-4.6 3.1 0 2.2 1.5 3 8.2 5.1 7.3 2.4 11.9 5.4 11.9 12.9-.2 8.2-6.4 13.6-15.9 13.6z"/>\n          <path d="M749.6 832.6c5.2 0 9.8 1.9 13.5 5.6l-3.7 4.5c-2.9-2.6-6.4-3.9-9.7-3.9-3.6 0-6.1 1.5-6.1 4.6 0 3.4 2.6 4.4 9.2 6.5 7.6 2.5 10.8 5.3 10.8 11.4 0 7.6-5.6 12.3-14.2 12.3-6.2 0-11.3-2.5-15.2-6.6l3.8-4.7c3.6 3 7.7 4.9 11.7 4.9 3.5 0 6-1.9 6-5.2 0-3-1.6-4.6-8.3-6.5-8.2-2.3-11.6-5.3-11.6-11.5 0-7.6 6-11.4 13.8-11.4m0-3c-10.2 0-16.7 5.7-16.7 14.5 0 9.2 6.6 12.4 13.8 14.4 6.1 1.7 6.1 2.7 6.1 3.6 0 1.9-1.9 2.2-3 2.2-3.1 0-6.5-1.5-9.8-4.3l-2.3-1.9-1.9 2.4-3.8 4.7-1.7 2 1.8 1.9c4.7 4.9 10.7 7.5 17.4 7.5 10.4 0 17.2-6 17.2-15.3 0-8.4-5.2-11.8-12.9-14.3-6.6-2.2-7.1-2.7-7.1-3.7 0-1.3 1.7-1.6 3.1-1.6 2.7 0 5.4 1.1 7.7 3.1l2.3 2.1 2-2.4 3.7-4.5 1.7-2.1-1.9-1.9c-4.3-4.1-9.7-6.4-15.7-6.4z"/>\n        </g>\n      </g>\n      <g>\n        <path fill="#FFF" d="M726.6 401.5l-2-20.9-6.8 20.9h-8.3l-6.8-20.9-2 20.9h-10.3l4.2-42.6h10.6l8.5 25.9 8.7-25.9h10.2l4.2 42.6"/>\n        <path d="M731.3 360.4l3.9 39.6H728l-2.6-26.7-8.7 26.7h-6.1l-8.7-26.8-2.6 26.8H692l3.8-39.6h8.1l9.6 29.1 9.8-29.1h8m2.7-3h-12.7l-.7 2-6.9 20.5-6.8-20.5-.7-2.1h-13l-.3 2.7-3.8 39.6-.3 3.3h13.3l.3-2.7 1.2-12.4 4.2 13.1.7 2.1H719l.7-2.1 4.2-13 1.2 12.4.3 2.7H738.5l-.3-3.3-3.9-39.6-.3-2.7z"/>\n        <path fill="#FFF" d="M765.6 401.5l-2.9-9h-11.8l-2.9 9h-11.4l15.3-42.6h9.8l15.3 42.6h-11.4zm-5.9-18.3l-2.9-9.1-2.9 9.1h5.8z"/>\n        <path d="M760.6 360.4l14.2 39.6h-8.1l-2.9-9h-14l-2.9 9h-8.2l14.2-39.6h7.7m-8.7 24.3h9.8l-4.9-15.6-4.9 15.6m10.8-27.3H750.9l-.7 2-14.3 39.6-1.4 4h14.7l.7-2.1 2.2-6.9h9.6l2.2 6.9.7 2.1H779.2l-1.4-4-14.2-39.6-.9-2zm-6.7 24.3l.8-2.6.8 2.6H756z"/>\n        <path fill="#FFF" d="M792.1 402.2c-6.3 0-11.9-2.4-16.3-7.1l-.9-1 5.6-6.9 1.2 1c3.6 3 7.3 4.6 10.8 4.6 2.2 0 4.5-1 4.5-3.7 0-1.8-.5-3.2-7.2-5-7.6-2.1-12.7-5.2-12.7-12.9 0-8 5.8-13 15.2-13 5.6 0 10.7 2.1 14.6 6l1 1-5.5 6.8-1.2-1c-2.6-2.3-5.6-3.5-8.7-3.5-1.7 0-4.6.4-4.6 3.1 0 2.2 1.5 3 8.2 5.1 7.3 2.4 11.9 5.4 11.9 12.9-.2 8.2-6.3 13.6-15.9 13.6z"/>\n        <path d="M792.2 359.8c5.2 0 9.8 1.9 13.5 5.6l-3.7 4.5c-2.9-2.6-6.4-3.9-9.7-3.9-3.6 0-6.1 1.5-6.1 4.6 0 3.4 2.6 4.4 9.2 6.5 7.6 2.5 10.8 5.3 10.8 11.4 0 7.6-5.6 12.3-14.2 12.3-6.2 0-11.3-2.5-15.2-6.6l3.8-4.7c3.6 3 7.7 4.9 11.7 4.9 3.5 0 6-1.9 6-5.2 0-3-1.6-4.6-8.3-6.5-8.2-2.3-11.6-5.3-11.6-11.5.1-7.7 6.1-11.4 13.8-11.4m0-3c-10.2 0-16.7 5.7-16.7 14.5 0 9.2 6.6 12.4 13.8 14.4 6.1 1.7 6.1 2.7 6.1 3.6 0 1.9-1.9 2.2-3 2.2-3.1 0-6.5-1.5-9.8-4.3l-2.3-1.9-1.9 2.4-3.8 4.7-1.7 2 1.8 1.9c4.7 4.9 10.7 7.5 17.4 7.5 10.4 0 17.2-6 17.2-15.3 0-8.4-5.2-11.8-12.9-14.3-6.6-2.2-7.1-2.7-7.1-3.7 0-1.3 1.7-1.6 3.1-1.6 2.7 0 5.4 1.1 7.7 3.1l2.3 2.1 2-2.4 3.7-4.5 1.7-2.1-1.9-1.9c-4.2-4.2-9.6-6.4-15.7-6.4z"/>\n        <path fill="#FFF" d="M835.5 401.5l-10.4-17H822v17h-10.6v-42.6H822v16.4h3.2l9.1-16.4h11.9l-11.8 20.8 13.4 21.8"/>\n        <path d="M843.6 360.4l-11 19.3 12.5 20.3h-8.8L826 383h-5.4v17H813v-39.6h7.6v16.3h5.6l9.1-16.3h8.3m5.2-3h-15.5l-.9 1.5-8.2 14.8h-.8v-16.3h-13.6V403h13.6v-17h.8l9.5 15.6.9 1.4h15.9l-2.8-4.6-11.6-18.8 10.1-17.8 2.6-4.4z"/>\n        <g>\n          <path fill="#FFF" d="M873.3 401.5l-2.9-9h-11.8l-2.9 9h-11.4l15.3-42.6h9.8l15.3 42.6h-11.4zm-5.9-18.3l-2.9-9.1-2.9 9.1h5.8z"/>\n          <path d="M868.3 360.4l14.2 39.6h-8.1l-2.9-9h-14l-2.9 9h-8.2l14.2-39.6h7.7m-8.7 24.3h9.8l-4.9-15.6-4.9 15.6m10.8-27.3H858.6l-.7 2-14.3 39.6-1.4 4h14.7l.7-2.1 2.2-6.9h9.6l2.2 6.9.7 2.1H886.9l-1.4-4-14.2-39.6-.9-2zm-6.7 24.3l.8-2.6.8 2.6h-1.6z"/>\n        </g>\n        <g>\n          <path fill="#FFF" d="M911.9 401.5l-15.4-23v23H886v-42.6h9l15.3 23.3v-23.3h10.6v42.6"/>\n          <path d="M919.4 360.4V400h-6.7L895 373.6V400h-7.5v-39.6h6.7l17.6 26.8v-26.8h7.6m3-3h-13.5v19.8l-12.1-18.4-.9-1.4h-11.3V403h13.5v-19.6l12.2 18.2.9 1.3h11.3v-45.5h-.1z"/>\n        </g>\n        <g>\n          <path fill="#FFF" d="M951.2 401.5l-2.9-9h-11.8l-2.9 9h-11.4l15.3-42.6h9.8l15.3 42.6h-11.4zm-6-18.3l-2.9-9.1-2.9 9.1h5.8z"/>\n          <path d="M946.1 360.4l14.2 39.6h-8.1l-2.9-9h-14l-2.9 9h-8.2l14.2-39.6h7.7m-8.7 24.3h9.8l-5-15.6-4.8 15.6m10.8-27.3H936.4l-.7 2-14.3 39.6-1.4 4h14.7l.7-2.1 2.2-6.9h9.6l2.2 6.9.7 2.1H964.7l-1.4-4-14.3-39.6-.8-2zm-6.7 24.3l.8-2.6.8 2.6h-1.6z"/>\n        </g>\n        <g>\n          <path fill="#FFF" d="M987.8 401.5v-16.6h-13.4v16.6h-10.6v-42.6h10.6V375h13.4v-16.1h10.5v42.6"/>\n          <path d="M996.8 360.4V400h-7.6v-16.6h-16.3V400h-7.6v-39.6h7.6v16.1h16.3v-16.1h7.6m3-3h-13.6v16.1h-10.3v-16.1h-13.6V403h13.6v-16.6h10.3V403h13.6v-45.6z"/>\n        </g>\n      </g>\n      <g>\n        <path fill="#FFF" d="M489.2 224.7l-2.9-9h-11.8l-2.9 9h-11.4l15.3-42.6h9.8l15.3 42.6h-11.4zm-5.9-18.3l-2.9-9.1-2.9 9.1h5.8z"/>\n        <path d="M484.2 183.6l14.2 39.6h-8.1l-2.9-9h-14l-2.9 9h-8.2l14.2-39.6h7.7m-8.7 24.3h9.8l-4.9-15.6-4.9 15.6m10.8-27.3H474.5l-.7 2-14.2 39.6-1.4 4h14.7l.7-2.1 2.2-6.9h9.6l2.2 6.9.7 2.1H502.9l-1.4-4-14.5-39.6-.7-2zm-6.7 24.3l.8-2.6.8 2.6h-1.6z"/>\n        <path fill="#FFF" d="M501.9 224.7v-42.6h10.6V215h17.2v9.7"/>\n        <path d="M511 183.6v32.9h17.2v6.7h-24.8v-39.6h7.6m3-3h-13.6v45.6h30.8v-12.7H514v-32.9z"/>\n        <path fill="#FFF" d="M532.7 224.7v-42.6H562v9.7h-18.8v6.5h17.1v9.8h-17.1v7h19.1v9.6"/>\n        <path d="M560.5 183.6v6.7h-18.8v9.5h17v6.7h-17v10h19.1v6.7h-26.7v-39.6h26.4m3-3h-32.3v45.6h32.7v-12.7h-19.1v-4h17v-12.7h-17v-3.5h18.8v-12.7h-.1z"/>\n        <g>\n          <path fill="#FFF" d="M566 224.7v-42.6h15.9c9.7 0 15.5 5.3 15.5 14.2 0 9.3-5.8 14.6-16 14.6h-4.7v13.8H566zm14.9-23c3.9 0 5.9-1.6 5.9-5 0-3.5-1.7-5-5.5-5h-4.7v10h4.3z"/>\n          <path d="M581.8 183.6c9.1 0 14 4.7 14 12.7 0 8.1-4.7 13.1-14.5 13.1h-6.2v13.8h-7.6v-39.6h14.3m-6.7 19.6h5.8c4.9 0 7.4-2.4 7.4-6.5s-2.1-6.5-7-6.5h-6.2v13m6.7-22.6h-17.4v45.6H578v-13.8h3.2c11.1 0 17.5-5.9 17.5-16.1.1-9.8-6.2-15.7-16.9-15.7zm-3.7 12.6h3.2c3.4 0 4 1.2 4 3.5 0 1.7-.3 3.5-4.4 3.5h-2.8v-7z"/>\n        </g>\n        <g>\n          <path fill="#FFF" d="M600.6 224.7v-42.6h15.9c9.7 0 15.5 5.3 15.5 14.2 0 9.3-5.8 14.6-16 14.6h-4.7v13.8h-10.7zm15-23c3.9 0 5.9-1.6 5.9-5 0-3.5-1.7-5-5.5-5h-4.7v10h4.3z"/>\n          <path d="M616.5 183.6c9.1 0 14 4.7 14 12.7 0 8.1-4.7 13.1-14.5 13.1h-6.2v13.8h-7.6v-39.6h14.3m-6.8 19.6h5.8c4.9 0 7.4-2.4 7.4-6.5s-2.1-6.5-7-6.5h-6.2v13m6.8-22.6h-17.4v45.6h13.6v-13.8h3.2c11.1 0 17.5-5.9 17.5-16.1.1-9.8-6.3-15.7-16.9-15.7zm-3.8 12.6h3.2c3.4 0 4 1.2 4 3.5 0 1.7-.3 3.5-4.4 3.5h-2.8v-7z"/>\n        </g>\n        <g>\n          <path fill="#FFF" d="M654.4 225.4c-12.6 0-20.4-8.5-20.4-22.2 0-13.2 8-21.7 20.4-21.7 12.6 0 20.4 8.3 20.4 21.7-.1 13.9-7.7 22.2-20.4 22.2zm0-34c-5.9 0-9.4 4.4-9.4 11.8 0 4.6 1.2 12.3 9.4 12.3 7.8 0 9.4-6.7 9.4-12.3 0-7.4-3.5-11.8-9.4-11.8z"/>\n          <path d="M654.4 183c11.4 0 18.9 7.5 18.9 20.2 0 13.5-7.5 20.7-18.9 20.7-11.3 0-18.9-7.3-18.9-20.7 0-12.8 7.6-20.2 18.9-20.2m0 34c6.9 0 10.9-4.9 10.9-13.8 0-8.1-4-13.3-10.8-13.3-6.9 0-10.9 5.2-10.9 13.3-.1 8.9 4 13.8 10.8 13.8m0-37c-13.3 0-21.9 9.1-21.9 23.2 0 14.6 8.4 23.7 21.9 23.7s21.9-9.1 21.9-23.7c-.1-14.1-8.6-23.2-21.9-23.2zm0 34c-6.5 0-7.9-5.9-7.9-10.8 0-3.1.8-10.3 7.9-10.3 2.4 0 7.8 1 7.8 10.3.1 7.2-2.6 10.8-7.8 10.8z"/>\n        </g>\n      </g>\n      <circle fill="#FFF" cx="547.5" cy="259.5" r="12.8"/>\n      <circle fill="#FFF" cx="715.9" cy="315.6" r="12.8"/>\n      <circle fill="#FFF" cx="472.6" cy="583.6" r="12.8"/>\n      <circle fill="#FFF" cx="395.9" cy="848.6" r="12.8"/>\n    </svg>\n  ';
};

var pathSVG = function pathSVG(id) {
  return '\n    <svg id="svg-path-background-' + id + '" class="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 1302.3">\n      <path stroke-dasharray="190" stroke-dashoffset="190" class="' + _map2.default['path-aleppo-maskanah'] + '" fill="none" stroke="#2BB7E9" stroke-width="5" stroke-miterlimit="10" d="M549.3 259.5l46 6.3 31.5 4 21.5-5 26.5 14 17.5 6 8.3 15.2 8.7 3 6.6 12.6"/>\n      <path stroke-dasharray="515" stroke-dashoffset="515" class="' + _map2.default['path-homs-aleppo'] + '" fill="none" stroke="#2BB7E9" stroke-width="5" stroke-miterlimit="10" d="M549.3 259.5l27.5 4 14 22.2 26 15 15.8 14.8-2.5 18.7-6 11 6 10 16.4 5 12.7 31.4 13.8 22 7.7 18L661 446l-19.7 8-30 12-19.5 2.6-13.4 8.2-15.5 18-9.8 1.4-7.6 5L536 526l-24.5 28.5S472.5 585 473 584"/>\n      <path stroke-dasharray="310" stroke-dashoffset="310" class="' + _map2.default['path-damaskus-homs'] + '" fill="none" stroke="#2BB7E9" stroke-width="5" stroke-miterlimit="10" d="M472.6 584.3v19l6 23.7 5.7 74.3-4.4 9.3 4 11.7-11 19.7v13l-26 36 6 6.6-23 28.7-35 22.3"/>\n      <circle class="' + _map2.default["dot-damaskus-blink"] + '" opacity="0" fill="#2BB7E9" cx="395.9" cy="848.6" r="18"/>\n      <circle class="' + _map2.default["dot-damaskus"] + '" opacity="0" fill="#2BB7E9" cx="395.9" cy="848.6" r="10"/>\n      <circle class="' + _map2.default["dot-homs-blink"] + '" opacity="0" fill="#2BB7E9" cx="472.3" cy="583.6" r="18"/>\n      <circle class="' + _map2.default["dot-homs"] + '" opacity="0" fill="#2BB7E9" cx="472.3" cy="583.6" r="10"/>\n      <circle class="' + _map2.default["dot-aleppo-blink"] + '" opacity="0" fill="#2BB7E9" cx="545.3" cy="259.5" r="18"/>\n      <circle class="' + _map2.default["dot-aleppo"] + '" opacity="0" fill="#2BB7E9" cx="545.3" cy="259.5" r="10"/>\n      <circle class="' + _map2.default["dot-maskanah-blink"] + '" opacity="0" fill="#2BB7E9" cx="715.9" cy="315.6" r="18"/>\n      <circle class="' + _map2.default["dot-maskanah"] + '" opacity="0" fill="#2BB7E9" cx="715.9" cy="315.6" r="10"/>\n    </svg>\n  ';
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var resetSvg = exports.resetSvg = function resetSvg(element) {
  var id = element.getAttribute('data-background-id');
  var mapString = element.getAttribute('data-map-string');
  var svgElement = document.getElementById('svg-path-background-' + id);
  try {
    svgElement.setAttribute('class', '');
  } catch (ex) {
    console.error(ex);
  }
};

var transitionSvg = exports.transitionSvg = function transitionSvg(element) {
  var id = element.getAttribute('data-background-id');
  var mapString = element.getAttribute('data-map-string');
  var svgElement = document.getElementById('svg-path-background-' + id);
  try {
    svgElement.setAttribute('class', mapString);
  } catch (ex) {
    console.error(ex, svgElement, mapString);
  }
};

var getAnimation = function getAnimation(mapString, id) {
  switch (mapString) {
    case 'to-damaskus':
      return toDamaskus(id);
    case 'from-damaskus-to-homs':
      return fromDamaskusToHoms(id);
    case 'from-homs-to-aleppo':
      return fromHomsToAleppo(id);
    default:
      return toDamaskus(id);
  }
};

var toDamaskus = function toDamaskus(id) {
  return [{
    id: id + '-svg-dot-damaskus',
    style: 'transition: 1s all ease; opacity: 1'
  }, {
    id: id + '-svg-text-damaskus',
    style: 'transition: 1s 1s all ease; opacity: 1'
  }];
};

var fromDamaskusToHoms = function fromDamaskusToHoms(id) {
  return [
  /**
   * Her skal størrelsen på teksten endres
   */
  {
    id: id + '-svg-from-damaskus-to-homs',
    style: 'transition: 2s .5s all ease; stroke-dashoffset: 0;'
  }, {
    id: id + '-svg-dot-homs',
    style: 'transition: 2s 2.5s all ease; opacity: 1'
  }, {
    id: id + '-svg-text-homs',
    style: 'transition: 2s 4s all ease; opacity: 1'
  }];
};

var fromHomsToAleppo = function fromHomsToAleppo(id) {
  return [
  /**
   * Her skal størrelsen på teksten endres
   */
  {
    id: id + '-svg-from-homs-to-aleppo',
    style: 'transition: 2s .5s all ease; stroke-dashoffset: 0;'
  }, {
    id: id + '-svg-dot-aleppo',
    style: 'transition: 2s 2.5s all ease; opacity: 1'
  }, {
    id: id + '-svg-text-aleppo',
    style: 'transition: 2s 4s all ease; opacity: 1'
  }];
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.videoHandler = undefined;

var _video = __webpack_require__(4);

var _video2 = _interopRequireDefault(_video);

var _alignmentClasses = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { getInitialMuteButton } from './muteButtons'

var videoHandler = exports.videoHandler = {
  property: 'data-video-element',
  load: function load(card) {
    var elem = document.createElement('div');
    elem.id = card.getAttribute('data-background-id');

    var videoSrc = {
      poster: card.getAttribute('data-video-poster-image') || '',
      mp4: card.getAttribute('data-video-mp4') || '',
      webm: card.getAttribute('data-video-webm') || '',
      subtitles: card.getAttribute('data-video-subtitles') || ''
    };

    var desktopAlignment = card.getAttribute('data-background-align') || '';
    var mobileAlignment = card.getAttribute('data-background-align-mobile') || '';

    var alignmentClasses = '';
    if (desktopAlignment || mobileAlignment) {
      alignmentClasses = (0, _alignmentClasses.getPositionClasses)(desktopAlignment, mobileAlignment);
    }

    var webmElement = videoSrc.webm ? '<source type="video/webm" src="' + videoSrc.webm + '">' : '';
    var mp4Element = videoSrc.mp4 ? '<source type="video/mp4" src="' + videoSrc.mp4 + '">' : '';

    var trackElement = videoSrc.subtitles ? '<track src="' + videoSrc.subtitles + '" kind="caption" srclang="no" label="Norwegian" default=""></track>' : '';

    var videoElement = '\n      <video\n        loop\n\n        muted=""\n        preload="none"\n        poster="' + videoSrc.poster + '"\n        playsinline=""\n        class="\n          ' + _video2.default['video'] + '\n          ' + alignmentClasses + '\n          "\n      >\n        ' + webmElement + '\n        ' + mp4Element + '\n        Your browser does not support the video tag. We suggest you upgrade your browser.\n      </video>\n      <div class="' + _video2.default['subtitlescontainer'] + '"></div>\n    ';
    elem.innerHTML = videoElement;

    return elem;
  }
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fakeSubtitles = undefined;

var _video = __webpack_require__(4);

var fakeSubtitles = exports.fakeSubtitles = function fakeSubtitles(videoElement, subtitleId) {
  var subtitleArray = subtitle[subtitleId];
  addSubtitle(videoElement, subtitleArray);
  videoElement.setAttribute('data-already-subtitled', true);
  var tracks = videoElement.textTracks[0];

  if (!tracks) {
    return;
  }

  videoElement.controls = false;
  tracks.mode = 'hidden';
  var cues = tracks.cues;

  var subtitleContainer = videoElement.parentElement.querySelector('.' + _video.subtitlescontainer);

  var replaceText = function replaceText(text) {
    subtitleContainer.innerHTML = '<span class="' + _video.subtitles + '">' + text + '</span>';
  };
  var hideText = function hideText() {
    subtitleContainer.style.display = 'none';
  };

  var showText = function showText() {
    subtitleContainer.style.display = 'block';
  };

  var cueEnter = function cueEnter(text) {
    replaceText('text');
    showText();
  };

  var cueExit = function cueExit() {
    hideText();
  };
  var videoLoaded = function videoLoaded(e) {
    var _loop = function _loop(i) {
      var cue = cues[i];
      try {
        cue.onenter = function () {
          replaceText(cue.text);
          showText();
        };
        cue.onexit = hideText;
      } catch (ex) {
        // hehe
      }
    };

    for (var i in cues) {
      _loop(i);
    }
  };
  videoElement.addEventListener('play', videoLoaded);
};

function addSubtitle(videoElement, arr) {
  var track = videoElement.addTextTrack('subtitles', 'Norsk', 'no');
  try {
    arr.forEach(function (a) {
      return track.addCue(new VTTCue(a.start, a.end, a.text));
    });
  } catch (ex) {
    arr.forEach(function (a) {
      return track.addCue(new TextTrackCue(a.start, a.end, a.text));
    });
  }
}

var standup_homs = [{
  start: 1,
  end: 3,
  text: 'Her var syriske opprørsstyrker inntil nylig.'
}, {
  start: 4,
  end: 8,
  text: 'I dette huset på frontlinjen hadde de sine skarpskytterposisjoner.'
}, {
  start: 9,
  end: 12,
  text: 'Nå er de blitt drevet ut av den syriske regjeringshæren,'
}, {
  start: 13,
  end: 17,
  text: 'og dette er det siste nabolaget i Homs by som de mistet.'
}];

var standup_aleppo = [{
  start: 0.5,
  end: 5.5,
  text: 'Gamlebyen i Aleppo var en av de mest atmosfæriske byene i hele midtøsten.'
}, {
  start: 5.5,
  end: 9.5,
  text: 'Her var det masse butikker og masse folk.'
}, {
  start: 9.5,
  end: 14.5,
  text: 'Nå er det nesten ingenting igjen. Det er ikke et menneske i denne gaten.'
}, {
  start: 16.5,
  end: 20,
  text: 'Det føles nesten som å bevege seg gjennom en spøkelsesby.'
}];

var standup_maskaneh = [{
  start: 1,
  end: 6.5,
  text: 'Her var IS inntil nylig. Dette er rester av et av deres skilt.'
}, {
  start: 6.5,
  end: 10.5,
  text: 'Nå har den syriske hæren drevet dem tilbake i dette området.'
}, {
  start: 10.5,
  end: 14,
  text: 'De blir presset tilbake i hele Syria.'
}];

var subtitle = {
  standup_homs: standup_homs,
  standup_aleppo: standup_aleppo,
  standup_maskaneh: standup_maskaneh
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLogo = undefined;

var _index = __webpack_require__(2);

var getLogo = exports.getLogo = function getLogo() {
  return '<a class="' + _index.NRKlogo + '" style="transform: translate3d(0,0,0)" href="http://www.nrk.no/" title="Forsiden av NRK.no">\n    <svg width="48.75px" height="18px" viewBox="0 0 152 55" style="position: relative">\n      <g stroke="none" stroke-width="0" fill="none">\n        <g fill="#f6f6f6" transform="translate(-50.000000, -50.000000)">\n          <g transform="translate(50.000000, 50.000000)">\n          <path d="M0.06,1.787 L18.646,1.787 L18.646,54.94 L0.06,54.94 L0.06,1.787 Z" data-reactid=".0.2.0.0.0.0.0"></path>\n          <path d="M53.194,1.787 L71.847,1.787 L71.847,54.94 L53.194,54.94 L53.194,1.787 Z"></path>\n          <path d="M95.233,1.787 L113.887,1.787 L113.887,54.94 L95.233,54.94 L95.233,1.787 Z" ></path>\n          <path d="M83.54,0.681 C77.723,0.681 73.017,5.431 73.017,11.289 C73.017,17.142 77.723,21.896 83.54,21.896 C89.352,21.896 94.071,17.142 94.071,11.289 C94.071,5.431 89.352,0.681 83.54,0.681"></path>\n          <path d="M137.206,30.871 C136.096,28.972 136.036,27.807 137.11,25.985 L151.893,1.787 L131.391,1.787 C131.391,1.787 119.059,21.915 117.383,24.718 C115.708,27.511 115.774,29.255 117.452,32.125 C119.129,34.996 131.391,55 131.391,55 L151.893,55 C151.893,55 137.379,31.164 137.206,30.871"></path>\n          <path d="M42.041,10.319 C41.09,5.456 36.822,1.787 31.709,1.787 L19.731,1.787 L31.756,55 L52.047,55 L42.041,10.319"></path>\n          </g>\n        </g>\n      </g>\n    </svg>\n  </a>';
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShareButtons = undefined;

var _index = __webpack_require__(2);

var getShareButtons = exports.getShareButtons = function getShareButtons() {
  return '\n  <div class="' + _index.shareButtonGroup + '">\n    <a class="nrk-button nrk-button--o ' + _index.shareButton + '" data-share="Article:Facebook" rel="noopener" target="_blank" href="https://www.facebook.com/sharer.php?u=https://www.nrk.no/min-reise-i-krigens-syria-1.13652870">\n      <span class="nrk-sr">Del p\xE5 Facebook</span>\n      <svg width="30" height="30" aria-hidden="true"><use xlink:href="#nrk-some-facebook" /></svg>\n    </a>\n    <a class="nrk-button nrk-button--o ' + _index.shareButton + '" data-share="Article:Twitter" rel="noopener" target="_blank" href="https://twitter.com/intent/tweet?url=https://www.nrk.no/min-reise-i-krigens-syria-1.13652870;text=Min reise i krigens Syria">\n      <span class="nrk-sr">Del p\xE5 Twitter</span>\n      <svg width="30" height="30" aria-hidden="true"><use xlink:href="#nrk-some-twitter" /></svg>\n    </a>\n  </div>\n  ';
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bylineSection = undefined;

var _index = __webpack_require__(2);

var _index2 = _interopRequireDefault(_index);

var _byline = __webpack_require__(67);

var _byline2 = _interopRequireDefault(_byline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shareButtons = function shareButtons() {
  return '\n  <nav class="' + _byline2.default['byline--sharebutton--container'] + '">\n    <ul class="' + _byline2.default['byline--sharebutton--group'] + '">\n      <li class="' + _byline2.default['byline--sharebutton--item'] + '">\n        <a class="' + _index2.default['to-top'] + '"  href="#">\n          <strong>G\xE5 til toppen</strong>\n          <button class="nrk-button nrk-button--o">\n            <svg width="30" height="30" aria-hidden="true">\n              <use xlink:href="#nrk-chevron-up" />\n            </svg>\n          </button>\n        </a>\n      </li>\n      <li class="' + _byline2.default['byline--sharebutton--item'] + '">\n        <a class="" data-share="Article:Facebook" rel="noopener" target="_blank" href="https://www.facebook.com/sharer.php?u=https://www.nrk.no/min-reise-i-krigens-syria-1.13652870">\n          Del p\xE5 Facebook\n          <button class="nrk-button nrk-button--o">\n            <svg width="30" height="30" aria-hidden="true">\n              <use xlink:href="#nrk-some-facebook" />\n            </svg>\n          </button>\n        </a>\n      </li>\n      <li class="' + _byline2.default['byline--sharebutton--item'] + '">\n        <a class="" data-share="Article:Twitter" rel="noopener" target="_blank" href="https://twitter.com/intent/tweet?url=https://www.nrk.no/min-reise-i-krigens-syria-1.13652870;text=Min reise i krigens Syria">\n          Del p\xE5 Twitter\n          <button class="nrk-button nrk-button--o">\n            <svg width="30" height="30" aria-hidden="true">\n              <use xlink:href="#nrk-some-twitter" />\n            </svg>\n          </button>\n        </a>\n      </li>\n    </ul>\n  </nav>\n';
};

var seeMore = function seeMore() {
  return '\n    <div class="' + _byline2.default['seemore--block'] + '">\n      <h2 class="' + _byline2.default['seemore--heading'] + '">L\xE6r og forst\xE5 mer om Syria</h2>\n      <a class="' + _byline2.default['seemore--heading-link'] + '" href="https://www.nrk.no/emne/syria-1.6931818">\n        <span>Alt om borgerkrigen i Syria</span>\n        <svg width="30" height="30" aria-hidden="true">\n          <use xlink:href="#nrk-arrow-right-long" aria-hidden="true" />\n        </svg>\n      </a>\n      <div class="' + _byline2.default['seemore--link--list--wrapper'] + '">\n        <ul class="' + _byline2.default['seemore--link--list'] + '">\n          <li class="' + _byline2.default['seemore--link--item'] + '">\n            <div>\n              <a href="https://www.nrk.no/video/PS*293556" alt="Urik forklarer: Syria (3 min)">\n                <div class="' + _byline2.default['seemore--link--image'] + '">\n                  <img id="VTV9_ybKJ0cy6a9QCN8u_g" sizes="100vw" srcset="https://gfx.nrk.no/VTV9_ybKJ0cy6a9QCN8u_gDtrzfLDePbMQOgvUGjyqXA 80w, https://gfx.nrk.no/VTV9_ybKJ0cy6a9QCN8u_giH7ylL63VJYQOgvUGjyqXA 160w, https://gfx.nrk.no/VTV9_ybKJ0cy6a9QCN8u_g2EMRXwlpXNoQOgvUGjyqXA 350w" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="I snart seks \xE5r har de pr\xF8vd \xE5 styrte Bashar al-Assad, men han biter seg fast til makta. Hvordan ligger presidenten i Syria an n\xE5? Urix forklarer!" title="">\n                  <svg width="30" height="30" aria-hidden="true"><use xlink:href="#nrk-media-play" /></svg></div>\n                <h3>Urix forklarer: Syria (3 min)</h3>\n              </a>\n              <p>\n                I snart seks \xE5r har de pr\xF8vd \xE5 styrte Bashar al-Assad, men han biter seg fast til makta. Hvordan ligger presidenten i Syria an n\xE5? Urix forklarer!\n              </p>\n            </div>\n          </li>\n\n          <li class="' + _byline2.default['seemore--link--item'] + '">\n            <div>\n              <a href="https://tv.nrk.no/program/mddp22001616/vaare-allierte" alt="">\n                <div class="' + _byline2.default['seemore--link--image'] + '">\n                  <img src="https://gfx.nrk.no/NIK7DSVPE8AJNYzHbf4kPgPodgvgOT88_VU_APzA87KA"\n                  alt="" >\n                  <svg width="30" height="30" aria-hidden="true"><use xlink:href="#nrk-media-play" /></svg>\n                </div>\n                <h3>V\xE5re allierte (1 time)</h3>\n              </a>\n              <p>\n                Norsk dokumentar. Norge har sendt ut soldater for \xE5 delta i krigen mot IS i Irak og Syria.\n              </p>\n            </div>\n          </li>\n        </ul>\n      </div>\n    </div>\n  ';
};

var byline = function byline() {
  return '\n    <div class="' + _byline2.default['byline--block'] + '">\n      <ul class="' + _byline2.default['byline--credit--list'] + '">\n\n        <li class="' + _byline2.default['byline--credit--list--item'] + '">\n          <h4 class="' + _byline2.default['byline--credit--list--item--role'] + '">Journalist</h4>\n          <p><a class="' + _byline2.default['byline--credit--list--item--names'] + '" href="mailto:kristin.solberg@nrk.no">Kristin Solberg</a><p>\n        </li>\n\n        <li class="' + _byline2.default['byline--credit--list--item'] + '">\n          <h4 class="' + _byline2.default['byline--credit--list--item--role'] + '">Digital historieutvikling</h4>\n          <p class="' + _byline2.default['byline--credit--list--item--names'] + '">Ragnar Aasen Rognstad, Kari Anne Gisestad Andersen og Johannes Odland</p>\n        </li>\n\n        <li class="' + _byline2.default['byline--credit--list--item'] + '">\n          <h4 class="' + _byline2.default['byline--credit--list--item--role'] + '">Nyhetsredakt\xF8r</h4>\n          <p class="' + _byline2.default['byline--credit--list--item--names'] + '">Alexandra Beverfjord</p>\n        </li>\n\n        <li class="' + _byline2.default['byline--credit--list--item'] + '">\n          <h4 class="' + _byline2.default['byline--credit--list--item--role'] + '">Ansvarlig redakt\xF8r</h4>\n          <p class="' + _byline2.default['byline--credit--list-item-names'] + '">Thor Gjermund Eriksen</p>\n        </li>\n\n        <li class="' + _byline2.default['byline--credit--list--item'] + '">\n          <h4 class="' + _byline2.default['byline--credit--list--item--role'] + '">Nettsjef</h4>\n          <p class="' + _byline2.default['byline--credit--list--item--names'] + '">Hildegunn Soldal</p>\n        </li>\n\n        <li class="' + _byline2.default['byline--credit--list--item'] + '">\n          <p style="margin-top: 40px" class="' + _byline2.default['byline--credit--list--item--names'] + '">\n            Publisert 27.08.2017\n          </p>\n        </li>\n      </ul>\n    </div>\n  ';
};

var bylineSection = exports.bylineSection = function bylineSection(id) {

  return '\n    <div\n      class="' + _index2.default.section + ' ' + _byline2.default.bylineSection + '"\n      data-background-id="' + id + '"\n      data-background-byline="true"\n    >\n      ' + shareButtons() + '\n      ' + seeMore() + '\n      ' + byline() + '\n    </div>\n  ';
};

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"align-top":"nrk-align-top","align-center":"nrk-align-center","align-left":"nrk-align-left","align-right":"nrk-align-right","align-middle":"nrk-align-middle","align-bottom":"nrk-align-bottom","mobile-align-top":"nrk-mobile-align-top","mobile-align-center":"nrk-mobile-align-center","mobile-align-left":"nrk-mobile-align-left","mobile-align-right":"nrk-mobile-align-right","mobile-align-middle":"nrk-mobile-align-middle","mobile-align-bottom":"nrk-mobile-align-bottom"};

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bylineSection":"nrk-bylineSection","byline--sharebutton--container":"nrk-byline--sharebutton--container","byline--sharebutton--group":"nrk-byline--sharebutton--group","byline--sharebutton--item":"nrk-byline--sharebutton--item","seemore--block":"nrk-seemore--block","byline--block":"nrk-byline--block","seemore--heading":"nrk-seemore--heading","seemore--heading-link":"nrk-seemore--heading-link","seemore--link--list--wrapper":"nrk-seemore--link--list--wrapper","seemore--link--list":"nrk-seemore--link--list","seemore--link--item":"nrk-seemore--link--item","seemore--link--image":"nrk-seemore--link--image","byline--credit--list":"nrk-byline--credit--list","byline--credit--list--item":"nrk-byline--credit--list--item","byline--credit--list--item--role":"nrk-byline--credit--list--item--role","byline--credit--list--item--names":"nrk-byline--credit--list--item--names"};

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"damaskus":"nrk-damaskus","dot-damaskus":"nrk-dot-damaskus","dot-damaskus-blink":"nrk-dot-damaskus-blink","blink":"nrk-blink","damaskus-to-homs":"nrk-damaskus-to-homs","path-damaskus-homs":"nrk-path-damaskus-homs","dot-homs":"nrk-dot-homs","dot-homs-blink":"nrk-dot-homs-blink","homs-to-aleppo":"nrk-homs-to-aleppo","path-homs-aleppo":"nrk-path-homs-aleppo","dot-aleppo":"nrk-dot-aleppo","dot-aleppo-blink":"nrk-dot-aleppo-blink","aleppo-to-maskanah":"nrk-aleppo-to-maskanah","path-aleppo-maskanah":"nrk-path-aleppo-maskanah","dot-maskanah":"nrk-dot-maskanah","dot-maskanah-blink":"nrk-dot-maskanah-blink","mobile-map":"nrk-mobile-map","desktop-map":"nrk-desktop-map","mapContainer":"nrk-mapContainer"};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29);
module.exports = __webpack_require__(30);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index-6db9b7.js